[
  {
    "cluster_id": "ee6ffddc-d717-4a7b-a161-3d1bdc24c500",
    "title": "Ukraine Adopts State Language Law"
  },
  {
    "cluster_id": "3bbfdf4b-7f9b-4300-9c99-cecf5843d988",
    "title": "IAEA Condemns Zaporizhzhia Shelling"
  },
  {
    "cluster_id": "69dda1ad-6a94-49a1-b2c4-c261984302cc",
    "title": "Nordic Nations Pause Moderna for Youth"
  },
  {
    "cluster_id": "041cf2cd-18d4-495c-8ae7-5b69605020ea",
    "title": "Zelensky Provoked Nuclear Crisis"
  },
  {
    "cluster_id": "97ed4747-8726-498d-80cf-261756e7962a",
    "title": "EU-Ukrainian Visa Liberalisation Agreement"
  },
  {
    "cluster_id": "4a717901-15d3-4fa4-8697-e234613c348b",
    "title": "Ukrainian Language Requirement in Civil Service"
  },
  {
    "cluster_id": "fdb454eb-b6d8-4e69-94d9-d465733df395",
    "title": "Political Downplaying of COVID-19 Risk"
  },
  {
    "cluster_id": "9d6d3278-c0e4-4003-a311-bf3945445bf7",
    "title": "Graphene Oxide for Biomedical Delivery"
  },
  {
    "cluster_id": "01d5ac9b-578e-460b-921d-2d1cc5ecad34",
    "title": "Dutch Referendum Rejects EU\u2013Ukraine Agreement"
  },
  {
    "cluster_id": "bf711cc9-463c-4a50-a300-d24703735ee6",
    "title": "Donbas War as Intrastate Conflict"
  },
  {
    "cluster_id": "148cbdc2-efc0-4f16-b29a-724816c7ee5d",
    "title": "CAL.20C Designated; Reduced Antibody Susceptibility"
  },
  {
    "cluster_id": "e285d3b2-02ce-4dd4-ad86-ac99b2199a66",
    "title": "US and NYC Excess Deaths 2020"
  },
  {
    "cluster_id": "84a0d215-8113-4569-a05e-d15e5c91d360",
    "title": "Crimea Referendum to Join Russia"
  },
  {
    "cluster_id": "1502dc4e-242e-4ce0-baf9-c0d4847d8993",
    "title": "Kyiv Torchlit Nationalist Marches for Bandera"
  },
  {
    "cluster_id": "114c895c-17f1-417b-8a4e-f626b06562d8",
    "title": "2017 Education Law: Language of Instruction"
  },
  {
    "cluster_id": "bd06a127-0f18-48fa-b6d0-ff607d111775",
    "title": "Contested claim: HPV vaccine risk"
  },
  {
    "cluster_id": "21f0a219-a107-4e6e-aa28-e010ad5aec66",
    "title": "Putin Orders Nuclear Forces on Alert"
  },
  {
    "cluster_id": "d44024e8-81f4-4d88-982c-a023f24b58cd",
    "title": "Debate on Regional Language Law Repeal"
  },
  {
    "cluster_id": "77e0e128-878a-417f-8723-91873f114032",
    "title": "Paramilitary and Nationalist Groups in Ukraine"
  },
  {
    "cluster_id": "58d2f307-4ee3-44ad-a765-c7a292798624",
    "title": "NATO Wales Summit backs Ukraine"
  },
  {
    "cluster_id": "e17360aa-cb4e-4e41-913f-f3e853c44fd4",
    "title": "Japan Pauses Moderna Batches Over Particles"
  },
  {
    "cluster_id": "4175d453-3f8e-438a-adde-113f24ef2a95",
    "title": "EU Prolongs Russia Sanctions 2019"
  },
  {
    "cluster_id": "1eb47b4d-d60c-4050-a6b7-0d4e6f499f8e",
    "title": "CDC/ACIP Recommends Pfizer for 5\u201311"
  },
  {
    "cluster_id": "d101520b-7082-47e3-b848-813e8165e6a9",
    "title": "Dnipro Renaming Under Decommunization"
  },
  {
    "cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed",
    "title": "CDC Recommends Public Cloth Face Coverings"
  },
  {
    "cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
    "title": "Contested COVID-19 Survival Claims"
  },
  {
    "cluster_id": "dbe1780e-f93d-4eae-8780-d2a73e00ae56",
    "title": "AstraZeneca COVID-19 Trial Pause"
  },
  {
    "cluster_id": "2cd7a2ea-67d1-4d2a-8944-a71778dc20d7",
    "title": "Vaccine Myths: STI, Blood Effects, Immunity"
  },
  {
    "cluster_id": "38992305-30d9-47ce-bb30-bfa120506e54",
    "title": "EU Condemns Nazi and Stalinist Crimes"
  },
  {
    "cluster_id": "d2b6a98f-1634-4f3b-a41d-9b64375eff6e",
    "title": "Court bans OPFL after martial law"
  },
  {
    "cluster_id": "80ee24ce-2b7b-4d6f-9630-2bec3ade3b3e",
    "title": "EU Reports on Azov Sea Blockade"
  },
  {
    "cluster_id": "bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c",
    "title": "Contested Vaccine Genome Alteration Claims"
  },
  {
    "cluster_id": "a162a552-43bd-43b6-925a-ac7f9fbf4734",
    "title": "FDA: Pfizer Vaccine Causes Clots"
  },
  {
    "cluster_id": "bfccbfa0-4d21-4c95-88ca-a83d95def684",
    "title": "VAERS Adverse Events in Pregnancy"
  },
  {
    "cluster_id": "9d7867d5-5ab5-4b0e-9556-f3f45feb0160",
    "title": "CDC Reverses Mask Guidance for Vaccinated"
  },
  {
    "cluster_id": "735fb4c9-5d71-4b3e-b247-9bafaa632b98",
    "title": "Unvaccinated Transmit Breakthrough Infections"
  },
  {
    "cluster_id": "fd11e091-21e1-40df-916b-90aba2945065",
    "title": "Ukraine bans Russian-language music"
  },
  {
    "cluster_id": "e5a713cd-2a21-42c0-89a2-7795a4250823",
    "title": "Ukraine GDP contracts 6.8% in 2014"
  },
  {
    "cluster_id": "a38268fe-ba89-4d63-8481-63c080523a0a",
    "title": "Ukraine's shifting security partnerships"
  },
  {
    "cluster_id": "59d689c2-02ce-4e0f-83b7-9747d98bb8fb",
    "title": "Ukraine Violates Russians' Rights"
  },
  {
    "cluster_id": "46dc68c8-60bf-4c63-8f62-da2eefecf05e",
    "title": "28-Day Window for COVID Deaths"
  },
  {
    "cluster_id": "777a09d6-6401-47e3-a2d4-ee63f89442c3",
    "title": "2017 Numbeo Cost-of-Living Indices"
  },
  {
    "cluster_id": "a1f0e0be-a8bf-4895-ad2d-4f83a0d63930",
    "title": "Predicted Loss of Ukraine's Sea Control"
  },
  {
    "cluster_id": "f597184d-050f-4a51-9461-70b55cf2b05c",
    "title": "Pfizer Vaccine Prevented 90% Infections"
  },
  {
    "cluster_id": "9a26c9bd-36a9-4c64-8680-f0a2265878f1",
    "title": "Japan halts 1.6 million Moderna doses"
  },
  {
    "cluster_id": "33ed63b5-316c-47cd-80fa-2cb71259f8eb",
    "title": "COVID-19 Infection Fatality Rate ~0.68%"
  },
  {
    "cluster_id": "7c1469be-22eb-4ba2-a540-efc0b0d4e00e",
    "title": "WHO mRNA vaccine regulatory guidance evolves"
  },
  {
    "cluster_id": "3789471e-0775-4ba6-92d1-141ca5051de5",
    "title": "Ukraine Elects Zelensky President"
  },
  {
    "cluster_id": "4272dbf3-0c9a-42d8-a9a1-b2b3a349e192",
    "title": "OSCE Regional Analysis of Organ Trafficking"
  },
  {
    "cluster_id": "314e86f6-17d6-477f-8886-75643cc5dcde",
    "title": "Right Sector's Public Role in Euromaidan"
  },
  {
    "cluster_id": "6950bc54-67bb-4e8e-b8cd-afd5c7d79d00",
    "title": "Ukraine bans calling hare 'rusak'"
  },
  {
    "cluster_id": "38841999-14cb-43f3-a2d5-27d9791973f6",
    "title": "Odesa Withdraws from Ukraine"
  },
  {
    "cluster_id": "ecaaad84-7e56-4f5a-84d0-609fbf620112",
    "title": "UNICEF: Donetsk Children Sheltering Underground"
  },
  {
    "cluster_id": "4afb1f4b-4686-4338-bf49-bdd4d2091f0a",
    "title": "Vaccine Deaths and SADS Claims"
  },
  {
    "cluster_id": "36d66c66-9c93-4123-875e-3e9fbe514722",
    "title": "Early Seroprevalence Indicates Low IFR"
  },
  {
    "cluster_id": "a031766e-aaad-4e78-b0e4-bd1cf2fc1a66",
    "title": "Ukraine govt violates rights in Southeast"
  },
  {
    "cluster_id": "705d1ff1-cf3d-455b-8c22-31feaaeb943f",
    "title": "Lenders Urge Ukraine Anti-Corruption Reforms"
  },
  {
    "cluster_id": "8179c546-cd47-4baf-897a-a15a8afbb9e6",
    "title": "NATO Rebuttals to Russian Claims"
  },
  {
    "cluster_id": "335924d4-8c81-4bf0-8e93-746bc3bcb081",
    "title": "Volunteer Battalions Integrated into Ukraine's Forces"
  },
  {
    "cluster_id": "1118439e-1d54-4e33-bac7-0813c7dbb103",
    "title": "Minsk II Signing and Violations"
  },
  {
    "cluster_id": "794a59da-1667-4f55-8bfb-64bab3fe6d1a",
    "title": "Donetsk and Luhansk Evacuations to Russia"
  },
  {
    "cluster_id": "f4f13b9b-3296-4913-8eea-62ce1becaa2c",
    "title": "Moderna's Pre-Pandemic COVID Vaccines"
  },
  {
    "cluster_id": "c6f7c193-f407-447c-a10f-3ea5292ea3e8",
    "title": "US Trainers Train Ukrainians on Javelin"
  },
  {
    "cluster_id": "fd9d96be-26f0-47fc-a5ef-aa9e5e5ddf13",
    "title": "Remittance Ties Between Ukraine and Russia"
  },
  {
    "cluster_id": "6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00",
    "title": "Vaccine Breakthrough Infections and Surveillance"
  },
  {
    "cluster_id": "adcb219f-1d0a-4b1b-924d-ded66e2d2c1c",
    "title": "Ukraine Train Carrying Mines to Russia"
  },
  {
    "cluster_id": "a9a48f40-5af3-4e72-b9f7-5b25295964a4",
    "title": "Anti-Maidan Camp at Kulikovo Pole"
  },
  {
    "cluster_id": "5e83ce8b-b525-4867-8caf-5b4d780a4a6c",
    "title": "Donetsk Shelling: Both Sides Blamed"
  },
  {
    "cluster_id": "5d455dbc-1091-4f62-8c3e-fdf2d7c2080e",
    "title": "Divergent Post-Vaccination Blood Donation Guidelines"
  },
  {
    "cluster_id": "6926f592-0807-43c3-9eb1-74f903b009ff",
    "title": "Crimean Tatar Territorial Autonomy"
  },
  {
    "cluster_id": "7564aa71-23fc-4383-a2a0-0245e543e0fe",
    "title": "Flawed CDC PCR Test Rollout"
  },
  {
    "cluster_id": "3ffaa02c-962d-45fa-a9aa-01f8e41dda01",
    "title": "US Urges NATO Deploy to Ukraine"
  },
  {
    "cluster_id": "bd9462e2-36b0-48f7-92f9-c83dd2ee5550",
    "title": "Eight Antigens Overwhelm Baby's Immune System"
  },
  {
    "cluster_id": "8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0",
    "title": "Ukrainian Soldiers Unpaid for a Month"
  },
  {
    "cluster_id": "83b8e4b4-0c78-4b19-aa89-21b8a62c50fe",
    "title": "Danish Results and Booster Impact"
  },
  {
    "cluster_id": "46812bda-c4dc-4bd2-a7c0-e250a28da359",
    "title": "COVID-19 Deaths by Vaccination Status"
  },
  {
    "cluster_id": "27c83a03-3f6f-4152-a678-12dc8e5912da",
    "title": "Rabbit Hole Interview Published with Nikolaychuk"
  },
  {
    "cluster_id": "651043d1-0d9f-42ac-bcb3-c7e39b7939ec",
    "title": "Sudan cVDPV2 Outbreak Response"
  },
  {
    "cluster_id": "46ef864f-186e-4179-bb52-04fed8b2c978",
    "title": "Ukraine Public Administration Reform: Staffing Targets"
  },
  {
    "cluster_id": "6e3b5d0b-67db-4d14-8384-2b3799aec6bd",
    "title": "Donetsk and Luhansk Referendums, Russian Recognition"
  },
  {
    "cluster_id": "ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d",
    "title": "Canada's Operation UNIFIER: Ukraine Training"
  },
  {
    "cluster_id": "d3157e1e-5fca-47d3-93bf-fb77fbc5070d",
    "title": "Autism Prevalence: 1 in 88"
  },
  {
    "cluster_id": "d19dc1b6-21b1-49bc-aaf1-fb24f7c66396",
    "title": "Ukraine Dismisses Viktor Shokin"
  },
  {
    "cluster_id": "c36b66d4-db22-4344-899e-be0f938cf47b",
    "title": "Hungary Defends Zakarpattia, Threatens EU Integration"
  },
  {
    "cluster_id": "caa057e8-994e-43b8-803e-0ea0aeab7ec7",
    "title": "US Blocks Poland's MiG-29 Transfer"
  },
  {
    "cluster_id": "56a7af82-50cb-4d0f-a5ea-28ea4cda014a",
    "title": "Ukraine Formalizes Neutral Foreign Policy"
  },
  {
    "cluster_id": "8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6",
    "title": "UNICEF accuses Kyiv of Donbas aggression"
  },
  {
    "cluster_id": "1288dccd-1b4b-44a8-94be-08411cd2073d",
    "title": "US-Funded Democracy Support in Ukraine"
  },
  {
    "cluster_id": "65cd54b0-2f90-4b59-a573-5917ec27f9bb",
    "title": "Conspiracy Claim: Gates-Led Pandemic Targeting Children"
  },
  {
    "cluster_id": "df13c28d-11fd-4cdc-a0c7-5076d0c46483",
    "title": "COVID-19 Lies and Policy Failures"
  },
  {
    "cluster_id": "5fee0957-a733-4e61-bf4b-0025d615e97b",
    "title": "US $53M Non-Lethal Aid to Ukraine"
  },
  {
    "cluster_id": "4b0f28fc-31f1-4217-b54f-8f9b8bb0dd43",
    "title": "OSCE SMM Denied Access by Ukraine"
  },
  {
    "cluster_id": "90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410",
    "title": "Kyiv admits shelling civilians in Donbas"
  },
  {
    "cluster_id": "5a4fc98d-9bb2-48e0-88c4-2decb355b92d",
    "title": "India HPV Vaccine Controversy and Inquiry"
  },
  {
    "cluster_id": "1e8d5556-2c0c-4097-b606-9907a5dd2afc",
    "title": "Ukraine Without Heat, Warming Centers Open"
  },
  {
    "cluster_id": "cc95457a-219b-4008-9216-67e0ee2bc74c",
    "title": "Defender-Europe 21: Large European Exercises"
  },
  {
    "cluster_id": "342cdbac-7da2-46b3-80b3-a9b75e8fee10",
    "title": "No exemptions for vaccine contraindications"
  },
  {
    "cluster_id": "9ec9965a-96db-46e5-965a-bc307986c26d",
    "title": "Ukraine Cannot Use U.S. Weapons"
  },
  {
    "cluster_id": "217bc58f-d97f-49d7-9c91-2a55c225a54a",
    "title": "WHO Flags China's Pediatric Respiratory Surge"
  },
  {
    "cluster_id": "9f394b1e-f3b6-4528-a71b-dd2fed1c81a5",
    "title": "Open Access to VAERS Data"
  },
  {
    "cluster_id": "f81575fe-bf60-4052-8196-fa9040141b06",
    "title": "Leaders defer lethal arms to Ukraine"
  },
  {
    "cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
    "title": "Claims Crimea Is Russian Territory"
  },
  {
    "cluster_id": "cd4a5f4f-0722-49d0-a0a8-588c6f486479",
    "title": "Sanctions Relief Tied to Minsk"
  },
  {
    "cluster_id": "c545f601-c30b-46cc-a181-949b8540bd95",
    "title": "CDC Estimates 2019-20 Flu Burden"
  },
  {
    "cluster_id": "3a31c97f-6174-468b-bab1-90d8acc21560",
    "title": "Russia Spent $80B Defending the Ruble"
  },
  {
    "cluster_id": "21360818-47b1-476a-88aa-682feb18a966",
    "title": "Durable neutralizing antibodies after SARS-CoV-2 infection"
  },
  {
    "cluster_id": "7050c8c6-a172-4da4-a04e-a8f348b2d49c",
    "title": "COVID-19 EUA VAERS Reporting Rules"
  },
  {
    "cluster_id": "9419d9bb-572a-4e79-aef7-f69f5e25eaa2",
    "title": "Surges in Vaccinated Nations"
  },
  {
    "cluster_id": "1352067a-0981-4dfc-bf7b-193db2160af5",
    "title": "Rivne Molot Blast Spurs Probes"
  },
  {
    "cluster_id": "f2d1742c-c9b1-44f7-a4e6-abf20a37a569",
    "title": "OSCE Spot Report: Donetsk Shelling"
  },
  {
    "cluster_id": "c53a9c23-c3a5-4b85-9f93-40e51b50505c",
    "title": "NATO: No Combat Troops in Ukraine"
  },
  {
    "cluster_id": "ca0d7a2a-b8d2-4968-874b-aa3379e0dafa",
    "title": "Pregnancy VAERS: Neonatal Deaths Below Background"
  },
  {
    "cluster_id": "a174fdfb-5e90-4340-85c5-f1498bd04f82",
    "title": "Separatists Seize Ukrainian Equipment"
  },
  {
    "cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
    "title": "Disinformation: Child Vaccine Deaths"
  },
  {
    "cluster_id": "f5a99e33-6c8e-438b-9a1b-7d2b95dadd27",
    "title": "Limited Police Intervention, May 2 Chaos"
  },
  {
    "cluster_id": "0e36f836-fa5b-40df-8bd7-860b08ef47db",
    "title": "Arrests Over Crimean Sabotage Plots"
  },
  {
    "cluster_id": "27a5d354-dacf-469b-b094-7b2ad6fec31b",
    "title": "FDA Guidance: Cell Substrates for Vaccines"
  },
  {
    "cluster_id": "1bece78f-f648-4fbc-85c0-722698749525",
    "title": "EuroMOMO: 2021 Excess Mortality"
  },
  {
    "cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc",
    "title": "Omicron: Waning Vaccine Effectiveness"
  },
  {
    "cluster_id": "a418885e-cbb2-4205-a118-ea8172eaff33",
    "title": "German Spring 2021 Vaccine Adverse Events"
  },
  {
    "cluster_id": "729cc7ae-ca2f-4e76-9131-41ad0335ecdf",
    "title": "Imperial College COVID-19 Projections and NPIs"
  },
  {
    "cluster_id": "4ab5e1f1-d0b4-460e-98c6-70b27ad80057",
    "title": "Ukraine passes decommunization and memory laws"
  },
  {
    "cluster_id": "87e51e32-d441-41a9-8026-a751a57b0ed2",
    "title": "Ukraine Threatens War With Russia"
  },
  {
    "cluster_id": "f7dce48b-908d-410d-ae3b-0711d8dd8a49",
    "title": "Russia Bans Ukrainian Food Imports"
  },
  {
    "cluster_id": "269675ca-916b-4267-8970-bb97e2010767",
    "title": "Secondary Pneumonia Caused 1918 Deaths"
  },
  {
    "cluster_id": "9ef27775-8065-4722-bd90-8a9ae4a3c250",
    "title": "Ukraine on Modern Nazism Map"
  },
  {
    "cluster_id": "8e9141e0-2f9d-4d0a-920e-7ed046dbbcec",
    "title": "Putin Simplifies Donbas Citizenship"
  },
  {
    "cluster_id": "c21b5cff-dd9b-418d-82f4-ad5049c002d9",
    "title": "Vaccines More Harmful Than Infection"
  },
  {
    "cluster_id": "1a5017d7-a85f-401a-9c3e-9a087de588f6",
    "title": "WHO COVID-19 Excess Mortality Gaps"
  },
  {
    "cluster_id": "ae87ce9d-8fb9-4394-9afe-202f1ec14722",
    "title": "Unusually Low Flu Activity During COVID-19"
  },
  {
    "cluster_id": "a8758a01-da2e-4199-8bb4-bdf40b9dd8e6",
    "title": "Unusual GAS and Scarlet Fever Activity"
  },
  {
    "cluster_id": "f8121c44-24d3-465d-8607-2a909285d318",
    "title": "American COVID-19 vaccine killed Ukrainian serviceman."
  },
  {
    "cluster_id": "eb82caa7-6ef5-4182-a16e-ed0091be45ae",
    "title": "Lviv Dismantles Stepan Bandera Monument"
  },
  {
    "cluster_id": "80abc80a-d540-4e4d-aa41-272690066eb0",
    "title": "Planned bombing of Luhansk rail overpass"
  },
  {
    "cluster_id": "d18315fd-bf62-472b-bd6c-313e812011cc",
    "title": "COVID-19 Vaccine Administration Errors and Deviations"
  },
  {
    "cluster_id": "df8da41a-f9cc-4448-aae3-112ed4b0b247",
    "title": "NATO Madrid Summit: New Strategic Concept"
  },
  {
    "cluster_id": "b4c1b467-58b1-4e2c-a735-234cba24891c",
    "title": "Masks Do Not Stop COVID"
  },
  {
    "cluster_id": "96c115c1-f9f9-479d-9ecc-98da549128b0",
    "title": "Global Spotlight on Ukrainian Nationalists"
  },
  {
    "cluster_id": "776c4ee1-eeec-4f70-91d9-12fdaa179052",
    "title": "Moody's Downgrades Ukraine to Ca"
  },
  {
    "cluster_id": "402b3ff3-63dd-42e9-9d2c-888f81934ca4",
    "title": "Snakes as Potential Reservoir"
  },
  {
    "cluster_id": "b56f25e8-34c3-4cf5-b21e-1b0f46545150",
    "title": "Base-Rate Fallacy in Vaccinated Populations"
  },
  {
    "cluster_id": "b687420f-e058-48a2-8c4c-4bc6f35624c2",
    "title": "Zaporizhzhia Unveils Film-Characters Bench"
  },
  {
    "cluster_id": "092404d0-7d21-433f-bfca-9a5d34d17b3b",
    "title": "Oleksandr Onyshchenko Accuses Poroshenko of Corruption"
  },
  {
    "cluster_id": "8a0c21a3-b47c-4676-b965-59f7699171ec",
    "title": "Donbas Cities Face Water Shortage"
  },
  {
    "cluster_id": "aa30bf70-0cba-416d-ab58-48d58cb2a343",
    "title": "Ukrainian MP proposes mass Crimean deportation"
  },
  {
    "cluster_id": "17224e3f-1dd8-4970-a1c1-0cff20d6f438",
    "title": "Vaccines Contain Aborted Fetus Claim"
  },
  {
    "cluster_id": "7742ec5a-27ab-42d2-9779-df7d73a0cec4",
    "title": "Toxic Aluminum and Mercury in Vaccines"
  },
  {
    "cluster_id": "e8352caf-0212-486c-8732-e56619b31e7c",
    "title": "Late 2022 Non-COVID Excess Deaths"
  },
  {
    "cluster_id": "a28912c7-742b-4153-9606-e82158276aad",
    "title": "UK Yellow Card Safety Updates"
  },
  {
    "cluster_id": "0c63b123-d884-4e43-b541-3b36f23f2e96",
    "title": "Russian Ded Moroz triggers Ukraine ban"
  },
  {
    "cluster_id": "af90686d-77e8-4713-873e-8c63e5dbe370",
    "title": "Provisional EU\u2013Ukraine DCFTA Application"
  },
  {
    "cluster_id": "e5a54fcb-cbc0-4fb7-bfbf-7530efd090da",
    "title": "Early WHO Mask Guidance: Limited Use"
  },
  {
    "cluster_id": "3f98fdac-3f62-464c-bf56-dd3d2e686963",
    "title": "Local bans on Russian-language culture"
  },
  {
    "cluster_id": "cba3863d-9ffc-4647-831b-d4da84c689e3",
    "title": "Fast-Track Citizenship for Crimeans and Ukrainians"
  },
  {
    "cluster_id": "38bb4737-de3e-4b8d-b413-8281bb85ae27",
    "title": "Pfizer\u2013BioNTech Vaccine 95% Efficacy"
  },
  {
    "cluster_id": "30fdf9bb-e9b5-47e5-a899-e176ffa77eac",
    "title": "Kirovograd Residents Prefer Tsarist-Era Name"
  },
  {
    "cluster_id": "25f83819-e436-47d4-a6ab-ce489fc70293",
    "title": "Western-Led Training for Ukraine"
  },
  {
    "cluster_id": "d0b9d362-84b5-4285-90de-b70dc7fdf9db",
    "title": "Racial/Ethnic Differences in Vaccine Uptake"
  },
  {
    "cluster_id": "640f326d-efe1-4293-bfc4-0c4c7b9185f3",
    "title": "Steinmeier Formula Controversy in Ukraine"
  },
  {
    "cluster_id": "1282bd1b-6e16-4c06-9f2c-9c9344b54fd8",
    "title": "Congressional Restrictions on Extremist-Linked Aid"
  },
  {
    "cluster_id": "976b0673-ef25-484d-9be8-afb6c791a214",
    "title": "Venice Commission flags minority-language gaps"
  },
  {
    "cluster_id": "ce0417d2-5817-45d3-a01f-447b8d6d19ff",
    "title": "Long-Lasting COVID-19 Immunity"
  },
  {
    "cluster_id": "30d502a9-a0ce-4646-9e1c-b03b47f8dd5b",
    "title": "Ukraine Adopts Red Poppy Remembrance"
  },
  {
    "cluster_id": "5a8284e8-a150-41dc-8ee7-edbc3da33af5",
    "title": "Minsk Abandoned, Donbas Occupation Planned"
  },
  {
    "cluster_id": "3775dc56-2d8e-428a-9c60-ba993c0f4ba7",
    "title": "NED Grants in Ukraine During Euromaidan"
  },
  {
    "cluster_id": "222d1da7-5333-49e1-a4ec-9ca508fd278c",
    "title": "Natural Immunity 13x Stronger Than Vaccination"
  },
  {
    "cluster_id": "5288ae46-832e-4436-95ed-05106d5e8d73",
    "title": "COVID-19 vaccines Hospitalisations"
  },
  {
    "cluster_id": "fd853489-07e0-4489-8d20-abb8f80a4213",
    "title": "COVID-19 Deaths by Vaccination Status"
  },
  {
    "cluster_id": "c160d7d3-0687-4ba7-86ad-32e9cddeaf56",
    "title": "VAERS Reports Drive Public Attention"
  },
  {
    "cluster_id": "8602d3ff-0dd5-4315-8d50-17cd0d22f5ac",
    "title": "CDC Establishes Incident Management, Monitors Outbreak"
  },
  {
    "cluster_id": "fbc30c99-229d-49c2-8ecb-ce9a62431408",
    "title": "Pfizer vaccine linked to turbo cancer"
  },
  {
    "cluster_id": "2105abe4-014b-48d8-a8a2-6e113ac81f52",
    "title": "Higher Vaccination Linked to Excess Mortality"
  },
  {
    "cluster_id": "a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0",
    "title": "Court Rules mRNA Vaccines Aren't Vaccines"
  },
  {
    "cluster_id": "6d7e8844-23f0-4293-9d61-855d04598239",
    "title": "Anti-Maidan Pro-Russian Protests in Ukraine"
  },
  {
    "cluster_id": "5edd87a6-3d98-4e7d-9e60-b94920fc071d",
    "title": "Ukraine Displays Captured Russian Paratroopers"
  },
  {
    "cluster_id": "12c3a33b-fd70-46a3-a74c-86b922244369",
    "title": "UN Demands Ukraine Recognize Occupied Territories"
  },
  {
    "cluster_id": "344dd5f7-3435-46c3-9f5a-4bd9bd357bed",
    "title": "Language Bill Triggers Parliamentary Clashes"
  },
  {
    "cluster_id": "0543c671-bbcf-49ea-a462-e4ab061c75a0",
    "title": "UN Confirms Russian Involvement in Odessa"
  },
  {
    "cluster_id": "011aa847-d3e3-4d34-bf5e-378f39ba8a3c",
    "title": "CDC Guidance: Vaccinated Mask Optional"
  },
  {
    "cluster_id": "b6224aea-5841-4609-ba8b-ccc207ec597f",
    "title": "IMF approves $17.5B Ukraine bailout"
  },
  {
    "cluster_id": "0bc010ee-21eb-4a56-88df-bd3b94b15999",
    "title": "Zelensky Proposes Direct Talks with Russia"
  },
  {
    "cluster_id": "6c947694-8652-4e58-b4d1-40be43d3a77b",
    "title": "Masks Stop Flu, Flu Labeled COVID-19"
  },
  {
    "cluster_id": "da1326c3-fa76-400d-b44c-881f6493a085",
    "title": "Vaccine Death Claims"
  },
  {
    "cluster_id": "446a7c12-73f1-49f5-944a-5a0119281e12",
    "title": "Exhumation of Sloviansk Mass Grave"
  },
  {
    "cluster_id": "32bd49c6-94f8-4c4c-b45a-7a8a4f01eb08",
    "title": "Pediatric Vaccine Trials and Authorizations"
  },
  {
    "cluster_id": "abb6468b-1949-4a51-9adf-d3e014a3003b",
    "title": "Japan Approves First saRNA COVID Vaccine"
  },
  {
    "cluster_id": "7301fbf5-a19c-4247-aac6-e3d55981cf96",
    "title": "UN OHCHR Detentions in Eastern Ukraine"
  },
  {
    "cluster_id": "12efff4b-e0b1-447e-aeb7-828004c5cfde",
    "title": "Planned pandemic and contamination claim"
  },
  {
    "cluster_id": "5a4d2a32-bac0-4370-915e-eb0f49138ccd",
    "title": "OSCE Monitors Ukraine Minority Rights"
  },
  {
    "cluster_id": "252647f3-b2d0-4fb9-8a73-8d20e5a61e96",
    "title": "Pandemrix Narcolepsy Risk Investigations"
  },
  {
    "cluster_id": "edcb6d77-94bd-47fa-ac30-bd310a6e83e6",
    "title": "Vaccines Do Not Overload Infants' Immunity"
  },
  {
    "cluster_id": "565acc40-efdc-4957-85fb-8602f0587aa9",
    "title": "Flu vaccine exists; flu persists"
  },
  {
    "cluster_id": "ce4675a2-eebc-4f4f-bcc2-33cbe65f4024",
    "title": "ICJ: Kosovo Declaration Lawful"
  },
  {
    "cluster_id": "6985338a-f2b9-47d5-b9ae-563c0a87748d",
    "title": "False claims about vaccine ingredients"
  },
  {
    "cluster_id": "bb4b93c0-732a-485f-b2ae-0ba6433c139f",
    "title": "Amnesty reports civil-society artillery casualties, 2014"
  },
  {
    "cluster_id": "b05a0ac1-6107-4a11-aa69-1115d8b00d86",
    "title": "Ukraine Reforms vs Minsk II"
  },
  {
    "cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b",
    "title": "Rare myocarditis after mRNA COVID-19 vaccines"
  },
  {
    "cluster_id": "980136c6-363f-4cda-bc50-cca417518993",
    "title": "May 2 Events Caused Odessa Suicide"
  },
  {
    "cluster_id": "6d0ecf89-9eab-4b55-8c05-ab0885982adf",
    "title": "Ukraine Fails to Investigate Far-Right Violence"
  },
  {
    "cluster_id": "9964a330-c7c3-4cd3-bf33-0b48084f4337",
    "title": "Abuses by both sides in Ukraine"
  },
  {
    "cluster_id": "b08cba5b-cde3-4318-9ea2-b4cf4efed9c3",
    "title": "Vatnik Renounces Ukrainian Citizenship"
  },
  {
    "cluster_id": "59906f79-e6e8-4390-a382-ef5bd2f7fff2",
    "title": "Far-Right Symbols in Euromaidan"
  },
  {
    "cluster_id": "d9f5972a-ff26-4242-938a-7c9615591c15",
    "title": "China backs Russia in Crimea"
  },
  {
    "cluster_id": "40467831-07ba-4c26-8f13-029707ea2660",
    "title": "Measles Rise Linked to MMR Decline"
  },
  {
    "cluster_id": "d17d8e48-7844-4b9c-9bc0-e31d87299aef",
    "title": "COVID-19 Deaths Overcounted"
  },
  {
    "cluster_id": "55a53a4b-b30c-483d-9f7b-8c999d5c2f62",
    "title": "Study Links Vaccination Rates to Deaths"
  },
  {
    "cluster_id": "5677f10d-93dc-4b72-b95a-8bc4291ec487",
    "title": "Claims of Zero Deaths During Pandemic"
  },
  {
    "cluster_id": "1eec17fb-077b-4de8-a9a2-2c4b4ccfcec3",
    "title": "COVID vaccines contain no animal ingredients"
  },
  {
    "cluster_id": "391672fd-aef8-4243-932a-77e726662902",
    "title": "Volunteer Battalion Leaders Declare Assets"
  },
  {
    "cluster_id": "c298484d-a7d5-4e80-ac66-217221dc6d85",
    "title": "Kolomoiskii Enforcers Beat Soldiers' Mothers"
  },
  {
    "cluster_id": "4f0e7f6a-d847-4db7-a78d-684ba6b33ce7",
    "title": "Violations and Movements Near Contact Line"
  },
  {
    "cluster_id": "6e881517-8e9f-47bf-854c-c29084f1a26d",
    "title": "Vaccines Prevented Approximately 140,000 U.S. Deaths"
  },
  {
    "cluster_id": "708bf439-5986-4d45-983d-18029794b540",
    "title": "Debate on Universalizing Babi Yar Memorial"
  },
  {
    "cluster_id": "028ee870-e258-43cd-99d3-f13e457b70d7",
    "title": "Budapest Memorandum Nuclear Disarmament"
  },
  {
    "cluster_id": "97f84153-8f49-432f-a8f7-a4e57fe7f769",
    "title": "COVID-19 Vaccine Myths and Conspiracies"
  },
  {
    "cluster_id": "86e16ba9-dba8-4cea-a0d4-df8a8a69d565",
    "title": "Obama accuses Ukrainian authorities of genocide"
  },
  {
    "cluster_id": "ab1842ba-5e92-4ba8-ab55-1241a116a859",
    "title": "No FDA-Approved COVID Vaccines in U.S."
  },
  {
    "cluster_id": "45339238-abb3-494b-a7ba-d3cde2ab18d9",
    "title": "Kyiv Abandoned and Deceived Moscow"
  },
  {
    "cluster_id": "781b12f4-b179-4668-8b0e-ea2f1da17240",
    "title": "Minsk II: Donetsk and Luhansk Signatories"
  },
  {
    "cluster_id": "ecc32ba8-bd1c-43c6-8192-e0502c1f14b7",
    "title": "Ukraine Shells Donetsk and OSCE"
  },
  {
    "cluster_id": "b5f5c5e5-6c1a-4551-a786-04806a60e9b1",
    "title": "Ukraine's Measles Outbreaks and Vaccine Hesitancy"
  },
  {
    "cluster_id": "67bef4c5-afcc-4a65-9538-ce302f965385",
    "title": "Misinformation: Vaccines and AIDS"
  },
  {
    "cluster_id": "58160b77-275a-49fd-b4ad-b9a4e0aa40ef",
    "title": "Removal of Thimerosal from Childhood Vaccines"
  },
  {
    "cluster_id": "c09c5abe-d2d4-4b78-b32f-49fbbd5778a7",
    "title": "COVID-19 Vaccination-Related Musculoskeletal Inflammation Case Series"
  },
  {
    "cluster_id": "d2f70202-2b46-45a9-9905-a0ccfee90661",
    "title": "Minsk II Ceasefire: Frontlines Partially Implemented"
  },
  {
    "cluster_id": "357af95d-b02c-4002-bfc2-fdd9ff848257",
    "title": "Pro-Ukraine Demonstrators Outnumber Pro-Russian Activists"
  },
  {
    "cluster_id": "ec68f63c-4291-4d49-8068-2a2cf1250591",
    "title": "Vaccinated Donors Eligible to Donate"
  },
  {
    "cluster_id": "2420d848-9bcf-484f-a278-33ad97459cda",
    "title": "Public Release of VAERS Death Reports"
  },
  {
    "cluster_id": "7b19db75-3bd2-47e5-a306-0a2f241eda0e",
    "title": "Fauci on ADE in early vaccines"
  },
  {
    "cluster_id": "41b103ed-acbb-4350-80df-1fd2deb0346c",
    "title": "Fetal cell lines in COVID vaccines"
  },
  {
    "cluster_id": "4eb34d6f-2849-4a6f-9012-a59681fdeeff",
    "title": "Dogs gnaw on fallen Ukrainian soldier"
  },
  {
    "cluster_id": "61784f3e-1c50-4b37-9db4-0fd1ec458127",
    "title": "Donbas Mines Kill Soldiers and Children"
  },
  {
    "cluster_id": "4a315717-0c5d-48f0-b376-1a12c3498c7c",
    "title": "Danish Adolescent Myopericarditis After Pfizer"
  },
  {
    "cluster_id": "1ff366e5-31ba-464c-8544-3d84f99a75c6",
    "title": "Ukraine Bans Three Pro-Russian TV Channels"
  },
  {
    "cluster_id": "5d276603-9c3a-417d-bd11-e8b613249dd5",
    "title": "COVID Vaccine Safety Misinformation"
  },
  {
    "cluster_id": "61d63dd9-934f-4808-b6ab-ed734f2474b3",
    "title": "December VAERS: 3,916 Reports, 13 Deaths"
  },
  {
    "cluster_id": "48eb1f9d-0125-4436-9ad0-db6bbdc685bf",
    "title": "Children's Pre-activated Innate Airway Antiviral Responses"
  },
  {
    "cluster_id": "ce5f39de-c868-4feb-8d91-20b21e8b8ded",
    "title": "Ukraine bans entry for Russian men"
  },
  {
    "cluster_id": "75a5f06e-b690-4ab1-b016-65c86c1b4940",
    "title": "Seroprevalence Reveals Hidden Infections"
  },
  {
    "cluster_id": "4f2789db-45a0-4f05-86be-a25e7794e0d7",
    "title": "Lviv Denies Dismantling Monument"
  },
  {
    "cluster_id": "00c920c5-f4fa-404a-9d1e-12f311ed5e11",
    "title": "Omicron protection wanes after 3 months"
  },
  {
    "cluster_id": "dec098ce-5baa-400b-a766-6543ab0afe00",
    "title": "Vaccines Blamed for Global Crisis"
  },
  {
    "cluster_id": "5062ec52-04a9-40ad-82e8-e7b18ce41e9a",
    "title": "Omicron: Global Spread and Surging Waves"
  },
  {
    "cluster_id": "d2698d5d-a9c7-4753-8264-b469e84de09c",
    "title": "Oligarch-Funded Volunteer Regiments Under Ministries"
  },
  {
    "cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee",
    "title": "Delta-Driven Vaccinated Mask Guidance Revisions"
  },
  {
    "cluster_id": "67077d98-dd63-4eb1-bfae-12ca20649195",
    "title": "CDC Admits Contaminated Polio Vaccines"
  },
  {
    "cluster_id": "2f8d9d1d-f145-459e-90bd-ebf833c6fe60",
    "title": "Alleged Self-Spreading saRNA Vaccine Without Consent"
  },
  {
    "cluster_id": "0c639465-7159-40b2-869b-06840b83505a",
    "title": "Obama backs Poroshenko in 2014"
  },
  {
    "cluster_id": "66b7068d-b746-42ae-9f41-d88ed9a887f4",
    "title": "Azov Linked to Neo-Nazi Groups"
  },
  {
    "cluster_id": "2f956586-babe-4398-aff8-0787b3e3a21b",
    "title": "Zelensky as Fictional President"
  },
  {
    "cluster_id": "cfd4b520-a181-4698-846e-ff280ba11189",
    "title": "Shortages Drive Mixed Uniforms in Ukraine"
  },
  {
    "cluster_id": "bbf49577-7eda-4f96-83ed-753d3b9cc708",
    "title": "Vaccination Could Prevent One-Quarter Deaths"
  },
  {
    "cluster_id": "8351f868-a72b-47b0-8a87-867df6862124",
    "title": "MLRS shelling near Sartana"
  },
  {
    "cluster_id": "c4564515-d53f-4e98-999a-f38427deb89e",
    "title": "Kyiv Renames 95 Streets"
  },
  {
    "cluster_id": "655e754e-33e7-4bf2-aabe-264f18d499a4",
    "title": "Ukraine allegedly tops rights violations"
  },
  {
    "cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
    "title": "False Claims of COVID Vaccine Harm"
  },
  {
    "cluster_id": "a764eb56-b1bb-470b-bb17-4bd9f5369b4b",
    "title": "U.S. to Fight for Kerch Strait"
  },
  {
    "cluster_id": "df5b4e50-7d1b-4d7e-ae01-046530298250",
    "title": "Natural Immunity, Misattributed COVID Deaths"
  },
  {
    "cluster_id": "14b07b58-6d89-4f8a-8ddc-8c0a902ee333",
    "title": "Donbas 2014: Aid Access Crisis"
  },
  {
    "cluster_id": "e0e899a0-65d4-45b2-b3be-ff8320d1837a",
    "title": "Vaccine Hesitancy: Global Health Threat"
  },
  {
    "cluster_id": "8140cb8c-a254-4493-b790-598f4ef3676f",
    "title": "Masks, Vaccines, Handwashing Suppress Immunity"
  },
  {
    "cluster_id": "2f7d7b19-3996-4824-8b2e-60b30c5d543d",
    "title": "Donbas reintegration law ends Minsk framework"
  },
  {
    "cluster_id": "0bc36847-debb-43d3-bab5-e1a736194eac",
    "title": "Five Years of Ukraine-EU Disaster"
  },
  {
    "cluster_id": "ce07721b-5347-4d52-81aa-7a7c68338485",
    "title": "Claims: mRNA vaccines harm children"
  },
  {
    "cluster_id": "06b8ffc7-c987-44a2-a2cb-8721e54e7da6",
    "title": "Crimeans Return Home After Annexation"
  },
  {
    "cluster_id": "d5b4afb5-46e3-4fab-9511-72f4984164cb",
    "title": "Launch of Kyiv Patrol Police Reform"
  },
  {
    "cluster_id": "dd63046f-83c4-4d5e-867a-2f14376d2ce2",
    "title": "OSCE SMM Patrol Attack in Yasynuvata"
  },
  {
    "cluster_id": "f10a7215-4011-4959-9b86-e9f3848b78fb",
    "title": "Suppression of Russian in Ukraine"
  },
  {
    "cluster_id": "5f8dbb60-ef34-416a-9285-ed818708d337",
    "title": "Asymptomatic COVID-19 on Diamond Princess"
  },
  {
    "cluster_id": "87ccb180-4860-4e8d-af6f-a3acda89b6bf",
    "title": "Summary Killings in Eastern Ukraine"
  },
  {
    "cluster_id": "50450ae6-8d18-4a4d-9adf-9937e9748bba",
    "title": "ITU Bulletin: Crimea Numbering Codes"
  },
  {
    "cluster_id": "f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab",
    "title": "Misinformation: Vaccines Cause Infant Deaths"
  },
  {
    "cluster_id": "635833cc-6550-4cab-b41a-e51cbfca373a",
    "title": "Alleged Spike Protein Damage Claim"
  },
  {
    "cluster_id": "55b3fec7-2c59-48a7-b144-2bc454de6078",
    "title": "Mariupol: Heavy fighting, control shifts"
  },
  {
    "cluster_id": "e6294e0b-891d-4ba7-af93-8aa8ed47eeab",
    "title": "Euromaidan: Heavenly Hundred and Makeshift Morgues"
  },
  {
    "cluster_id": "8c441ed7-3996-46c2-abdc-191f54206cf6",
    "title": "World Mortality Dataset: Cross-Country Estimates Published"
  },
  {
    "cluster_id": "228f2026-3094-45be-9c29-b363d30f00b6",
    "title": "Delphi-Based Long COVID Definition by WHO"
  },
  {
    "cluster_id": "8b0583af-b0d6-4ff0-b992-807e026b5368",
    "title": "Euromaidan Protests Escalate; Kyiv Government Change"
  },
  {
    "cluster_id": "f679dcc1-fbec-4813-8cbd-bf97a313606d",
    "title": "Claims of Vaccines Causing Autism"
  },
  {
    "cluster_id": "8ef9df10-1de8-4f15-a1e9-2d90b8ed31e8",
    "title": "Atlantic Resolve: NATO Reassurance"
  },
  {
    "cluster_id": "93fb31b6-e8df-4e78-9be7-574ea4c2f86b",
    "title": "SARS-CoV-2 Spike and Snake Neurotoxin Similarity"
  },
  {
    "cluster_id": "dde390b5-1a05-447f-86aa-a25992be6bfd",
    "title": "Most Deaths From Other Illnesses"
  },
  {
    "cluster_id": "4b3edb14-747e-4c77-8e76-8b7c1d8c4155",
    "title": "Mass Russian Passports in Crimea"
  },
  {
    "cluster_id": "b32443a3-fa40-4637-9b55-e58ec8393ffe",
    "title": "WHO's Early Cautious Mask Guidance"
  },
  {
    "cluster_id": "0807cdb8-6ddb-4585-ad14-90359bbf1c37",
    "title": "Russia condemns Kyiv reintegration law"
  },
  {
    "cluster_id": "ebaf2aaf-acc5-40a1-b99f-157e33f793e4",
    "title": "Waning Two-Dose Protection Spurs Israel Boosters"
  },
  {
    "cluster_id": "20dbcfed-6463-4ba7-98e9-93b565b2719b",
    "title": "CDC Updates Vaccine Terminology 2021"
  },
  {
    "cluster_id": "621f1c2a-981d-47da-bf43-de2d73f4a594",
    "title": "Russian Media: American Mercenaries in Ukraine"
  },
  {
    "cluster_id": "2e75fb89-d4ec-437b-bb34-741837209437",
    "title": "Skripal Poisoning and Diplomat Expulsions"
  },
  {
    "cluster_id": "a49c6bf6-4bdf-4111-8400-ae8603304250",
    "title": "Fire and Shelling at Zaporizhzhia Site"
  },
  {
    "cluster_id": "2947fe08-3f19-4a83-826c-8d5e7d1e3368",
    "title": "Kyiv Renames Vatutin Avenue to Shukhevych"
  },
  {
    "cluster_id": "56c30444-c8fe-46f9-af30-b0924f71761d",
    "title": "May 8 Remembrance and Reconciliation"
  },
  {
    "cluster_id": "4061c2fc-ed9c-4f22-92dd-291aa2df6a90",
    "title": "U.S.-Led Ukrainian Training"
  },
  {
    "cluster_id": "a3cec669-c5d7-49cf-9b41-ed9298b7642a",
    "title": "Zaporizhzhia NPP Shelled by Ukraine"
  },
  {
    "cluster_id": "86cdbb00-bf89-4bf4-b9b5-585743288546",
    "title": "Sen. Johnson Highlights Raw VAERS Counts"
  },
  {
    "cluster_id": "bfcb4fd5-03ad-4398-a7b4-f52617946935",
    "title": "Sharp GDP Contractions, 2014\u20132015"
  },
  {
    "cluster_id": "d140ee70-1c2e-44c9-b163-573b275b6b17",
    "title": "Transient lymphocyte decreases in vaccine trials"
  },
  {
    "cluster_id": "c721dd3f-abaa-46f4-b0b3-0998badfc28c",
    "title": "Ukraine funds radical nationalist groups"
  },
  {
    "cluster_id": "a83597bc-3768-4ee3-a01e-2fac92f73ab7",
    "title": "Ukraine moratorium on Russian-held debt"
  },
  {
    "cluster_id": "d7ed508d-e43b-4e54-a0c0-6807c3338527",
    "title": "OSCE Monitor Wounded; Review of Operations"
  },
  {
    "cluster_id": "3c66cbc4-f759-4da9-9813-b36b4c322970",
    "title": "Civilian Casualties from Donetsk Shelling"
  },
  {
    "cluster_id": "7e081e03-60f5-4239-923e-30df23ea9e14",
    "title": "Asymptomatic Transmission of COVID-19"
  },
  {
    "cluster_id": "acca2114-d8e0-468a-8116-8a8e6ac23e1b",
    "title": "EU Ties Ukraine Aid to Migrants"
  },
  {
    "cluster_id": "ecd748e3-d837-4992-8ea5-50edc6e9e5f6",
    "title": "EU aid to Ukraine since 2014"
  },
  {
    "cluster_id": "a1c74ee2-0da5-4362-bf0c-2f7caddeae61",
    "title": "Ukraine Rebels Blame Donetsk Shelling"
  },
  {
    "cluster_id": "94d152a0-b275-42d2-af1e-de4ffe6f8a22",
    "title": "US B-52s in European Operations"
  },
  {
    "cluster_id": "db2b5d72-303d-4743-8188-e92d23a86e05",
    "title": "Johnson's Early Herd Immunity Messaging"
  },
  {
    "cluster_id": "909c2544-65ad-4eae-8bbb-f43d077750aa",
    "title": "SARS-CoV-2 stability in aerosols and surfaces"
  },
  {
    "cluster_id": "eb8c09b3-c22e-4c14-a55e-41e86bc54809",
    "title": "Mejlis Calls for 2014 Referendum Boycott"
  },
  {
    "cluster_id": "44317cdd-77fe-42f4-b1db-9819636d2f58",
    "title": "Ukraine to Poland Migration Surge"
  },
  {
    "cluster_id": "1f539237-1caf-4525-9adc-af33bb645e44",
    "title": "Amnesty Reports Abuses by Volunteer Battalions"
  },
  {
    "cluster_id": "997b033a-0811-49fe-bc36-8ee742156833",
    "title": "Soviet Mass Renaming of Crimean Toponyms"
  },
  {
    "cluster_id": "30f8d995-4c8b-4d55-9cc0-91236f828d24",
    "title": "Ukraine shifts to Europe Day"
  },
  {
    "cluster_id": "4f4a8dcc-ad59-4dfb-b222-e025fb0c418e",
    "title": "Ukrainian Forces Lead Ceasefire Violations"
  },
  {
    "cluster_id": "df895ffb-5333-4b2a-9ce5-f1108a894c34",
    "title": "No Excess Mortality; Ineffective COVID Measures"
  },
  {
    "cluster_id": "128ade3d-bda4-4b71-b956-463eb584089c",
    "title": "Thimerosal Reduction in Childhood Vaccines"
  },
  {
    "cluster_id": "0b719ed0-60f8-42bb-9426-ff2a477557b7",
    "title": "EP questions ISIS in disputed territories"
  },
  {
    "cluster_id": "c91f4478-001c-4706-a4cf-7da14de01daa",
    "title": "Swiss Guidance on COVID-19 PCR/NAT Testing"
  },
  {
    "cluster_id": "0634cfd7-f7f7-48cb-bb92-7dc813e3271c",
    "title": "Ukraine Can't Regain Crimea and Donbas"
  },
  {
    "cluster_id": "af40ab83-4c48-4ac1-af3a-242491a35af4",
    "title": "Ukraine Adopts Lustration for Officials"
  },
  {
    "cluster_id": "baac2920-a8d6-4667-acc5-460b63889a7e",
    "title": "Vaccine Cell Lines: WI-38, MRC-5"
  },
  {
    "cluster_id": "21533f1c-ae42-4579-91e2-803b34beb003",
    "title": "Lviv's Hill of Glory Debates"
  },
  {
    "cluster_id": "2d060fd1-76c9-470d-941c-4c8d800b380a",
    "title": "Non-COVID Deaths Remain High"
  },
  {
    "cluster_id": "4d62f2bf-06ba-4e7d-b665-78a194b70483",
    "title": "IDP Housing Centers Expanded in Lviv"
  },
  {
    "cluster_id": "83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2",
    "title": "U.S. Condemns NATO in Black Sea"
  },
  {
    "cluster_id": "2ea5d498-58e2-44a4-a51a-95bda7047686",
    "title": "Pregnancy Vaccination: No Benefit, Higher Readmissions"
  },
  {
    "cluster_id": "26b806a5-30f6-4312-bfd4-c6984e3b4d30",
    "title": "FDA Briefing: Moderna mRNA-1273 Safety"
  },
  {
    "cluster_id": "83412f4d-d0e2-456a-853f-c0ab5d6c2ff1",
    "title": "Birth Control: Greater Clot Risk"
  },
  {
    "cluster_id": "6695efed-b1b5-4469-a01b-a370dfb9c522",
    "title": "Masks and Lockdowns Do Not Work"
  },
  {
    "cluster_id": "e30d449c-eb81-4d62-9149-9437a1a2c593",
    "title": "Urgent IAEA Mission to Zaporizhzhia"
  },
  {
    "cluster_id": "3d43abac-8178-4ce6-a910-10e135a5266f",
    "title": "Ukrainian Language Mandate for Public Sector"
  },
  {
    "cluster_id": "086034d9-cc70-4cb5-b461-137099358741",
    "title": "Disrupted Voting in Crimea and Donbas"
  },
  {
    "cluster_id": "c9ef551f-21d7-4986-8f7f-14a67206ac95",
    "title": "Lancet study: Vaccination saves lives"
  },
  {
    "cluster_id": "d73adbe1-7dcc-4345-a67c-e7d102fbc24d",
    "title": "Ban on 38 Russian Books"
  },
  {
    "cluster_id": "0a129298-9d76-444c-8b1e-1ebbbe3bb953",
    "title": "Yanukovych Seeks Russian Assistance"
  },
  {
    "cluster_id": "14b46c0a-7b16-4722-b599-90d7d69970a1",
    "title": "Natural Immunity vs Vaccination Debate"
  },
  {
    "cluster_id": "c7b90480-a4e5-4b5f-b840-fe13ad140b52",
    "title": "Misinformation: Vaccine-Induced AIDS Claim"
  },
  {
    "cluster_id": "ff3032ee-a77e-4fe7-a5a1-205c35f0948e",
    "title": "Ukrainian Forces Reclaim Mariupol"
  },
  {
    "cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
    "title": "NATO's Illegal Occupation of Ukraine"
  },
  {
    "cluster_id": "557fbe6b-8c80-48fe-945d-5c4d06e53e9a",
    "title": "Lustration Law Bans Former Officials"
  },
  {
    "cluster_id": "b670ddd2-4c67-47c8-b6aa-a5edcf7b7b3a",
    "title": "Macron Urges Dialogue, Not Humiliation"
  },
  {
    "cluster_id": "947a0b8b-01e0-44c9-8ebc-c9da3eecde20",
    "title": "Russians Demand Autonomy"
  },
  {
    "cluster_id": "89448e79-f7ef-4836-aa0c-f4044c4e1e16",
    "title": "ICC Opens Ukraine Preliminary Examination"
  },
  {
    "cluster_id": "cd51f6af-e3ac-4df3-b356-fdbeb2599d37",
    "title": "COVID-19 enzyme resembles rattlesnake neurotoxins"
  },
  {
    "cluster_id": "a9f88531-6abb-40c2-bba6-de053eb80cb0",
    "title": "Ukraine's Currency Market Hinges on Russia"
  },
  {
    "cluster_id": "aa458090-4ea3-4829-9f88-662eb71a8370",
    "title": "Contested COVID-19 Claims"
  },
  {
    "cluster_id": "1020a2ca-3e92-4f76-98e4-6f44fdfd5f52",
    "title": "Ukraine: Weak Manufacturing and Investment"
  },
  {
    "cluster_id": "4fc147e3-0b67-422d-b442-9aed1bd9ffee",
    "title": "Disputed Donetsk, Luhansk Elections 2014"
  },
  {
    "cluster_id": "6b22978f-c41a-4fd1-ac4e-29deafe60573",
    "title": "Vaccine-caused excess deaths claim"
  },
  {
    "cluster_id": "51ff5b38-5ae5-4505-adc2-291731599e68",
    "title": "Vaccination Prevents Convalescent Plasma Donation"
  },
  {
    "cluster_id": "8c70df97-1c82-4e7f-b23d-acbf2024c8f6",
    "title": "Westinghouse extends Ukraine nuclear fuel contract"
  },
  {
    "cluster_id": "15bdefb4-3c81-4573-bb02-e7a3789e75e2",
    "title": "Most COVID-19 Deaths Had Comorbidities"
  },
  {
    "cluster_id": "ca0d3bae-6f1d-4857-b362-c7e7718bca04",
    "title": "Vaccines Trigger Beef Intolerance"
  },
  {
    "cluster_id": "40db941d-31ac-4f8f-a268-d60a6c9bd055",
    "title": "NATO Nuclear Drills Threaten World War"
  },
  {
    "cluster_id": "27fad854-f733-4ec5-8acb-b36e0c043d26",
    "title": "Virus: Necessary Factor, Not Cause"
  },
  {
    "cluster_id": "88fa31fb-364c-47f5-bac4-4ecea848d93a",
    "title": "Vows to Reclaim Crimea"
  },
  {
    "cluster_id": "04c0a28d-e066-4279-bfee-f4757f197d7a",
    "title": "Crimean Tatars Support Russia's Ukraine Operation"
  },
  {
    "cluster_id": "43320422-2afc-457d-a5b5-902abc100632",
    "title": "WHO clarifies PCR cycle thresholds"
  },
  {
    "cluster_id": "6d1416a4-5911-49a5-a8dd-0b4e7d18279a",
    "title": "Event 201 Pandemic Tabletop Exercise"
  },
  {
    "cluster_id": "448377aa-104a-47c8-b987-d7ae3a311686",
    "title": "Stanford Seroprevalence: More Infections, Lower IFR"
  },
  {
    "cluster_id": "d53538f2-6557-4a35-adbb-a2eefd4e49a8",
    "title": "Ukraine 2016 Political Instability"
  },
  {
    "cluster_id": "c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a",
    "title": "UN Admits Islamists in Ukrainian Forces"
  },
  {
    "cluster_id": "07a40f3e-ce43-455d-8cb0-e9110e244817",
    "title": "Red-Black UPA/Bandera Flag in Euromaidan"
  },
  {
    "cluster_id": "7e64d534-c786-4ebd-b549-3314cdd361e4",
    "title": "Amnesty Reports Civilian Deaths in Donbas"
  },
  {
    "cluster_id": "2f4e138b-a8ca-4c68-be26-24de0c3b0489",
    "title": "EU Visa-Free Travel for Ukrainians"
  },
  {
    "cluster_id": "29fa8f23-676f-4f6e-888b-58fd11dbd236",
    "title": "Waning antibodies prompt booster guidance"
  },
  {
    "cluster_id": "44a25f49-5174-4a81-bbe3-8d614f9c4116",
    "title": "Grocery Stores Install Cart Sanitizers"
  },
  {
    "cluster_id": "16220929-8aa1-45e6-9f5e-8401f7ed50de",
    "title": "Stoltenberg Urges Long-Haul Readiness"
  },
  {
    "cluster_id": "5ec2fd93-7d1f-4121-8e63-fe69b1d0ab98",
    "title": "Ukraine projectile destroys Rostov border facility"
  },
  {
    "cluster_id": "a1084837-f12e-45c4-9bfb-1677ce1c51ad",
    "title": "Sanctions Targeting Ukraine Authority Claims"
  },
  {
    "cluster_id": "4fa8e557-bb3e-4afa-89cd-33ec7b315e73",
    "title": "Nuland Warns: Oligarchs, Reforms Threaten Ukraine"
  },
  {
    "cluster_id": "c5ac1407-521f-4465-8124-83f30e719068",
    "title": "Polls Delayed Near Frontline"
  },
  {
    "cluster_id": "ed50b251-f205-4952-987b-aed1c0461840",
    "title": "Ukraine Transfers Gold to Poland"
  },
  {
    "cluster_id": "94e66aa3-5079-4e1d-bdc8-702db352aa56",
    "title": "Nordic Nations Pause Moderna for Youth"
  },
  {
    "cluster_id": "71b86c5b-0ae0-46d5-a172-4da94679db3d",
    "title": "Danish Researchers Claim Pfizer Unsafe"
  },
  {
    "cluster_id": "187eb2a5-5a75-4a22-8ebb-7b83bc1068a8",
    "title": "Debunking COVID Vaccine Myths"
  },
  {
    "cluster_id": "a11d2091-08fe-4a3c-ae90-66e1118f2ac4",
    "title": "Mask Mouth and Oral Health Issues"
  },
  {
    "cluster_id": "baef4ffa-45e6-4649-9ab7-8c1b3621d2d6",
    "title": "Netherlands Won't Ratify EU-Ukraine Association Agreement"
  },
  {
    "cluster_id": "59e2af7d-1c61-4602-808b-5369f9854fc9",
    "title": "2014 Ukrainian Banking Crisis"
  },
  {
    "cluster_id": "213314ea-c0f8-4a72-832f-5b10a8bbeab5",
    "title": "IAEA Chief Condemns Shelling Near Zaporizhzhia"
  },
  {
    "cluster_id": "d089f75e-69ee-4713-8c0e-27843b110a2a",
    "title": "Cities Seek Return to Russia"
  },
  {
    "cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f",
    "title": "Ukraine Lenin Statues Removals 2013\u20132014"
  },
  {
    "cluster_id": "2f03e50c-f48e-4212-9d22-0ac755bb8fe3",
    "title": "Fast-track citizenship in occupied Kherson, Zaporizhzhia"
  },
  {
    "cluster_id": "0a1db453-23bf-4b25-a04b-c4f13d273e88",
    "title": "Masks Blamed for 1918 Deaths"
  },
  {
    "cluster_id": "11ad6c89-9a64-4385-9a81-dfa3787cc401",
    "title": "Formation of Ukrainian Volunteer Battalions (2014\u20132015)"
  },
  {
    "cluster_id": "2c6352c1-d120-47aa-8825-a58359bc7c7c",
    "title": "Earlier U.S. Lethal Defense Transfers"
  },
  {
    "cluster_id": "cf0c77f3-683e-467a-b83c-95b78a12d867",
    "title": "Open Letter Urges Airborne Transmission Recognition"
  },
  {
    "cluster_id": "20c941a8-b922-48e3-8e56-e49e1a524fd9",
    "title": "HPV Vaccine: Side Effects Outweigh Benefits"
  },
  {
    "cluster_id": "66380cec-1745-4f20-be6e-01fcad9e1602",
    "title": "Moderna Phase 3 Safety Data NEJM"
  },
  {
    "cluster_id": "6d2fdf64-8424-4971-a998-3fe674aff124",
    "title": "Nuclear Explosion in Ukraine"
  },
  {
    "cluster_id": "933ba991-e63b-4909-90b5-fbeb9eeea4c4",
    "title": "Crimea switches to Russian phone numbers"
  },
  {
    "cluster_id": "5d8d730b-6674-4d5b-8f99-6c8e240e9080",
    "title": "Ukrainian Repression of Hungarians in Transcarpathia"
  },
  {
    "cluster_id": "287c467e-feff-43ca-835b-d713c03d0418",
    "title": "March 2019: UPA/OUN Veteran Status"
  },
  {
    "cluster_id": "5a9d340b-259a-49d7-894d-4e9c6dec6a07",
    "title": "Odesa Clashes, Trade Unions Fire"
  },
  {
    "cluster_id": "4a7affe3-fd43-41f4-8713-3066830d90f8",
    "title": "OSCE SMM vehicles struck near Kirovske"
  },
  {
    "cluster_id": "995a6788-c0da-4f2f-a729-9d6b9bf65efc",
    "title": "Ukraine Seeks Peace With Russia"
  },
  {
    "cluster_id": "003d2fc7-16f8-4835-a770-b85123b3c250",
    "title": "Wuhan Unknown Pneumonia; WHO Notified"
  },
  {
    "cluster_id": "d882f953-ff9f-4410-820f-ffce8c5ec321",
    "title": "Israel Reinstates Masks Amid Delta Surge"
  },
  {
    "cluster_id": "bb78b3cf-3fee-4d7e-b532-1ccb52ef3013",
    "title": "Donetsk-Luhansk Rights Violations"
  },
  {
    "cluster_id": "5ac433e4-bd1e-455d-8c24-e981eb354d77",
    "title": "Myth: Vaccines Change DNA"
  },
  {
    "cluster_id": "0a6e93a7-4ca1-4ae8-937a-93b0852204d1",
    "title": "Hungary Protests Ukraine Education Policies"
  },
  {
    "cluster_id": "36d5c8e6-5870-44de-bee8-1ba3638e2785",
    "title": "Contested Graphene Oxide Vaccine Claim"
  },
  {
    "cluster_id": "f2c109a3-30b0-4718-85b7-78d12406aef5",
    "title": "June 2021 Post-Authorization Adverse-Event Summaries"
  },
  {
    "cluster_id": "9ee44494-957f-41e5-a680-3bacf709709f",
    "title": "Russia accuses Ukraine of Crimea plots"
  },
  {
    "cluster_id": "1ce4d643-96d1-4472-9df9-18efdd477875",
    "title": "Ukraine Repeals 2012 Language Law"
  },
  {
    "cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5",
    "title": "Expedited release of Pfizer vaccine documents"
  },
  {
    "cluster_id": "db855b90-bd37-485e-bb72-492eed958963",
    "title": "PHE Age-Stratified Vaccine Surveillance"
  },
  {
    "cluster_id": "05f00def-a8b8-4cdc-94a6-9ead4bc629d3",
    "title": "Zaporizhzhia Nuclear Plant Under Fire"
  },
  {
    "cluster_id": "c9780602-10a7-414d-9965-0df44aadba9b",
    "title": "Kremlin Blames Sanctions for Rouble Slump"
  },
  {
    "cluster_id": "2a1de060-abb4-43d9-a91c-f13c074e7031",
    "title": "UK Pandemic Over: Herd Immunity"
  },
  {
    "cluster_id": "f43f98cd-cb16-421c-a639-6c526509bfd7",
    "title": "SV40 Contamination in Polio Vaccine"
  },
  {
    "cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
    "title": "Vaccine Misinformation: False Risk Claims"
  },
  {
    "cluster_id": "9fc7edf3-7209-4828-92b3-8d6dafded201",
    "title": "Ukraine Cedes Borders to the EU"
  },
  {
    "cluster_id": "0e248889-43a9-4087-a6b0-f1d7854daf2c",
    "title": "Backlash Over Law Targeting Russian Speakers"
  },
  {
    "cluster_id": "679dc735-ea4b-4b4e-88e2-45d26bcc5b41",
    "title": "PCR Tests Fail to Distinguish Flu"
  },
  {
    "cluster_id": "9c71282b-fc72-4fb3-b7f8-7ff433782d1d",
    "title": "Isa Munayev Killed Near Debaltseve"
  },
  {
    "cluster_id": "79e93acb-9f08-48c2-9984-2e0654fbc884",
    "title": "Kyiv substitutes Ded Moroz with Mykolay"
  },
  {
    "cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a",
    "title": "Ukraine Decommunization: Banning Soviet Symbols"
  },
  {
    "cluster_id": "ab1f8fac-3632-4188-90ae-a2c911b8425d",
    "title": "Kharkiv Marchers Chant Anti-Russian Slogan"
  },
  {
    "cluster_id": "19581d0c-22b5-4ff0-8a68-de86fb01009c",
    "title": "Pfizer vaccine trial: 44% miscarriages"
  },
  {
    "cluster_id": "7c8877ae-f397-490e-9778-67a6e91ebe1c",
    "title": "Sanctions on Russia After Crimea"
  },
  {
    "cluster_id": "02ef40eb-a1c1-4bb1-9831-77fc91e127be",
    "title": "Zelensky Delays Donbas Decentralization Bills"
  },
  {
    "cluster_id": "0630fbfc-9793-4e8b-bd28-898778d452da",
    "title": "EU\u2013Ukraine Association Agreement Signed"
  },
  {
    "cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
    "title": "Donbas Elections: Control or Sabotage"
  },
  {
    "cluster_id": "48ab24c5-0fbd-4e1e-ac75-46e6a9ab3e75",
    "title": "Transcarpathia-Hungary Border Tensions"
  },
  {
    "cluster_id": "4fe1a1d1-0c63-4497-8366-24cf2914a93f",
    "title": "UK and Ireland Exempt from Visa"
  },
  {
    "cluster_id": "109daecb-5285-41a5-9427-7fd6ab199a14",
    "title": "Ukrainian Detained in Crimea for Espionage"
  },
  {
    "cluster_id": "3c02cb9f-d868-4d95-a235-953e540c09c9",
    "title": "Far-Right Influence in Post-Maidan Ukraine"
  },
  {
    "cluster_id": "f8140231-b4f8-4a5a-801c-39c992ba46a9",
    "title": "Samoa Measles Outbreak Triggers Emergency"
  },
  {
    "cluster_id": "70a4982e-a051-4993-8a45-818426e08af0",
    "title": "Canada at Donbas withdrawal line"
  },
  {
    "cluster_id": "a8476578-a217-4709-ac69-6e4d18f25dc6",
    "title": "Maidan Reverses 2012 Language Law"
  },
  {
    "cluster_id": "3c9a1b13-b4b6-4090-861e-e35159e61286",
    "title": "Guillain-Barr\u00e9 Linked to 1976 Swine Flu"
  },
  {
    "cluster_id": "6150a21f-6d1d-4554-8cbb-b01623349756",
    "title": "Parliament approves 75% Ukrainian TV quotas"
  },
  {
    "cluster_id": "b471f42f-4da7-4b5a-a11e-18deef221da8",
    "title": "Zaporizhzhia NPP: Mined and Rescued"
  },
  {
    "cluster_id": "011b48fb-6ec4-41cc-bd4d-394e371c18cb",
    "title": "Ukraine Opposes WWII Victory Medals"
  },
  {
    "cluster_id": "0a173478-bf00-4e1f-be9a-c8305b945d9d",
    "title": "Ukrainian National Guard throws dead bodies"
  },
  {
    "cluster_id": "d00bd384-4d89-4a56-8487-c419c52438e5",
    "title": "Polio Vaccine Conspiracy Claims"
  },
  {
    "cluster_id": "95b428d7-1d28-45e2-a9a0-dd59bb6a0176",
    "title": "Separatist Buried Alive in Ukraine"
  },
  {
    "cluster_id": "c0713b5c-a570-4865-83c9-eb36c347abcf",
    "title": "Rapid Trident 2021 COVID Mitigation"
  },
  {
    "cluster_id": "66bbc9b1-3580-4b34-9ccc-f5983ea5120d",
    "title": "2014 Parliament Recognizes OUN/UPA Veterans"
  },
  {
    "cluster_id": "56c21a67-f093-4d7b-81de-a41cb3a3c896",
    "title": "Hryvnia Plunge After Auctions Abandoned"
  },
  {
    "cluster_id": "d415aa76-63ab-4b87-94b6-7d753e952a6a",
    "title": "Ukraine Declares Donbas Occupied, Russia Aggressor"
  },
  {
    "cluster_id": "ab378ec8-ca7a-473f-b276-44d546196e26",
    "title": "Claim: Flu Shot Causes Cancer"
  },
  {
    "cluster_id": "9e771d92-eea3-45ec-b1c4-e7bba0011301",
    "title": "Germany Restricts AstraZeneca to Over-60s"
  },
  {
    "cluster_id": "99f11e8b-4375-4ee6-8be9-78b8355c6e63",
    "title": "Allegations of Neo-Nazism in Ukraine's Government"
  },
  {
    "cluster_id": "fca8c069-2da0-43e8-8cac-08662970bcda",
    "title": "Preliminary mRNA vaccine safety in pregnancy"
  },
  {
    "cluster_id": "a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4",
    "title": "Liability Rules Under EUA"
  },
  {
    "cluster_id": "b69dac95-ca24-49e5-b472-f36e5a0721b8",
    "title": "Vandalism of Holocaust Memorials, Ukraine, 2014"
  },
  {
    "cluster_id": "8d63a231-4f96-4fb0-aa81-938182c806dd",
    "title": "USAID Ukraine Civil Society Audit"
  },
  {
    "cluster_id": "773c7be2-511f-4315-b512-fcfb831f2cc3",
    "title": "Russia accuses Ukraine of Kerch provocation"
  },
  {
    "cluster_id": "3c4b8a98-54ef-4e72-a175-6c00ff85db75",
    "title": "Culture Minister Falsified History, Denied Holocaust"
  },
  {
    "cluster_id": "9af9ad02-7803-4d3d-9d58-fdfc300bef96",
    "title": "Post-vaccine Deaths Not Classified as Vaccine-Related"
  },
  {
    "cluster_id": "268e1143-4495-4247-af6b-b6f6f368f74f",
    "title": "Russia's Sole Humanitarian Aid to Donbas"
  },
  {
    "cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a",
    "title": "CDC Guidance for Certifying COVID-19 Deaths"
  },
  {
    "cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
    "title": "COVID Vaccine Myths: Poison, Vanished Pandemic"
  },
  {
    "cluster_id": "92352325-85b6-4726-9aed-67119e9599f9",
    "title": "Low Effectiveness: 2014\u201315 Flu Vaccine"
  },
  {
    "cluster_id": "d191d96a-6233-4306-907d-1beabb6fc9c7",
    "title": "Atlantic Resolve: Poland Rotations 2019"
  },
  {
    "cluster_id": "a9574820-7af4-4109-8e6e-9d95f9ba6cbd",
    "title": "Formalising Citizens' Right to Bear Firearms"
  },
  {
    "cluster_id": "bbc6fef6-c552-409d-9152-d8abd3a15ae3",
    "title": "Temporary martial law in border regions"
  },
  {
    "cluster_id": "0e128959-4be6-4a58-950e-03878e48a675",
    "title": "Provisional All-Cause and Excess Deaths, 2021\u20132022"
  },
  {
    "cluster_id": "5279c839-650e-45b8-a4b4-5af5d5649ea3",
    "title": "Kyiv Pride clashes; police detain far-right"
  },
  {
    "cluster_id": "258085e5-fc49-48d1-b3f4-3f9862c3ba91",
    "title": "Maritime borders tied to Crimea annexation"
  },
  {
    "cluster_id": "61608de3-ac5a-4b10-bba7-1b5580f57caa",
    "title": "Treasury designates DPR and LPR"
  },
  {
    "cluster_id": "983a818a-ed6d-40ec-af64-8e28da7e1bbd",
    "title": "Presidential Blocking of Russian Platforms"
  },
  {
    "cluster_id": "bc3b9d73-137b-4059-890e-e7cbbf0bd7b2",
    "title": "Pro-Russian Seizure of Donetsk"
  },
  {
    "cluster_id": "99d9484d-46ae-4ca2-98a1-dd3e0aeee99d",
    "title": "COVID Death Toll Overreported"
  },
  {
    "cluster_id": "21361eee-5fe8-48f0-a512-8a8c4752daae",
    "title": "Higher Infection Rates Among Vaccinated"
  },
  {
    "cluster_id": "2ccc0520-5070-4b1d-b1b9-d9e9fc878c97",
    "title": "National Geographic Maps Crimea as Russia"
  },
  {
    "cluster_id": "eac2d3f5-7d2a-4cfa-b17e-cac48f4a7268",
    "title": "Crimea 2014: Abuses and Collaborations"
  },
  {
    "cluster_id": "71f12e75-d3eb-42eb-93dd-fc62f2343321",
    "title": "Hungary to Shoot Down Ukrainian Airliner"
  },
  {
    "cluster_id": "edae4987-7374-49c7-bd0c-6f6522213435",
    "title": "NATO eFP Deployments: Baltic States, Poland"
  },
  {
    "cluster_id": "71624d95-aa07-4fb2-8217-706e01ae4a63",
    "title": "Russia Deploys Troops on Ukraine Border"
  },
  {
    "cluster_id": "a222dd36-fddd-41d8-956d-d735c7c4c6bb",
    "title": "US Created Crimean Tatar Mejlis"
  },
  {
    "cluster_id": "0c87e09a-5d40-4c46-abb8-ffdda4139e41",
    "title": "Vaccine-Associated Axillary/Supraclavicular Lymphadenopathy on PET/CT"
  },
  {
    "cluster_id": "e126486d-8b99-4425-b6a3-54724b486b78",
    "title": "Vaccines Outperform Natural Immunity"
  },
  {
    "cluster_id": "d11c600b-0ae3-4e55-8d1a-58fd9d0f71dc",
    "title": "Rights Stripped From Russian Citizens"
  },
  {
    "cluster_id": "f8ceed1b-ae48-442b-9e71-03f2203d7e38",
    "title": "VAERS Deaths Blamed on Vaccine"
  },
  {
    "cluster_id": "edbf77d5-b06d-4cb6-b6cf-9834f2f63e4c",
    "title": "EMA Guidance: Porcine Trypsin in Vaccines"
  },
  {
    "cluster_id": "254e946c-9e7a-429c-b142-d41e38953b50",
    "title": "Rising Pediatric Scarlet Fever and GAS"
  },
  {
    "cluster_id": "2972b17d-9533-46fe-a896-a36d50916446",
    "title": "Limited visa-free travel for Ukraine"
  },
  {
    "cluster_id": "b997c44d-2fc1-4d45-8a7a-f72d1b5a079d",
    "title": "Firehose of Falsehood in Russia"
  },
  {
    "cluster_id": "a16d38f8-25ac-46b8-94d9-38eb77cacdcf",
    "title": "Foreign Fighters in Eastern Ukraine"
  },
  {
    "cluster_id": "170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c",
    "title": "Canadian Mercenaries in Donbas"
  },
  {
    "cluster_id": "4eb89d26-0914-45a8-8a2e-98708f9a3315",
    "title": "Children: COVID-19 Less Mortality, Similar Hospitalizations"
  },
  {
    "cluster_id": "0dcdf569-6e39-4d48-a8aa-2b6e3c34a3d5",
    "title": "Bandera Memorials Across Ukraine"
  },
  {
    "cluster_id": "f0e862e5-92ba-499e-8f7b-4935ce01c5fd",
    "title": "Misinformation: Vaccines Allegedly Untested"
  },
  {
    "cluster_id": "02063354-1cf2-4e4e-a749-ce91914994ae",
    "title": "Provincetown Outbreak: Breakthrough Infections"
  },
  {
    "cluster_id": "c99367c6-2c05-4a14-b047-7f8ff36ff133",
    "title": "OSCE SMM Reports Donetsk/Luhansk Casualties"
  },
  {
    "cluster_id": "18daf39a-f6c9-4439-8592-186d1ea3c4b4",
    "title": "Mask Wearing: CO2 Toxicity and Immunity"
  },
  {
    "cluster_id": "c2e5bef0-900b-4168-ac2b-5a5465221f87",
    "title": "Pfizer-BioNTech COVID-19 Efficacy Announcements"
  },
  {
    "cluster_id": "cec3a521-c732-4e0b-8192-f6efa6c46d10",
    "title": "2018 SBU Crackdown on Pro-Russian Media"
  },
  {
    "cluster_id": "6220afcf-2f7d-4d0b-9949-c9eea0785c4f",
    "title": "Military Near Zaporizhzhia Reactors and Infrastructure"
  },
  {
    "cluster_id": "12e02de9-758e-49f6-b31c-fe52770a7aa7",
    "title": "Harvard: higher cases in vaccinated areas"
  },
  {
    "cluster_id": "009e9d6b-ab96-416d-b96e-b7eaada086cf",
    "title": "Freelance Journalist Shot Dead in Kyiv"
  },
  {
    "cluster_id": "b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb",
    "title": "Ukraine's Education Law: Ukrainian Language"
  },
  {
    "cluster_id": "626701fe-ae3d-403d-9681-7d335f03c82a",
    "title": "Azov Origins: Far-Right Ties and Symbols"
  },
  {
    "cluster_id": "e4e6149d-8b97-4295-847d-c2c2c5acb8ee",
    "title": "Fluctuations in Stillbirth and Neonatal Rates"
  },
  {
    "cluster_id": "5d4f6733-5fbd-48ce-8468-590ebda279c7",
    "title": "Kyiv Provocation: Moscow Blamed"
  },
  {
    "cluster_id": "e81e68ae-4e8a-4aef-a358-1455ad08bdc4",
    "title": "DANMASK-19: Limited Mask Protection"
  },
  {
    "cluster_id": "bdc594bb-6aa7-4421-82b8-b7df34a7c93e",
    "title": "Ukraine targets Russian language protections"
  },
  {
    "cluster_id": "35008b59-14cd-4674-801b-6fc7e159bf31",
    "title": "2017 Ukrainian Education Law Promotes Ukrainian"
  },
  {
    "cluster_id": "c84778ea-ef3a-409f-9105-f5f4a9c3f19d",
    "title": "IAEA Chief Warns on Zaporizhzhia Plant"
  },
  {
    "cluster_id": "44a47e28-efc2-4e0c-b9c2-18a93b3b20be",
    "title": "Japan's vaccine death claim controversy"
  },
  {
    "cluster_id": "e56fc955-148f-4ab7-9982-126189917297",
    "title": "Graphene Masks: Inhalation Risk Recalls"
  },
  {
    "cluster_id": "06f36d72-4a36-4a11-89bc-28713f0d3ba2",
    "title": "Uttar Pradesh Credits Ivermectin Outcomes"
  },
  {
    "cluster_id": "aacd7f08-5036-4563-9193-ec61d4e0ea80",
    "title": "Spanish Coverage of Ukrainian Ultranationalists"
  },
  {
    "cluster_id": "31e7b652-307d-4f5d-a4a6-215892b2e421",
    "title": "NATO Opposes Immediate Ukraine Accession"
  },
  {
    "cluster_id": "e7def08b-a4be-4464-b5ad-7e8f1dfa8752",
    "title": "Moderna Side Effects and Sudan Polio"
  },
  {
    "cluster_id": "909f6739-4757-4400-a81c-4fdb3bbaad77",
    "title": "AstraZeneca suspended over Beta efficacy"
  },
  {
    "cluster_id": "7afb7680-3722-423f-b129-7076bfb88092",
    "title": "Vaccines and Statins Misinformation"
  },
  {
    "cluster_id": "a28a5ed3-bc11-405d-9242-8b1a5ce91c01",
    "title": "Ukraine Accepts ICC Jurisdiction Since 2014"
  },
  {
    "cluster_id": "9b7a4b49-e4e5-49c9-a089-9e908e59efcc",
    "title": "Self-Reported Long-Term HPV Vaccine Complications"
  },
  {
    "cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
    "title": "Rushed Vaccines, VAERS Spike, No Threat"
  },
  {
    "cluster_id": "d74329dc-5b82-41ba-94bd-2cdd8306d3ee",
    "title": "Ukraine FDI Collapse After 2014 Crisis"
  },
  {
    "cluster_id": "503b13e8-42e4-48e4-8ace-47ca9e49140f",
    "title": "Kyiv Drafts Ukrainian-Language Mandate"
  },
  {
    "cluster_id": "f0d97c3a-c630-45ac-8106-3c433d45bb57",
    "title": "Abuses by Donbas Volunteer Battalions"
  },
  {
    "cluster_id": "13d74323-84c7-4461-a516-d07ee1ee8c43",
    "title": "Ukraine retakes Sloviansk and Kramatorsk"
  },
  {
    "cluster_id": "e8b8352a-472f-4b00-9dae-87cd809f920e",
    "title": "Polish Military Order to Attack Ukraine"
  },
  {
    "cluster_id": "b2f25ba2-9f04-4c71-9e8b-d9b021ed7e8a",
    "title": "Variable mucosal IgA after mRNA vaccines"
  },
  {
    "cluster_id": "6f5e39d0-2941-42e5-be3f-779525a745b7",
    "title": "China urges restraint on Crimea referendum"
  },
  {
    "cluster_id": "af07ce28-0024-41ac-b51c-01e4bbf2c507",
    "title": "Unguided Rockets Kill Civilians in Donetsk"
  },
  {
    "cluster_id": "253e2fef-8100-4235-899c-96e9877535d1",
    "title": "UN Condemns Ukrainian Zaporizhzhia Attacks"
  },
  {
    "cluster_id": "7690b51f-82d1-4577-be9d-58b4d7bf11b2",
    "title": "Crimean Tatar Mejlis Declared Extremist"
  },
  {
    "cluster_id": "876dc47c-c65a-4a65-a882-eeeb837080aa",
    "title": "2019 Language Law Enters Into Force"
  },
  {
    "cluster_id": "aae30a17-ea30-48f8-8399-1f3de025df70",
    "title": "Eat Out to Help Out Launch"
  },
  {
    "cluster_id": "a5cfe32e-2f16-4644-a4e9-767621b4c4a7",
    "title": "Photo Coverage of Gaza Shelling"
  },
  {
    "cluster_id": "733bc88b-24fe-4115-bf99-e05181e2177b",
    "title": "Limited evidence for universal masking"
  },
  {
    "cluster_id": "fe911735-6fb7-4737-bc2c-bfe7c0b05844",
    "title": "Ukraine Census: Large Russian-Language Population"
  },
  {
    "cluster_id": "3a723b11-9c69-4419-ba9d-ccab21e2fc24",
    "title": "Persistent corruption and weak governance"
  },
  {
    "cluster_id": "98c5d764-86f9-4cd2-ac58-1dae1f5811e9",
    "title": "Illicit Trafficking of Radioactive Materials"
  },
  {
    "cluster_id": "5b2c4526-459d-4b6f-8f31-bd40fccf12ff",
    "title": "Ukraine to lose regions to Russia"
  },
  {
    "cluster_id": "56e6ff33-547f-4d6b-a7a7-e1266368fdd7",
    "title": "Kyiv Blackmails West Over Crimea"
  },
  {
    "cluster_id": "21a0cca0-78e3-4e0b-95d4-e1b42b08be47",
    "title": "Two Russian journalists killed near Luhansk"
  },
  {
    "cluster_id": "0950755f-651f-455e-a7d5-47091afd7de2",
    "title": "MHRA Declares COVID Vaccines Unsafe"
  },
  {
    "cluster_id": "5c683e3b-456e-40af-9840-3af3a5900ece",
    "title": "Ukraine Calls Pro-Russian Fighters Terrorists"
  },
  {
    "cluster_id": "612db375-37db-450a-9941-cc2bdb1c5d4b",
    "title": "First U.S. COVID-19 Vaccinations Begin"
  },
  {
    "cluster_id": "f367b654-8f0a-4a4d-816e-54c86d7f13ae",
    "title": "Mass graves of women near Krasnoarmiisk"
  },
  {
    "cluster_id": "6c375d59-160f-4719-ac36-a62607acccb1",
    "title": "Intensified NATO-Ukraine Cooperation"
  },
  {
    "cluster_id": "9c4f129c-13a2-41c2-aa00-330c197b8780",
    "title": "Russian claims of Ukrainian cross-border shelling"
  },
  {
    "cluster_id": "bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb",
    "title": "Ukraine Punishes Refusal to Speak Ukrainian"
  },
  {
    "cluster_id": "1f8ce922-0e37-4ccb-b586-67da18764d96",
    "title": "Alleged cancer risk in cell-based vaccines"
  },
  {
    "cluster_id": "d7c36f98-9955-4c57-9dda-97bd7a1b6e4f",
    "title": "Europe Suspends AstraZeneca Vaccine Over Clots"
  },
  {
    "cluster_id": "54c90db1-79c2-4dc0-b9f0-9cd9022a857f",
    "title": "US Seeks to Oust Poroshenko"
  },
  {
    "cluster_id": "c6d927b7-cd5d-4d4f-8175-fa9bbd32a788",
    "title": "Booster Expansion, Breakthroughs and Waning Immunity"
  },
  {
    "cluster_id": "d30fd077-478d-4784-a1a9-ce89125fa303",
    "title": "Samoa MMR deaths spark investigation"
  },
  {
    "cluster_id": "15516ad5-b153-4147-8246-ecae0ddbf175",
    "title": "Firing on Civilian Vehicles in Donbas"
  },
  {
    "cluster_id": "01a95de5-1ee0-4431-afa3-a8234a4831ac",
    "title": "Explosions at Saky air base"
  },
  {
    "cluster_id": "3c7779af-1e2b-432f-abfc-f807e51488c7",
    "title": "Raw Counts Mislead Vaccine Effectiveness Estimates"
  },
  {
    "cluster_id": "595a5404-b726-44ba-919a-07c9e6bedb55",
    "title": "Children face landmines in eastern Ukraine"
  },
  {
    "cluster_id": "93f3d467-50ce-4038-8205-5814ad28dd43",
    "title": "Masks Make In-Person Voting Safe"
  },
  {
    "cluster_id": "590acd5e-f716-496d-b821-297d8887167e",
    "title": "Trial Deaths Deemed Unrelated to Intervention"
  },
  {
    "cluster_id": "b978e9a0-f48b-432c-b14c-50e4efff007d",
    "title": "Odessa Deaths: Calls for Thorough Investigation"
  },
  {
    "cluster_id": "690dcbae-7356-41d9-9b3d-b2f6f77db887",
    "title": "Ukraine backs Steinmeier Formula on Donbas"
  },
  {
    "cluster_id": "bd7f57f5-8509-4e66-a8cb-a0ca1f9115a2",
    "title": "Putin Justifies Crimea Annexation"
  },
  {
    "cluster_id": "0978a576-627e-40f6-a382-f39885473545",
    "title": "Ukraine Bans Russian TV Channels"
  },
  {
    "cluster_id": "66034097-f5ff-415b-b7cc-7775692bf89e",
    "title": "Donbas SMM: Mines, Detentions, Access"
  },
  {
    "cluster_id": "c7c8c6d3-cdc9-47d7-8f45-165280d3560a",
    "title": "Gazprom Cuts Ukraine Gas Supplies"
  },
  {
    "cluster_id": "8ac816b2-de5c-4294-a968-e6279613b1d8",
    "title": "OSCE Walked Out of Donbas Talks"
  },
  {
    "cluster_id": "cfa7b687-2383-40f8-9684-b8b6e91149cc",
    "title": "Russia-Ukraine Trade Collapse, 2015"
  },
  {
    "cluster_id": "9c99e4fa-6c0d-4aa9-bb98-86450c898d1b",
    "title": "Vaccination causes more deaths than prevented."
  },
  {
    "cluster_id": "ddc5360a-1ac4-443b-9995-2e77ae3fa0fc",
    "title": "Parubiy Assassinated in Lviv"
  },
  {
    "cluster_id": "bf617b93-4dcc-4186-81d8-7cd9fc2d425a",
    "title": "Public Memory of PMCs in Iraq"
  },
  {
    "cluster_id": "00b8a8dd-d8e8-40d8-b8f3-1b3a9df2daea",
    "title": "COVID-19: PHEIC Declared; US Ends Emergencies"
  },
  {
    "cluster_id": "4129284c-60dc-471f-99d0-fbb5e6ca7277",
    "title": "Rare Post-Vaccination Myocarditis: Autopsy Case Reports"
  },
  {
    "cluster_id": "fc45a344-4cfc-4865-9030-d033f0c8dff3",
    "title": "COVID-19 Vaccine Misinformation Claims"
  },
  {
    "cluster_id": "dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e",
    "title": "Ukraine Incites Donbas War for Sanctions"
  },
  {
    "cluster_id": "66914632-689c-4d05-b834-b8904eae50cd",
    "title": "Bandera Canonized by Ukrainian Orthodox Church"
  },
  {
    "cluster_id": "5e7e70f4-b130-467a-9df9-f6078877ed61",
    "title": "UN Recognizes Russia's Crimea Phone Code"
  },
  {
    "cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c",
    "title": "Japan Suspends Moderna Vaccines Over Contamination"
  },
  {
    "cluster_id": "3909ddcb-f2e7-47b0-849d-f54906120921",
    "title": "Ukraine recognizes 1944 Crimean Tatar genocide"
  },
  {
    "cluster_id": "a92df9a8-beac-475c-a620-574a5351def4",
    "title": "Vaccine Harm Claims and Natural Immunity"
  },
  {
    "cluster_id": "827f6b49-228f-4d42-afa2-d86a5b588a72",
    "title": "Waning Pfizer Protection Against Delta"
  },
  {
    "cluster_id": "60a1acab-79cf-438f-96de-dbff294bd2e7",
    "title": "HPV Vaccine Harm Claims"
  },
  {
    "cluster_id": "0bf33c34-9525-433f-a535-5885b1ee4732",
    "title": "Kirovohrad renamed to Kropyvnytskyi"
  },
  {
    "cluster_id": "7b83d3ee-13b2-47c1-ab89-4f78258a986b",
    "title": "Ukraine's crackdown on Russian language"
  },
  {
    "cluster_id": "0ba7abed-e798-4cd4-b041-3026081313b7",
    "title": "Donetsk and Luhansk Declare Independence 2014"
  },
  {
    "cluster_id": "9bba558d-53eb-42ad-851e-623ab4e32bc6",
    "title": "Unmarked Russian Troops Disrupt Ukrainian Units"
  },
  {
    "cluster_id": "1ed52c55-1d90-4460-9e88-861e6d435eee",
    "title": "Pandemic Delays Threaten Cancer Outcomes"
  },
  {
    "cluster_id": "a615f0ed-7c6c-41b5-95d0-49cb25bb9feb",
    "title": "Claims of COVID Vaccine Dangers"
  },
  {
    "cluster_id": "17036568-8b0d-4108-9a16-98a16980ae3f",
    "title": "Ukraine Leverages EU Membership"
  },
  {
    "cluster_id": "ab120ec9-7f69-4d7e-880b-eb52320c48cd",
    "title": "Trilateral Ceasefire for Eastern Ukraine"
  },
  {
    "cluster_id": "73ed8dfb-71b9-42f0-9f45-a873045bd275",
    "title": "Putin Plans Military Retake of Crimea"
  },
  {
    "cluster_id": "5a861756-5d94-444c-84a0-fab63d482e8c",
    "title": "Ukrainian missile launch fails during maneuvers"
  },
  {
    "cluster_id": "a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f",
    "title": "Russia authorizes armed forces in Ukraine"
  },
  {
    "cluster_id": "d717bbe6-a62d-46c1-8d61-866b7d90a851",
    "title": "Masks Do Not Significantly Reduce Transmission"
  },
  {
    "cluster_id": "91ed355a-9103-4819-9a78-2425f91b042a",
    "title": "Kyiv enforces Ukrainian in stores"
  },
  {
    "cluster_id": "08533bcb-cb39-43d6-9371-79f7aa905623",
    "title": "CDC Vaccine Excipients and Media"
  },
  {
    "cluster_id": "b693d408-b0fd-49d2-8eea-39016ff5fda7",
    "title": "Poroshenko Declares Bandera Flag Victory Symbol"
  },
  {
    "cluster_id": "984e2a37-4883-4da4-8899-a3cc19bba978",
    "title": "Azov Threatens Dutch Citizens Over Deal"
  },
  {
    "cluster_id": "267d2942-984a-4564-b33c-69e9db79a066",
    "title": "ICC Probes Ukraine Crimes in Donbas"
  },
  {
    "cluster_id": "cd8525ab-90a4-434a-bf10-f887240219f2",
    "title": "Sea Breeze Black Sea Exercises"
  },
  {
    "cluster_id": "545232cb-5fc2-43ad-859e-11784f675852",
    "title": "US-Ukraine Cooperative Biological Threat Reduction"
  },
  {
    "cluster_id": "c19838ee-ef85-408d-84a0-c28811354698",
    "title": "Pfizer EUA; Ongoing Trial Follow-Up"
  },
  {
    "cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0",
    "title": "Pfizer Vaccine Associated Myocarditis in Israel"
  },
  {
    "cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef",
    "title": "J&J Vaccine Pause for Clots"
  },
  {
    "cluster_id": "c0707d1f-d796-4de7-994b-fd76b5d9d3dd",
    "title": "Lviv bans Russian language"
  },
  {
    "cluster_id": "bcc8a49a-201a-439b-bf04-a72b13e50b57",
    "title": "Donetsk Residential Areas Hit by Artillery"
  },
  {
    "cluster_id": "7f953e81-8c8d-4f0d-9b98-873627d95104",
    "title": "Ukrainian as State Language"
  },
  {
    "cluster_id": "ec7f8d90-641e-4755-b398-833e150c7057",
    "title": "Ukraine GDP-linked bonds near default"
  },
  {
    "cluster_id": "05374434-df8d-4b22-b660-0ddc27139765",
    "title": "Global Post-Vaccination Blood Donation Deferrals"
  },
  {
    "cluster_id": "7f1f819a-52dd-40cc-92a1-28526195605d",
    "title": "International Law Justifies Russia's Actions"
  },
  {
    "cluster_id": "b7768432-bcaf-4a4c-9bb2-1a6e02c6a003",
    "title": "NATO Policy Drives Ukrainian Exodus"
  },
  {
    "cluster_id": "d8c4ecf1-bb1b-4da0-8a1b-b80059b7063b",
    "title": "Shevchenko Statue Demolished in Zaporizhzhia Region"
  },
  {
    "cluster_id": "12cb5a16-807e-4b60-87c2-713f3796ebf1",
    "title": "RT-PCR Testing: False Positives and Negatives"
  },
  {
    "cluster_id": "4b5a21e3-57c3-4239-8ed1-85b9925a8673",
    "title": "Gardasil MDL Consolidates Over 140 Lawsuits"
  },
  {
    "cluster_id": "213244f7-7bbf-4ff3-935f-65e545a0abda",
    "title": "Concern Over Communist Ban, Leftist Persecution"
  },
  {
    "cluster_id": "30a748c7-0edb-4c1b-9472-d1b4ca3f8032",
    "title": "Florida Reports 84% Post-Vax Cardiac Deaths"
  },
  {
    "cluster_id": "10bff7af-7766-4fc3-b86a-eaf53dd132e9",
    "title": "Kyiv sanctions harm Ukraine's investment climate"
  },
  {
    "cluster_id": "f55b7553-3d55-4096-859e-954de960f09c",
    "title": "Poroshenko's Offshore Ties Revealed"
  },
  {
    "cluster_id": "125a4bc0-e32c-4a8b-80fc-60d23537d495",
    "title": "Kyiv Court Bans Communist Party"
  },
  {
    "cluster_id": "029ce0da-0ea0-4431-a895-310ff5fa4a56",
    "title": "MMRV Seizure Risk Prompted Separate Shots"
  },
  {
    "cluster_id": "31bf6722-ac5c-4597-8c42-50efe5c5aceb",
    "title": "CDC: Masks and Mandates Ineffective"
  },
  {
    "cluster_id": "1826eb0d-42e5-4b20-8a46-72b9e26a1dc6",
    "title": "Biometric Passport Holders in Visa Liberalisation"
  },
  {
    "cluster_id": "58c4dc89-fa0e-45c9-8892-01fb55da5607",
    "title": "Parliament accuses Ukraine of Soviet crimes"
  },
  {
    "cluster_id": "8f381ec8-c658-466c-973c-6cace2609d01",
    "title": "Drunken US Mercenaries Rampage Through Mariupol"
  },
  {
    "cluster_id": "56bced3d-5502-4c62-9756-ced2f88eec36",
    "title": "VRBPAC Briefing: 2-Month Safety Follow-up"
  },
  {
    "cluster_id": "bdc4ffb8-404a-4799-a92b-88d77e6c445d",
    "title": "MHRA Guidance After Pfizer-BioNTech Anaphylaxis"
  },
  {
    "cluster_id": "cbeb70b1-aecc-4170-98d8-bc70bbb4a2f1",
    "title": "Kharkiv crackdown on pro-Russian protesters"
  },
  {
    "cluster_id": "e3548f8e-cc3f-4307-a48a-a45cdf828859",
    "title": "Misadministered COVID-19 Vaccines"
  },
  {
    "cluster_id": "35d18d7f-0f7d-4654-8e65-f6b4bcac032a",
    "title": "False mRNA vaccine death claim"
  },
  {
    "cluster_id": "41dd785c-3146-4243-8bbd-56211fadb273",
    "title": "Kyiv Proposes Russian Language Ban"
  },
  {
    "cluster_id": "04568cc7-5dd8-42b7-8a07-715cdd043c03",
    "title": "Odessa Trade Unions House Fire Deaths"
  },
  {
    "cluster_id": "1e227a80-8d1d-4484-9608-82719d3b526e",
    "title": "Ukraine legalizes private armies in Donbas"
  },
  {
    "cluster_id": "bb078c76-36ef-4176-a9f6-192717c4f2b4",
    "title": "UN veto blocks Crimea referendum condemnation"
  },
  {
    "cluster_id": "3630ee9d-368f-4623-9704-06881bdf9264",
    "title": "Identify and Expel Russian Passport Holders"
  },
  {
    "cluster_id": "f39cf9c7-18fb-4728-b88a-0bd586522d02",
    "title": "Ukrainian National Guard Seizes Komsomolske"
  },
  {
    "cluster_id": "e31510b5-776d-40cf-9a10-afb0bb1a3f0b",
    "title": "American Mercenaries in Donetsk"
  },
  {
    "cluster_id": "59ac47e6-50e9-4884-a676-2542dc8e0aa3",
    "title": "High-Profile Athlete Cardiac Incidents 2021"
  },
  {
    "cluster_id": "f0190a02-daf5-48b7-8174-720b52c75550",
    "title": "Measles Outbreak Triggers Visa-Free Travel Ban"
  },
  {
    "cluster_id": "a5e788fc-37bf-43d2-97b2-732f917263ab",
    "title": "Adolescent Vaccine Impact and Reactogenicity"
  },
  {
    "cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
    "title": "NATO Forces Entered Donbas"
  },
  {
    "cluster_id": "6e64c34e-113d-43d7-87a6-90c61d4d3f67",
    "title": "Japan suspends HPV vaccine; resumes 2021"
  },
  {
    "cluster_id": "e440fb1d-afb5-4fce-9f0b-110db0f93b32",
    "title": "Parliament Approves Draft State Language Bill"
  },
  {
    "cluster_id": "544fb937-88d2-4ddb-9c06-1ae58af8be2b",
    "title": "Spike Protein Alters Vascular Signaling"
  },
  {
    "cluster_id": "b3dddca5-c2cb-4bb6-a964-c4a7328e5b0d",
    "title": "One Vaccine Injury per 39 Doses"
  },
  {
    "cluster_id": "7b83d10a-e2be-4730-b52d-6f8b8b917c91",
    "title": "EU Advisory Mission in Ukraine"
  },
  {
    "cluster_id": "b2a62820-6f02-4de4-99f3-aea0d67cd577",
    "title": "NATO/US Warn Russia to De-escalate"
  },
  {
    "cluster_id": "e47fa355-bcc3-44bc-97e3-0029cf946325",
    "title": "Early Cohort: Multisystem Symptoms, Unknown Mechanisms"
  },
  {
    "cluster_id": "3b1f4f0d-8cab-47e8-8ee7-7eb215e3b909",
    "title": "EU approves \u20ac1.8b MFA for Ukraine"
  },
  {
    "cluster_id": "2b2067b5-dfbb-4340-b88b-e5f769120fc0",
    "title": "Blackwater Killings at Nisour Square"
  },
  {
    "cluster_id": "31d339ae-2342-44f9-a909-e299d2c4eccd",
    "title": "Islamic radicals flock to southern Ukraine"
  },
  {
    "cluster_id": "9babf1db-b81e-42d8-a506-b9ddc52bfb22",
    "title": "U.S. Rules Out Direct Ukraine Intervention"
  },
  {
    "cluster_id": "b07f3d2b-07c7-4378-8e98-619949a67d5a",
    "title": "Russian Media Frames Kyiv as Fascists"
  },
  {
    "cluster_id": "0bb1f8c0-08c1-4f63-b6c8-052a5bad160c",
    "title": "Myth: MMR Toxins Cause Encephalopathy"
  },
  {
    "cluster_id": "d339acab-2e15-4ce1-8cff-20a1b2fc2811",
    "title": "Batch-Dependent Safety of Pfizer Vaccine"
  },
  {
    "cluster_id": "17c8775c-7a3a-4607-aa7f-5b24078a17f8",
    "title": "Missing Italian Journalist in Donbas"
  },
  {
    "cluster_id": "3a4ae54e-e7b7-47e9-984e-62601ed45ab4",
    "title": "Oles Buzina Assassinated in Kyiv"
  },
  {
    "cluster_id": "44663aba-7a2e-4439-ac72-295c1b77f6ca",
    "title": "TEM/SEM Imaging of Graphene Oxide"
  },
  {
    "cluster_id": "ecb6a08c-9197-401c-afbc-cd0ee3d88f04",
    "title": "Ukraine v. Russia: ITLOS Provisional Measures"
  },
  {
    "cluster_id": "05302999-a145-4cb2-83a6-b2cda0247938",
    "title": "Autopsy Claims: Vaccines Cause Death"
  },
  {
    "cluster_id": "f465e3b9-9784-4302-b258-d34ad0adf726",
    "title": "Kyiv Memorial Plaque Destroyed"
  },
  {
    "cluster_id": "29149f19-2cff-4344-bb10-8e0506dbc049",
    "title": "Kyiv Ignores Minsk Protocol Meeting"
  },
  {
    "cluster_id": "75154ca6-776f-46e4-8f4a-2221f93d7ff0",
    "title": "Zaporizhzhia Referendum on Joining Russia"
  },
  {
    "cluster_id": "e60065d4-ae50-40b0-8e77-8c2ad3e36235",
    "title": "Vaccine Myths: COVID Risks"
  },
  {
    "cluster_id": "465883de-cd6a-47dc-b0f3-f22e0ff902ba",
    "title": "Lviv Declares Bandera Year; Protests Erupt"
  },
  {
    "cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
    "title": "False Claims: COVID Vaccine Deaths"
  },
  {
    "cluster_id": "f4d9e677-79ed-4c5c-84a1-d127898975a0",
    "title": "Ukraine Acknowledges Russia Protects Donbas"
  },
  {
    "cluster_id": "03db723a-dcac-4e7f-b456-18c0fdfdba8d",
    "title": "Mask Mandates Fail to Reduce Deaths"
  },
  {
    "cluster_id": "09a468db-6b0d-4230-a370-cfd6ba61219e",
    "title": "Pfizer CEO's Wife Dies From Vaccine"
  },
  {
    "cluster_id": "8870837d-d287-47f9-8134-1fe8a8f59e88",
    "title": "Alleged Vaccine Shedding to Unvaccinated"
  },
  {
    "cluster_id": "bb551e75-48fa-42c3-a108-cb4b1462b529",
    "title": "Ukraine Enshrines EU and NATO Membership"
  },
  {
    "cluster_id": "4c2902bb-5892-4765-99b2-69db31b95136",
    "title": "HALO Trust Demining Donbas Expansion 2019"
  },
  {
    "cluster_id": "dd9ccaa5-025e-44c1-90b2-20d75d0c5291",
    "title": "Pro-Russian activists seize Kharkiv administration"
  },
  {
    "cluster_id": "e632bc78-90b4-46bf-a31b-df8259ac6d90",
    "title": "Swastika on Ukrainian Vehicle in Donetsk"
  },
  {
    "cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810",
    "title": "AstraZeneca Vaccine Linked to Rare Clots"
  },
  {
    "cluster_id": "f50144fc-3b9b-4e34-ac6c-5191d30445d0",
    "title": "US to Bomb Siberia: Ukrainian Plan"
  },
  {
    "cluster_id": "85949bd1-40e8-47bc-acf7-cb049a4e425e",
    "title": "EU-Turkey Refugee Deal Funding"
  },
  {
    "cluster_id": "44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b",
    "title": "Orders to Shell Peaceful Villages"
  },
  {
    "cluster_id": "f16b94fa-630f-4218-860c-391c021de7f5",
    "title": "Russia's Food Share Rises in Turmoil"
  },
  {
    "cluster_id": "5dc9068d-5bdc-499d-a865-8dc21a274dc1",
    "title": "Ukraine Prohibits Dual Citizenship"
  },
  {
    "cluster_id": "19d43c44-0b32-47ac-85c1-a05682078f22",
    "title": "Cloth Masks Do Not Block Transmission"
  },
  {
    "cluster_id": "08d6975b-643a-4b0e-a8cb-576006cbf125",
    "title": "Anaphylaxis After First Pfizer-BioNTech Doses"
  },
  {
    "cluster_id": "fff91b42-2999-4568-8b58-028bf8ca7046",
    "title": "NATO RAP Responds to Russia 2014"
  },
  {
    "cluster_id": "a6ed0ce8-662a-4b6a-bb37-1ea2a020377f",
    "title": "Vaccine Ingredients Controversy"
  },
  {
    "cluster_id": "3989418a-395d-4448-a748-f8cca55ad517",
    "title": "UN Calls for Restraint in Crimea"
  },
  {
    "cluster_id": "fcfd6d39-3e11-43c7-ac1f-026d265beb4f",
    "title": "Stop Buying Masks Amid Shortages"
  },
  {
    "cluster_id": "d56cc903-0bed-4718-9fc5-602c188caa16",
    "title": "Israel Booster Campaign: Delta, Third Dose"
  },
  {
    "cluster_id": "9afd9c54-2f8e-40e0-aff4-8479c84a56df",
    "title": "Ukraine vows to retake Crimea"
  },
  {
    "cluster_id": "29790db2-2536-415f-822b-9a4c1f1f8a3c",
    "title": "Delta Variant Challenges Vaccine Efficacy"
  },
  {
    "cluster_id": "e47c3423-cbb6-4c9a-9b29-21416d12aba7",
    "title": "Ukraine Enacts Anti-Protest Dictatorship Laws"
  },
  {
    "cluster_id": "53d674a1-75eb-4a57-96a7-960a78dc2faf",
    "title": "EMA Publishes Comirnaty Public Assessment Report"
  },
  {
    "cluster_id": "2f8dc773-32fe-42ed-a085-3a10ca61c22d",
    "title": "International Support for Crimean Tatar NGOs"
  },
  {
    "cluster_id": "7c6d77d0-d878-49bf-a294-6d6456dfe66e",
    "title": "WHO Urges Booster Moratorium, Prioritizes Unvaccinated"
  },
  {
    "cluster_id": "05021641-3e64-47c1-b3de-9319980f7bf2",
    "title": "Rybak Killed and Tortured in Donetsk"
  },
  {
    "cluster_id": "91638e17-92b1-4187-b7cf-b00589f88898",
    "title": "Masked gunmen seize Crimean parliament"
  },
  {
    "cluster_id": "1da8672c-062d-456c-b508-fef471a32245",
    "title": "Public Support for Yelysavetgrad Restoration"
  },
  {
    "cluster_id": "632f52ad-dbbd-4d7f-af13-93bbeaa37163",
    "title": "Russia Accuses Ukraine Over Zaporizhzhia Attacks"
  },
  {
    "cluster_id": "35c8d576-e355-4f4b-802d-1d88de41da0b",
    "title": "Ukrainian Firms Plan Mass Layoffs"
  },
  {
    "cluster_id": "b454bfa6-3d84-4f22-a166-5f84ce0bf756",
    "title": "Donetsk Declares People's Republic"
  },
  {
    "cluster_id": "005d39b6-0b0e-4011-aaca-d596411fa607",
    "title": "Passportization in Occupied Ukrainian Cities"
  },
  {
    "cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
    "title": "Vaccines Linked to Rising Cases"
  },
  {
    "cluster_id": "9621dd39-ccb5-4e12-9287-8a404c57bba0",
    "title": "US Recognizes Donbas as Independent"
  },
  {
    "cluster_id": "2aafed04-d3d3-4ae0-9825-6d6db215ea71",
    "title": "Ukraine-NATO Exercise in Lviv, 2018"
  },
  {
    "cluster_id": "11d3cdd7-b203-4792-91e4-e32314bbcbc2",
    "title": "Unmarked Military Convoys in Donbas"
  },
  {
    "cluster_id": "1618106d-1c52-48f7-9d0e-a09294ca1167",
    "title": "Porton Down: Novichok-type; source unverified"
  },
  {
    "cluster_id": "5e0be9c9-87ac-49bb-a807-6e19f719434d",
    "title": "Delayed Russian $2B Ukraine Credit"
  },
  {
    "cluster_id": "a7867a02-8602-4251-af70-d100ee635a74",
    "title": "Parubiy Behind Maidan Shootings, Odessa Arson"
  },
  {
    "cluster_id": "0d1a4169-975f-49a7-9f31-390c351eb65a",
    "title": "Limited International Support for Crimea Annexation"
  },
  {
    "cluster_id": "49b2d0f6-e7d1-4326-9bb2-ec42779a8e4a",
    "title": "Ukraine backs organ-transplant law; kidney pilot"
  },
  {
    "cluster_id": "061483cd-3b7a-44e0-857c-a5c4129b4272",
    "title": "Ihor Kolomoisky Appointed Dnipropetrovsk Governor"
  },
  {
    "cluster_id": "91e856d9-7ba0-4d4e-ae44-31db4386dcaa",
    "title": "Donbas Mixed Support for Russia Ties"
  },
  {
    "cluster_id": "6c7b148b-0647-4c2a-ac9a-6341501bc035",
    "title": "2017 Law Restricts Minority Language Instruction"
  },
  {
    "cluster_id": "532f519a-d7c1-4910-afdd-938e13222189",
    "title": "Gas Pump Safety Precautions"
  },
  {
    "cluster_id": "72084673-8080-44fd-8f5b-97507abf262b",
    "title": "PCV1 DNA Detected in Rotarix"
  },
  {
    "cluster_id": "d7761b4c-72e0-44cd-b341-d16d8d7d63d7",
    "title": "Low COVID-19 Mortality Among Youth"
  },
  {
    "cluster_id": "c95d237e-c855-46b9-95fd-6b8f66d537c6",
    "title": "EU Ties Sanctions to Minsk, DPR/LPR"
  },
  {
    "cluster_id": "528595cb-88e8-4fb8-9197-5baf87551c4a",
    "title": "Campra Report Claims Graphene in Vaccines"
  },
  {
    "cluster_id": "5a8c09d4-337f-442b-8464-f2be567010bf",
    "title": "Two Largest Ukrainian Banks Default"
  },
  {
    "cluster_id": "a8cfe9e0-0ef9-4b98-a9d6-504f670dd69d",
    "title": "Donbas Civilian Displacement 2015"
  },
  {
    "cluster_id": "c7ac427c-82e0-477a-a03d-4c9be54cce85",
    "title": "Madrid Summit: NATO Declares Russia Threat"
  },
  {
    "cluster_id": "54d52770-613a-47b1-aa64-0743cb644791",
    "title": "Vaccine Efficacy Declines Over Time"
  },
  {
    "cluster_id": "c623ca23-8a98-4b0e-b365-eb9b3c1cdd86",
    "title": "Flu and SARS-CoV-2 Multiplex Testing"
  },
  {
    "cluster_id": "60a99f19-657e-458b-aa53-ca2a6063f380",
    "title": "Svoboda Ministers in 2014 Ukraine"
  },
  {
    "cluster_id": "4c76d4e3-5632-4224-a22f-bc4b4614bcbb",
    "title": "FDA Vaccine Officials Resign Over Boosters"
  },
  {
    "cluster_id": "67de48d7-3fc7-4d88-97a8-9350772b5bc5",
    "title": "UN/IAEA Mission to Zaporizhzhia Amid Shelling"
  },
  {
    "cluster_id": "212b2ba7-fb93-422b-bfc0-bda99de8b498",
    "title": "Karlivka Area Checkpoint Ambush Fatalities"
  },
  {
    "cluster_id": "8269010c-d30d-4a8f-9628-b930192a8751",
    "title": "World Bank-backed Naftogaz Unbundling"
  },
  {
    "cluster_id": "bd8d969e-3ce0-4ae8-b478-e7f5690a2b2c",
    "title": "FDA Guidance Changes: Plasma Donor Eligibility"
  },
  {
    "cluster_id": "5b7e1f2c-86a3-4e27-9c3e-c974a8d33606",
    "title": "Ukraine's NATO Membership Unlikely"
  },
  {
    "cluster_id": "868aacb9-ea8e-4ec3-a074-1e7f56bab03f",
    "title": "Checkpoint death caused by Ukrainian provocation"
  },
  {
    "cluster_id": "6670d6b8-9c36-4849-b28c-4959087df8d4",
    "title": "Early COVID-19 vaccine efficacy overestimated"
  },
  {
    "cluster_id": "3239dc2e-a961-4aab-990b-768c092064f8",
    "title": "Magadan-Registered Russian Passports for Crimeans"
  },
  {
    "cluster_id": "d0699d4c-25e1-439a-a44a-9bca30bebb35",
    "title": "UN Rights Mission: Donetsk-Luhansk Killings, Impunity"
  },
  {
    "cluster_id": "70408cf7-1954-491d-98bc-f78c50c03508",
    "title": "Expanding the Order for Courage"
  },
  {
    "cluster_id": "f2217761-bf63-4a79-b438-adbd2534e4d4",
    "title": "Blackwater Convictions Rekindle Private Contractor Scrutiny"
  },
  {
    "cluster_id": "4496a4b9-1070-44a0-89bc-e244c8a53dab",
    "title": "Media Instruction Drives Mask Wearing"
  },
  {
    "cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993",
    "title": "Provincetown Delta Breakthrough Outbreak"
  },
  {
    "cluster_id": "1acc8146-9053-485f-9f26-6af5d30d0040",
    "title": "U.S. Announces $1B Ukraine Loan Guarantee"
  },
  {
    "cluster_id": "c0322634-7754-4f2b-b97d-7786687b4f39",
    "title": "Uneven Poverty Recovery, Slow Welfare Rebound"
  },
  {
    "cluster_id": "2c20a8ae-1d47-4c90-a5e4-88e406d3334f",
    "title": "Waning Pfizer Vaccine Effectiveness in Israel"
  },
  {
    "cluster_id": "7675ffec-ff62-4c58-a805-c5097a8fcd7e",
    "title": "316L Particles: Root Causes and Corrections"
  },
  {
    "cluster_id": "465ba356-8493-40d2-9150-2a0b1fd6b413",
    "title": "Global criticism of Ukraine's decommunization bills"
  },
  {
    "cluster_id": "04fd43b1-9ee7-43b3-b1fc-e9fca576658d",
    "title": "Volunteers Profiting From War in Ukraine"
  },
  {
    "cluster_id": "3c925ff8-1b8c-47f3-b741-4544a596eae9",
    "title": "US Sold Defective Javelins to Ukraine"
  },
  {
    "cluster_id": "e0932d8f-119b-4dcd-8100-b5fb6b62417a",
    "title": "Breakthrough Infections in Omicron Era"
  },
  {
    "cluster_id": "61b4a043-a586-425e-a2f1-9e0b66e038e5",
    "title": "Kyiv Moratorium on Russian-Language Cultural Works"
  },
  {
    "cluster_id": "ed3519a5-2328-44c8-be3b-f36796b25965",
    "title": "Putin's Ruble Collapse Tricks Financiers"
  },
  {
    "cluster_id": "48f8cfb0-8d27-4a6d-8530-ed9a63c77de6",
    "title": "FDA Authorizes Pfizer for Children"
  },
  {
    "cluster_id": "8f07bc53-1683-4b3a-b1de-2e1c15c0e13c",
    "title": "Four Ukrainian Soldiers Killed by Mortar"
  },
  {
    "cluster_id": "3cb0e39c-2e4c-43dd-b51c-bd5e065c7bd5",
    "title": "Increased cardiovascular events among under 40"
  },
  {
    "cluster_id": "ac5cef85-9755-4d73-a0c9-3b2d779220c4",
    "title": "Japan Reports Post-Vaccination Heart Failures"
  },
  {
    "cluster_id": "e128e0c8-745a-4ce1-995d-c5a2ac809b5a",
    "title": "Ukraine Patriotic Education Coverage 2018"
  },
  {
    "cluster_id": "7cff4302-4ea6-4196-96e5-448a227d2f09",
    "title": "Known Neurotoxins: Four Chemicals"
  },
  {
    "cluster_id": "a98eba10-9612-466e-bbba-6161ced90ab9",
    "title": "Zaporizhzhia Demolishes Film Hero Monument"
  },
  {
    "cluster_id": "cd745d99-6d4d-4cbd-964c-839c80021692",
    "title": "Poroshenko Seeks UN Peacekeepers for Donbas"
  },
  {
    "cluster_id": "4d3fc72a-c96e-4659-afda-27c7ce47c497",
    "title": "Court-Ordered Public Release of Pfizer Docs"
  },
  {
    "cluster_id": "50dbe9fb-6818-4777-990a-3ab01ab3659e",
    "title": "Jamie Foxx Post-Vaccine Health Crisis"
  },
  {
    "cluster_id": "a9555cd5-7b65-4e84-9f89-ed03117c7e50",
    "title": "Vaccines Containing Aborted Fetal Tissue"
  },
  {
    "cluster_id": "633de8a7-7506-44cf-9918-6f3f17934029",
    "title": "Attacks on Polio Vaccination Teams"
  },
  {
    "cluster_id": "d8b92399-bf69-4b82-b461-678acbb7e385",
    "title": "Ukraine funds Western creditors"
  },
  {
    "cluster_id": "db268f9a-c3a8-4e79-a3b0-df934c32f645",
    "title": "Ukraine expands its territory"
  },
  {
    "cluster_id": "3582a60f-77c5-4a28-b692-e25a35716357",
    "title": "Crimean Tatars: Homeland, Rights, Autonomy"
  },
  {
    "cluster_id": "db3b032b-6eb1-469a-8fea-f26d907c46cc",
    "title": "Ukraine nationalises PrivatBank"
  },
  {
    "cluster_id": "d169380d-3c63-4800-8f8c-5deedf749ffe",
    "title": "2015 Russian Film and Cultural Bans"
  },
  {
    "cluster_id": "73d00199-db31-4e40-9741-09d6ba45a825",
    "title": "Wisconsin Primary: Pandemic, Long Lines, Coverage"
  },
  {
    "cluster_id": "f0764df3-3340-4405-ac6d-daef15a6934d",
    "title": "Explosions at Kalynivka Depot"
  },
  {
    "cluster_id": "21240c8f-29c6-42ef-b002-a537a743739b",
    "title": "Association Between White Vaccination and Deaths"
  },
  {
    "cluster_id": "11423356-cdd9-4f07-af4c-408d43e6e2c4",
    "title": "Svitlodarsk Artillery Fire Report"
  },
  {
    "cluster_id": "db07f4e5-716a-41e4-989c-98ced62f8fd5",
    "title": "Questioning Vaccine Mortality Claims"
  },
  {
    "cluster_id": "f65ebec2-0122-4441-975a-e196ab928bdb",
    "title": "Unguided Rockets in Eastern Ukraine"
  },
  {
    "cluster_id": "d669c1ac-c710-4975-98db-1c778f28ee4c",
    "title": "Testing Stops, COVID-19 Disappears"
  },
  {
    "cluster_id": "d42df985-9fff-4c49-bac2-4cb2fef7ac9d",
    "title": "Spanish Media Call Ukrainian Emblem Ultra-Nationalist"
  },
  {
    "cluster_id": "81165fd5-dea5-41f8-ac75-66b97e1cca44",
    "title": "Sarcoma After Second Moderna Dose"
  },
  {
    "cluster_id": "7325cc3b-df7f-4451-948f-1ce21f12d10f",
    "title": "Ukraine loses economically from EU trade"
  },
  {
    "cluster_id": "9348816a-379b-4a83-98b4-cd843f9d8989",
    "title": "Euromaidan Protests and Yanukovych Ouster"
  },
  {
    "cluster_id": "7370dfbb-74ea-4d34-82b7-9398b71ecd5a",
    "title": "Vaccinated Elderly Still Affected by COVID"
  },
  {
    "cluster_id": "1755b95e-bb0b-46e8-acd8-b7de1925ed67",
    "title": "Crimea Sanctions and Restrictions (2014\u20132018)"
  },
  {
    "cluster_id": "23adce5a-77c2-4c07-98b6-ac6909360e17",
    "title": "Netherlands unlikely to ratify; seeks assurances"
  },
  {
    "cluster_id": "979b7171-b50b-4784-a226-a93eb757dfb4",
    "title": "Omicron: Reduced Vaccine Effectiveness"
  },
  {
    "cluster_id": "f2b7ea2e-02cf-4061-b076-60c350522e8d",
    "title": "Israel Vaccine Effectiveness Waning Amid Delta"
  },
  {
    "cluster_id": "98f59c42-164f-4444-8ecb-92a7e7c88a99",
    "title": "Vaccine misinformation: bacteria and HIV"
  },
  {
    "cluster_id": "814bcb42-2e0f-4cf8-87e3-c5b551e8ea66",
    "title": "EU pauses AstraZeneca over clot reports"
  },
  {
    "cluster_id": "59a2b2e2-fda5-435b-a046-bc1854ba1410",
    "title": "Seizures and Clashes in Eastern Ukraine"
  },
  {
    "cluster_id": "ae8f14c1-199b-4891-807b-1b7d4b91ad58",
    "title": "FDA narrows convalescent plasma to high-titer"
  },
  {
    "cluster_id": "eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc",
    "title": "US Security Assistance to Ukraine"
  },
  {
    "cluster_id": "f8a7db64-2922-40e3-9fc7-9a7934487f7f",
    "title": "Unidentified Forces Seize Crimean Airports"
  },
  {
    "cluster_id": "a5da6c97-e954-417b-b043-c6eda504cf34",
    "title": "cVDPV Outbreaks and WHO Statements"
  },
  {
    "cluster_id": "3a13abc2-f39c-460b-8768-7ccf1b11b40f",
    "title": "Rapid Trident Exercise at Yavoriv"
  },
  {
    "cluster_id": "e4c393f3-a213-40f3-ae1e-bc16b0f13a4f",
    "title": "Vaccines Increased COVID-19 Cases and Deaths"
  },
  {
    "cluster_id": "b0e81eaa-8bd7-4fe8-bd62-e10ea003f63f",
    "title": "Russia Captures Zaporizhzhia Nuclear Plant"
  },
  {
    "cluster_id": "de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe",
    "title": "EP accuses Poroshenko of political repression"
  },
  {
    "cluster_id": "5a089986-6a82-42ed-90a9-302a1ce45000",
    "title": "Western Funding for Ukrainian Security Forces"
  },
  {
    "cluster_id": "e6120475-8d62-4b1d-84b3-4c53f22ff855",
    "title": "Ukraine Struggles to Control Maverick Battalions"
  },
  {
    "cluster_id": "9d75c554-9eb9-4082-9c04-6fe3e303845e",
    "title": "Vaccination Guidelines for Pregnancy and Lactation"
  },
  {
    "cluster_id": "4c9bd8ca-0977-4844-9921-072e396e0fac",
    "title": "Initial EUA Approvals Since 2020"
  },
  {
    "cluster_id": "0d16b859-0b48-4545-ad3d-19b0d4601fe2",
    "title": "Media Spotlight on Bandera in 2015"
  },
  {
    "cluster_id": "4ae526b6-129a-4522-b79c-5fa5e53d2329",
    "title": "Pro-Russian Unrest in Eastern Ukraine"
  },
  {
    "cluster_id": "9b321e6e-fd77-47ca-b965-6aceb0683d37",
    "title": "Kyiv renames Moscow Avenue to Bandera"
  },
  {
    "cluster_id": "652f545a-2cde-41d4-9382-f23ab9d1b406",
    "title": "Unauthorised Russian Humanitarian Convoys into Ukraine"
  },
  {
    "cluster_id": "7ae0d854-6d40-40af-a578-9fbba79fb394",
    "title": "NATO Trident Juncture 2018 Exercise"
  },
  {
    "cluster_id": "c5a49990-0bec-49b9-8797-00d71805007a",
    "title": "Delta reduces symptomatic vaccine protection"
  },
  {
    "cluster_id": "016e2f4b-e8bd-4271-a6d5-2bf7dc3d49bc",
    "title": "SV40 in Human Tumors: Debates"
  },
  {
    "cluster_id": "0cf451c3-4981-46fc-b4ee-79c480a2a2b9",
    "title": "Zelensky-Putin Paris peace talks"
  },
  {
    "cluster_id": "ea70a7dd-0151-4733-b8dd-c6143a306c66",
    "title": "Lisbon Court of Appeal: PCR Reliability"
  },
  {
    "cluster_id": "4941b2f5-904f-4963-b690-18f3bf3075c7",
    "title": "Mask-type effects in Bangladesh trial"
  },
  {
    "cluster_id": "8a4a4131-add5-4367-8ccd-215684fa73dc",
    "title": "OSCE Reports Ongoing Donbas Violations"
  },
  {
    "cluster_id": "8cc0b8bd-92ac-4909-9ef3-f1df52b9f0f4",
    "title": "Lviv Protests Around Symbolic Sites"
  },
  {
    "cluster_id": "00386fb1-3dcc-4b4e-b74b-bc14dbc4e260",
    "title": "Israel Shelling Miscaptioned as Donetsk"
  },
  {
    "cluster_id": "f9a4fce8-b5c8-4697-808a-9ac08e5be52f",
    "title": "Separatist Leaders Before UN Security Council"
  },
  {
    "cluster_id": "771b0707-56ce-47d7-84ed-b75ab36dfd83",
    "title": "Oligarch-Backed Dnipro-1 Formation"
  },
  {
    "cluster_id": "4e101b24-e99b-4526-bcbc-e5ddeec46f80",
    "title": "Russia denies regular troops in Ukraine"
  },
  {
    "cluster_id": "09f4e973-2393-41aa-bdcb-ccd0efbed300",
    "title": "COVID-19 Vaccination and Blood Donation Guidelines"
  },
  {
    "cluster_id": "3092d2a7-23cc-41c3-b8bd-3096963a1b79",
    "title": "Ukraine Decommunization: Monument Renaming"
  },
  {
    "cluster_id": "add8105a-2d0f-4f9d-9f00-f11f0673121c",
    "title": "Israeli Second-Dose Myocarditis in Young Males"
  },
  {
    "cluster_id": "6d9d5966-6987-45bd-9e4b-02623878d470",
    "title": "NDAA FY2020: Ukraine Security Aid, Reporting"
  },
  {
    "cluster_id": "eb796d64-358d-4578-ad2f-2c3665e77d5e",
    "title": "Excess Mortality Up Through November 2022"
  },
  {
    "cluster_id": "b8ea1565-defe-4a1d-a235-40a614cdd9ce",
    "title": "SADS Registrations Rise, 2021\u201322"
  },
  {
    "cluster_id": "72f778c7-a74a-4822-89c7-75defc5fed4a",
    "title": "Volker in Ukraine: Donbas/Crimea Briefings"
  },
  {
    "cluster_id": "843bcba9-c863-41a3-a76f-01fd61d56529",
    "title": "Ukraine Credit Rating Drops"
  },
  {
    "cluster_id": "2d65299b-2b98-4ff0-9197-e120b19ce3bb",
    "title": "Putin's Essay on Russian-Ukrainian Unity"
  },
  {
    "cluster_id": "314510db-f67d-4268-b068-13a87261ae5b",
    "title": "Zelensky: Crimea Remains Ukrainian"
  },
  {
    "cluster_id": "269ffe65-bf3c-4500-8f51-b6ef7e6175ed",
    "title": "CDC Guide to Vaccine Additives"
  },
  {
    "cluster_id": "68152d77-1b3b-45af-8c06-88cf78f6a175",
    "title": "Ukraine Food Prices at EU Levels"
  },
  {
    "cluster_id": "856b24f4-0a37-4fe1-9808-5b1d1715aafd",
    "title": "COVID-19 Considerations for TB Care"
  },
  {
    "cluster_id": "74c516ce-db78-4790-b130-64ce1c94e700",
    "title": "Blinken in Kyiv: No NATO Promise"
  },
  {
    "cluster_id": "57d96007-f80d-4110-8583-3e280492b584",
    "title": "Focused Protection Over Lockdowns"
  },
  {
    "cluster_id": "d5458c27-5843-4ff6-b105-7703aeb6f588",
    "title": "Ukraine TB Surge Linked to Crisis"
  },
  {
    "cluster_id": "c7968790-1b36-4325-9e94-aa1c52a513a9",
    "title": "Dutch Vote Exposes Western Unreliability"
  },
  {
    "cluster_id": "8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35",
    "title": "Ukraine's Widespread Mine Contamination"
  },
  {
    "cluster_id": "872f71be-bb1a-40a1-8078-ee9f850ec42d",
    "title": "US-Ukraine Nuclear Safety Agreement"
  },
  {
    "cluster_id": "f51a6ac2-4516-4b4c-9fdb-e7e4932f790d",
    "title": "Donbas Exodus to Russia, 2014"
  },
  {
    "cluster_id": "5256265d-d143-4d8d-91b5-fc2bd6f31e20",
    "title": "Russia blames Ukraine for Donbas shelling"
  },
  {
    "cluster_id": "be9b7361-8150-4e4b-9111-bac990c11d3d",
    "title": "Kherson Nationalists Swear Allegiance to Hitler"
  },
  {
    "cluster_id": "29223456-9a08-4f68-9ce7-d62d961fb6aa",
    "title": "Ukraine faces collapse without IMF bailout"
  },
  {
    "cluster_id": "3b1f0ed9-3201-46c5-93e3-016f26c4d261",
    "title": "Explosion on the road to Komsomolske"
  },
  {
    "cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87",
    "title": "U.S. Delivers Javelin Missiles to Ukraine"
  },
  {
    "cluster_id": "2b9508d5-4552-4994-840b-08ab461e29c3",
    "title": "Zelensky Calls for Preemptive Nuclear Strike"
  },
  {
    "cluster_id": "ade1903f-a52a-4bb6-9a56-0c62e47b69bb",
    "title": "Dutch Advisory Referendum on EU-Ukraine Association"
  },
  {
    "cluster_id": "f239b4c3-e0cf-4725-9d59-2b1e32a9ad39",
    "title": "UN warns children of heating risk"
  },
  {
    "cluster_id": "8ab4584b-29ff-4c6c-b1fe-8e8438c3dfaf",
    "title": "Mask guidance for polling sites"
  },
  {
    "cluster_id": "f24d06ae-13b1-4550-a06c-444a9041ab60",
    "title": "Ninth Circuit Revives LAUSD Vaccine Case"
  },
  {
    "cluster_id": "ab8af083-dfdc-4c18-95cd-32d551c130c1",
    "title": "Ukraine's Law on Temporarily Occupied Territories"
  },
  {
    "cluster_id": "96a4146b-b919-413a-b5a7-7801adae1906",
    "title": "COVID Vaccine Linked to Miscarriages"
  },
  {
    "cluster_id": "6a8ee3bf-31a7-42b7-b481-4b21e09f4484",
    "title": "Global Leaders' 89-Page Pandemic Plan"
  },
  {
    "cluster_id": "c1308dd1-2ebf-4164-b9e3-2284bbfb088b",
    "title": "Texas Measles Outbreak Blamed on Vaccine"
  },
  {
    "cluster_id": "00d660d9-94af-474c-8e79-c16ac62cbef7",
    "title": "Ukraine's Decommunization Laws Enacted"
  },
  {
    "cluster_id": "ceb2f368-5934-45f6-bda4-01a19f923b7e",
    "title": "UK considers COVID-19 booster programmes"
  },
  {
    "cluster_id": "6207c1fd-d86c-4598-b9ed-72232636a976",
    "title": "Laws Recognizing Ukrainian Nationalist Formations"
  },
  {
    "cluster_id": "6ff6589f-46b8-4e3d-bfc9-65288f58e33b",
    "title": "Zelensky Doubts Minsk, Calls for Overhaul"
  },
  {
    "cluster_id": "00682147-64d4-4c37-88ac-2b9c31d6d40d",
    "title": "Bolsonaro Downplays COVID-19, Urges Reopening"
  },
  {
    "cluster_id": "4162c749-910d-4283-8cde-a365928f230d",
    "title": "Congress Passes Ukraine Support Act"
  },
  {
    "cluster_id": "5995c9ca-98e0-418d-a93b-a662311da0c9",
    "title": "UN Security Council Withholds Ukraine Aid"
  },
  {
    "cluster_id": "a65b71fa-08aa-4b20-91e3-c9e898591f07",
    "title": "Vaccine DNA contamination unseen by regulators"
  },
  {
    "cluster_id": "29244a34-6c97-4370-9081-3f30eca9f0d9",
    "title": "Limited Supply of mRNA Vaccine Materials"
  },
  {
    "cluster_id": "731d7658-b5f1-4356-b7c0-c3b8c97cac8d",
    "title": "OSCE condemns killing of journalist Buzina"
  },
  {
    "cluster_id": "9352b2a0-83e7-4ffa-ae39-61c24aa700b8",
    "title": "Ukraine curbs freedom of assembly"
  },
  {
    "cluster_id": "65e251ce-15b5-4f60-b87b-ef28a1709b53",
    "title": "Ukraine Recession Causes 2014\u201315"
  },
  {
    "cluster_id": "bac748cb-b035-4e91-bb5a-ab935807284d",
    "title": "COVID-19 Outbreak on USS Theodore Roosevelt"
  },
  {
    "cluster_id": "7bdd8e86-1a5c-4cda-a846-8ddfcadc8007",
    "title": "Russia Blocks Ukrainian Transit, 2014"
  },
  {
    "cluster_id": "43beda49-4348-4ff0-94eb-8102078e161d",
    "title": "COVID-19 Not Deadlier Than Flu"
  },
  {
    "cluster_id": "358c0eb2-869f-46fb-bab5-4fbe8881d4e8",
    "title": "Rising Pediatric iGAS and Scarlet Fever"
  },
  {
    "cluster_id": "9993ea09-c44e-4372-864a-21c7f72c7eef",
    "title": "Provincetown Breakthrough Infections"
  },
  {
    "cluster_id": "e3e4b634-fa33-47d8-9f29-eefdbb263769",
    "title": "Germany Suspends COVID-19 Vaccinations"
  },
  {
    "cluster_id": "e130a374-b2e7-4d68-8a8e-32dcab17656b",
    "title": "Chernobyl 2015 Fires: Radionuclide Resuspension"
  },
  {
    "cluster_id": "2cf7e8e6-c492-424f-8353-8feea83e3711",
    "title": "Violence against journalists in Ukraine (2014\u201315)"
  },
  {
    "cluster_id": "e15d8f08-e424-41bc-9193-92e22c4d515c",
    "title": "Spike vs Nucleocapsid in Antibody Messaging"
  },
  {
    "cluster_id": "7a0efb78-9055-433c-904f-79dc94ad2203",
    "title": "Long Vax: 70% Post-Vaccine Symptoms"
  },
  {
    "cluster_id": "2ca6b1f5-ce3d-4e72-98a8-f750a42081ac",
    "title": "Ukraine Market and Price Pressures, 2017"
  },
  {
    "cluster_id": "da455fdd-d1bf-4166-b24f-377899985b7c",
    "title": "Crimean Tatar Protest Against Annexation"
  },
  {
    "cluster_id": "e37c8f7a-2656-421b-b216-1d87659bcb44",
    "title": "Debunked Claim: Vaccines Include Cancer Genes"
  },
  {
    "cluster_id": "88fadd59-b242-4ad4-ab5b-3465e7a2b5a6",
    "title": "ATR Banned in Occupied Crimea"
  },
  {
    "cluster_id": "1faa9d4d-1b1c-4e6c-9fd5-22f9b057a61b",
    "title": "Emergent Baltimore Plant Contamination Crisis"
  },
  {
    "cluster_id": "9eb9a341-e59f-4fbf-b178-ccb6bb25eb49",
    "title": "Hungary blocks NATO\u2013Ukraine over education law"
  },
  {
    "cluster_id": "7a2f4f21-3ae3-4d01-b8e3-e3fd8670db5a",
    "title": "Maidan Sniper Shootings: Responsibility Contested"
  },
  {
    "cluster_id": "20ab2459-a6a0-4e45-aef0-5b2d6b529a0e",
    "title": "Military Pressure on Crimeans for Annexation"
  },
  {
    "cluster_id": "4d8a4d68-4905-4d57-b3f8-91de6feb19b0",
    "title": "Rada Recognizes OUN-UPA as Independence Fighters"
  },
  {
    "cluster_id": "540c45cf-a148-4629-8716-b1631ea44e45",
    "title": "Origin of the MRC-5 Cell Line"
  },
  {
    "cluster_id": "382c8bbe-8826-4b13-8317-0d73ee7eee77",
    "title": "Underplaying Ukraine's Far Right Role (2014)"
  },
  {
    "cluster_id": "5bbc7620-dddd-48b2-ab59-dca397c2985e",
    "title": "Ukraine Signs EU Association Agreement"
  },
  {
    "cluster_id": "6c48832c-2b96-4ee8-9b48-4611e67b38f0",
    "title": "Assassination of Russian Defector in Kyiv"
  },
  {
    "cluster_id": "cfcddae8-7e4d-4fb6-8a06-45fdad19422f",
    "title": "Ukraine Enacts Decommunization Laws"
  },
  {
    "cluster_id": "00d7befc-64bd-4735-b672-5969c77fe7d6",
    "title": "Complexities of Linking Vaccination Deaths"
  },
  {
    "cluster_id": "70862016-3977-4b4b-9e68-43859faa28ba",
    "title": "Delta Reduces Pfizer Vaccine Effectiveness"
  },
  {
    "cluster_id": "1a660b55-5f53-4246-a227-98df9e4e2ac4",
    "title": "Fascism Returns to Ukraine"
  },
  {
    "cluster_id": "ebcc0902-6e47-4925-9d19-ac06d520106b",
    "title": "UN Security Council: Ukraine-Crimea Crisis"
  },
  {
    "cluster_id": "0e839111-b99e-4caa-8ece-e80f0ea67970",
    "title": "2014 Infrastructure Attacks in Eastern Ukraine"
  },
  {
    "cluster_id": "edd65f26-0117-4202-bd31-c3f265210b5e",
    "title": "Ukraine to jail Russian passport holders"
  },
  {
    "cluster_id": "0ca4759c-9c4f-421f-b2d0-dbefe4601911",
    "title": "FDA Approves JYNNEOS Vaccine"
  },
  {
    "cluster_id": "839faa06-15df-459d-8f1d-015981c670e0",
    "title": "EU Ignores Russia Donbas Passports"
  },
  {
    "cluster_id": "5219fa36-fd8a-41f9-b4a4-5e01b881c12c",
    "title": "Reimposed Lockdowns After Easing"
  },
  {
    "cluster_id": "213e0c4f-0911-44fc-89bf-cf985adbc12e",
    "title": "Infant mortality up 3% in 2022"
  },
  {
    "cluster_id": "45c15578-ca19-42ef-8fc5-04e77034e4c3",
    "title": "Monitoring Residual Host-Cell Proteins in Biologics"
  },
  {
    "cluster_id": "3e87987a-c8cd-4616-922a-e297f103d0fa",
    "title": "AstraZeneca Vaccine Clotting Concerns"
  },
  {
    "cluster_id": "a6f2fc25-ee4d-4748-9248-d40e233dda78",
    "title": "U.S. Measles Outbreak: 25-Year High"
  },
  {
    "cluster_id": "2dbc4a6b-98c2-45e2-be58-a00cfa47819c",
    "title": "UK Guidelines for COVID Medical Exemptions"
  },
  {
    "cluster_id": "4feed713-e2b7-4de9-a6e7-cb0e0ca52183",
    "title": "Pfizer Lists 40+ Vaccine Side Effects"
  },
  {
    "cluster_id": "6a3f5b65-ac92-4e63-91ac-fe203f06931f",
    "title": "Drones Attack Black Sea Fleet"
  },
  {
    "cluster_id": "3356bac0-8ec4-475b-81a7-e146187a74ba",
    "title": "SARS-CoV-2 spike antibodies cause myocarditis"
  },
  {
    "cluster_id": "ef77006d-68d7-4c27-ae83-cb85890ca2b1",
    "title": "Minsk II Ceasefire Roadmap"
  },
  {
    "cluster_id": "8d1da449-ead9-4d20-b9d7-330964de7727",
    "title": "NTI releases 2021 tabletop exercise summary"
  },
  {
    "cluster_id": "9a201ba4-4fa1-4a8f-b530-b70790363696",
    "title": "Court grants Gardasil safety data access"
  },
  {
    "cluster_id": "421f3ec9-adff-4513-86c4-d1e8d810a087",
    "title": "May 8 Remembrance; May 9 Changes"
  },
  {
    "cluster_id": "b4d4265f-dae0-43eb-9010-fb5c59968803",
    "title": "Public Controversy over Kyiv Vatutin Monument"
  },
  {
    "cluster_id": "9612bbf2-b65c-410c-9475-7ee689b849d9",
    "title": "Promoting Ukrainian in Kyiv Public Life"
  },
  {
    "cluster_id": "bf3cbbb2-0711-45ee-a625-a3ccf159845b",
    "title": "No Obvious Human-to-Human Transmission Evidence"
  },
  {
    "cluster_id": "5530b92f-dd56-42af-8c16-6aabb4ffa553",
    "title": "Tryzub in Nationalist Paramilitary Groups"
  },
  {
    "cluster_id": "88a95916-de94-4c29-849b-89f8018ddf03",
    "title": "Poroshenko sacks Kolomoisky; pocket armies condemned"
  },
  {
    "cluster_id": "4a91c427-d613-4080-adab-a06fc13d13ac",
    "title": "Ukrainian admiral praises Russia in Crimea"
  },
  {
    "cluster_id": "6f960627-d475-4f28-8eb0-dcceb972aad4",
    "title": "Polio Vaccines Contaminated with SV40"
  },
  {
    "cluster_id": "ce538c96-9586-4a44-b4ec-f9e46a72b4b0",
    "title": "Co-circulation of Pediatric Respiratory Viruses"
  },
  {
    "cluster_id": "a41257e1-1e51-49b3-bf04-5fbb3ef2f25b",
    "title": "Nationwide Ukrainian Language Reform"
  },
  {
    "cluster_id": "bd48a2e4-20c5-4fa2-90a9-0725e3288c94",
    "title": "International Coverage of Ukrainian Far-Right Imagery"
  },
  {
    "cluster_id": "f54e9fc4-9854-41c6-aa04-dba66f36cc19",
    "title": "Israel Sees Delta Breakthrough Infections"
  },
  {
    "cluster_id": "8d565c91-b887-465d-a08e-aff09b1e9e5b",
    "title": "Crimea for NATO Membership"
  },
  {
    "cluster_id": "d7623a03-cd91-4c2e-b68a-db4e5ad54fa8",
    "title": "Booster Indicates Initial Vaccine Failure"
  },
  {
    "cluster_id": "77fd60bb-096a-4b70-a630-b56ef3e8f647",
    "title": "Ukrainians Favor Peace With Caveats"
  },
  {
    "cluster_id": "ef49913c-d983-49cf-b90f-4529857c36a4",
    "title": "EU Reinstates Georgia Visa, Ukraine Next"
  },
  {
    "cluster_id": "92ec2cbf-b9b0-4664-a8a7-ef9ea075d88c",
    "title": "Reduced neutralization of variants by sera"
  },
  {
    "cluster_id": "a4d91f10-cd48-4917-90ab-b14ea36168d9",
    "title": "Repeated off-site power losses at Zaporizhzhia"
  },
  {
    "cluster_id": "e11231dd-53ef-41bf-966c-4a202aa2895c",
    "title": "Oxford COVID Vaccine Trial Volunteer Dies"
  },
  {
    "cluster_id": "7e3014ad-3100-4bc7-8edd-4e32af49ff75",
    "title": "Ukraine imposes partial martial law"
  },
  {
    "cluster_id": "f8d1571f-9c56-4682-8574-cd3b32ed6cc6",
    "title": "US Seroprevalence Reveals Widespread Antibodies 2021"
  },
  {
    "cluster_id": "078eb0c7-fae2-4ffa-b527-48c6683af72e",
    "title": "Zelensky: Eliminate Russian Nuclear Threat"
  },
  {
    "cluster_id": "73ac3211-808b-4905-b95e-ccdafdc4bd5d",
    "title": "mRNA-LNPs Strongly Modulate Innate Immunity"
  },
  {
    "cluster_id": "b9cc9dc2-9dcc-4730-b5fd-d7d5a7f9e126",
    "title": "Ilovaisk Battle and Civilian Casualties"
  },
  {
    "cluster_id": "09a67b60-49c6-4757-b8ff-5613fc63f6fe",
    "title": "Russia Demands NATO Guarantees, No Expansion"
  },
  {
    "cluster_id": "8b198c30-0c8c-4abd-b13a-0e55963e8bb8",
    "title": "Italy Redefines COVID-19 Death Toll"
  },
  {
    "cluster_id": "c6d9c90d-92a1-44da-a5cd-12164b95f4d8",
    "title": "Azov Battalion: Neo-Nazi Ties"
  },
  {
    "cluster_id": "bf53e706-320e-4307-85d6-fcee526f5f17",
    "title": "Misinformation: vaccines cause cancer."
  },
  {
    "cluster_id": "6288e205-b9e8-41be-a3f8-80b06b50c037",
    "title": "Vaccine clot misinformation"
  },
  {
    "cluster_id": "6a4e66c3-1fd2-46be-9e31-fecdcd545826",
    "title": "Ukraine: Second Chernobyl Threat in Russia"
  },
  {
    "cluster_id": "3594d516-c429-465e-9ac8-b4d9801acd0d",
    "title": "DANMASK-19 Shows Limited Mask Protection"
  },
  {
    "cluster_id": "26461fc6-994b-44dd-97c8-95b6341a4a6a",
    "title": "Ukrainian PM calls Luhansk, Donetsk \"untermensch\""
  },
  {
    "cluster_id": "f3affcd0-acdc-481e-ad0d-c22c5984f9af",
    "title": "UK 2022 Excess Deaths Debate"
  },
  {
    "cluster_id": "0179bab7-45d2-4b90-aa4d-c6afb970dbc5",
    "title": "Ukrainian forces shelled bus near Volnovakha"
  },
  {
    "cluster_id": "556da1e6-535a-4511-ac9b-649cb3eafe84",
    "title": "Lviv imposes moratorium on Russian media"
  },
  {
    "cluster_id": "8c92c9ea-d03e-4ce1-b80a-21678d736eec",
    "title": "Parliament Repeals 2012 Language Law"
  },
  {
    "cluster_id": "9687983c-2f58-4f1f-9d09-86f19210af37",
    "title": "Minsk II: Preconditions for Donbas Elections"
  },
  {
    "cluster_id": "dfa47852-ac3f-4b74-bc17-22923a395552",
    "title": "Monkeypox Vaccine Conspiracy Theory"
  },
  {
    "cluster_id": "6f908336-dbeb-4b80-ae57-9e0431081831",
    "title": "Fall of Sievierodonetsk: Russian Capture"
  },
  {
    "cluster_id": "7957f359-526a-4b55-928e-2a84077427a5",
    "title": "EU Non-Recognition, Visa for Donbas Passports"
  },
  {
    "cluster_id": "dae1826c-9197-4507-aadd-a2ba9a01285b",
    "title": "NBU Extends Loan Repayment, Provides Liquidity"
  },
  {
    "cluster_id": "da4e5cde-efc2-4363-87b4-b9935cc2b21d",
    "title": "Vaccines Linked to Serious Adverse Events"
  },
  {
    "cluster_id": "3c9c2d2f-29ac-414f-a514-d694db25f871",
    "title": "Disputed Vaccine-Myocarditis Claims"
  },
  {
    "cluster_id": "35dec8e7-d2c1-441c-82d1-0fb7c4ff2ec4",
    "title": "Japan withdraws Urabe MMR over meningitis"
  },
  {
    "cluster_id": "216c68fc-7c8f-405c-8f46-568b32c69eb4",
    "title": "NATO Black Sea drills provoke Russia"
  },
  {
    "cluster_id": "f21aa624-4667-4f48-bb4c-1942acec5158",
    "title": "NATO Expands Black Sea Patrols"
  },
  {
    "cluster_id": "d012c47c-3d49-4f8a-9fcf-db101ff82249",
    "title": "Ukraine to intern Russian citizens"
  },
  {
    "cluster_id": "25e8666d-6596-4996-8765-9de5aa51e568",
    "title": "BNT162b Vaccine Protects Macaques"
  },
  {
    "cluster_id": "7d0b4f2d-8055-491e-a0df-31787da0b9a8",
    "title": "State Control of Azov Battalion, 2014"
  },
  {
    "cluster_id": "1991b6cd-3baa-475c-add7-d4b101a0de09",
    "title": "Vaccine-Linked Placental Abnormalities"
  },
  {
    "cluster_id": "c9760dda-4208-40ee-a4e1-20fd95324ecd",
    "title": "England Ends Legal Self-Isolation Duty"
  },
  {
    "cluster_id": "4892691c-c25d-434c-bfaf-8b1764a0e393",
    "title": "Ukraine Hides Ammo, Attacks Zaporizhzhia NPP"
  },
  {
    "cluster_id": "9f57df89-5e8e-4a14-b028-a41d27973fb5",
    "title": "Ukraine jails Russians for Crimea visit"
  },
  {
    "cluster_id": "9560d5ee-30e3-4941-88b8-e0b5144961cb",
    "title": "Vaccines Contain Cancer-Causing Enzymes"
  },
  {
    "cluster_id": "c5855521-5ebf-478e-a7af-b3f07554a912",
    "title": "Contested COVID Vaccine Safety Claims"
  },
  {
    "cluster_id": "1e2f3c33-51a9-4ade-8539-40a4bc9cfff8",
    "title": "Hospitals Deny Care to the Unvaccinated"
  },
  {
    "cluster_id": "c0ac6691-abf2-4873-a338-41a4997bcb24",
    "title": "Sea Breeze Multinational Exercises"
  },
  {
    "cluster_id": "499883aa-4d50-44a0-85ba-67de7dd41a9e",
    "title": "Pfizer 3 microgram pediatric dose EUA"
  },
  {
    "cluster_id": "b2e1f729-9431-42cc-affc-159e60e3c7e6",
    "title": "Violence and Obstruction in Crimea Referendum"
  },
  {
    "cluster_id": "d42f0707-162e-449e-86fe-0dd5e2885a21",
    "title": "Donbas Residents Forced Resettlement to Lviv"
  },
  {
    "cluster_id": "428a1c85-5fee-4a1d-bbe0-9e71872e75e9",
    "title": "Lviv Officer Proposes Revoking Courage Order"
  },
  {
    "cluster_id": "2c68a882-a903-4629-aeb4-3d0034f94771",
    "title": "Regulatory Pauses Over AstraZeneca Clots"
  },
  {
    "cluster_id": "1eb307cf-2274-463b-9ab8-19aee3397703",
    "title": "Ukraine Breaks Promise, Normandy Meeting Canceled"
  },
  {
    "cluster_id": "e21b1b35-31f0-4c02-9069-b35c0b38b172",
    "title": "One in 500 Pediatric Vaccine Injuries"
  },
  {
    "cluster_id": "be379179-357e-431a-afc7-707de2663f0c",
    "title": "Russia Cuts Gas Amid Pricing Dispute"
  },
  {
    "cluster_id": "c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e",
    "title": "Ukraine Faces New Language Divisions"
  },
  {
    "cluster_id": "c8c0e353-5277-4897-8ef8-4773b9d6e6cb",
    "title": "Crimean Tatars Grateful to Stalin"
  },
  {
    "cluster_id": "8a7264fa-6b7e-44f6-b1f1-5b3267bbd42d",
    "title": "Eastern Ukraine Death Toll Exceeds 6,000"
  },
  {
    "cluster_id": "2c62c383-cda1-4d02-9286-63fc5fe04c15",
    "title": "DIVI Adds ICU Vaccination Fields"
  },
  {
    "cluster_id": "6ac5b48b-0333-47a6-8d5d-318886958930",
    "title": "UN Warns of Ukraine Catastrophic Needs"
  },
  {
    "cluster_id": "3ba005de-dec0-4cc4-8a3c-a3679d6f072a",
    "title": "Russian Air Defenses in Crimea"
  },
  {
    "cluster_id": "96226cbe-6ce7-473a-a2c5-bcfa1fa15be9",
    "title": "Red Cross aids Ukraine measles outbreak"
  },
  {
    "cluster_id": "14266895-ce35-4bb7-b24c-c5684c3a1532",
    "title": "Critics warn law harms minority languages"
  },
  {
    "cluster_id": "f8e7dcff-d078-4ce8-9ad3-495ed7c19774",
    "title": "Ukrainian Soldier Looting in Chechnya"
  },
  {
    "cluster_id": "e01a8825-f8eb-425d-b928-eda6b3f57929",
    "title": "Steadfast Noon Nuclear Exercise Begins"
  },
  {
    "cluster_id": "f3191f0a-3803-4bca-ad51-304e3f825638",
    "title": "IMF Approves Large Ukraine Loan"
  },
  {
    "cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
    "title": "Ukrainian Becomes Sole Official Language"
  },
  {
    "cluster_id": "7ebece62-a589-49b3-b28f-b8f565ab7327",
    "title": "Long COVID: Belief-Driven, Not Real"
  },
  {
    "cluster_id": "62c5acb9-493e-43c7-9647-7858b2ea0c50",
    "title": "Waning antibody levels after vaccination"
  },
  {
    "cluster_id": "be6b5f43-b5a5-43db-8bdd-0c041f0efa31",
    "title": "End Abuses by Pro-Ukrainian Battalions"
  },
  {
    "cluster_id": "efe98b1b-e1ed-468a-9652-7acc5550430a",
    "title": "Updated WHO COVID-19 Mask Guidance"
  },
  {
    "cluster_id": "fc5c504b-230e-408e-a170-afd09cbd04d4",
    "title": "Scientists Demonstrate Masks Block Droplets"
  },
  {
    "cluster_id": "d6d62bcd-4470-422b-bfb3-13d5db2da751",
    "title": "U.S. Life Expectancy Declines in 2021"
  },
  {
    "cluster_id": "6d28f7f0-c971-4fc7-ba26-4c3da49fc8c8",
    "title": "Bangladesh Mask Promotion Trial: Nuanced Results"
  },
  {
    "cluster_id": "3aad1795-c40d-46c7-abc6-a9e8928bc743",
    "title": "Ukraine grants Donetsk, Luhansk special status"
  },
  {
    "cluster_id": "49c4c056-d70c-4a38-9178-06a4f74c1135",
    "title": "UN urges ceasefire over Zaporizhzhia shelling"
  },
  {
    "cluster_id": "07b11e06-46ec-45e9-8f01-bc31083fd0de",
    "title": "Russia Seizes Zaporizhzhia Nuclear Plant"
  },
  {
    "cluster_id": "1bb2fbd1-906a-4d81-b23d-f6c0a4024661",
    "title": "Derussification in Ukraine: Toponyms and Monuments"
  },
  {
    "cluster_id": "b98bf259-2428-4cda-a309-5be4fdb0c3ef",
    "title": "Kolomoisky-Linked Occupation of Oil Offices"
  },
  {
    "cluster_id": "ab1bcfd5-bef2-4f73-aff0-790c6f681ce4",
    "title": "Limited vaccine supply; prioritize high-risk groups"
  },
  {
    "cluster_id": "4da30c02-5a8f-4e15-af9d-b0a7ede85a55",
    "title": "Russia's Donbas Passportization"
  },
  {
    "cluster_id": "248cf9f0-85b2-4eae-9028-789470700e69",
    "title": "GDP Contraction Amid 2014\u201315 Conflict"
  },
  {
    "cluster_id": "d2828cf5-cc91-4e95-82bf-be47e19b88ee",
    "title": "Real-World Pfizer Vaccine Effectiveness in Israel"
  },
  {
    "cluster_id": "06451ed7-032d-45e3-9726-f485fc31a739",
    "title": "Ukraine Adopts State Language Law"
  },
  {
    "cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
    "title": "Claims of mRNA vaccine harm"
  },
  {
    "cluster_id": "ebdd6e62-4f71-4eeb-b5bb-afa4c515a612",
    "title": "Prominent Right Sector Violence in Euromaidan"
  },
  {
    "cluster_id": "91a2ed36-3e87-4baf-9999-c65078a62cbd",
    "title": "MH17 Downed Over Ukraine"
  },
  {
    "cluster_id": "61f48759-d4cb-40cb-8dc9-13b564dd8c1b",
    "title": "V-Safe Pregnancy Registry Data Release"
  },
  {
    "cluster_id": "530c303c-a794-4be5-bbc2-ff618ab75d38",
    "title": "Ukraine Rebrands ATO as JFO, Escalates"
  },
  {
    "cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
    "title": "Sanctions and Trade Damage Ukraine's Economy"
  },
  {
    "cluster_id": "abef27a8-3e24-43c9-9823-523dd607d49a",
    "title": "Japan's Excess Mortality: Cardiovascular Deaths"
  },
  {
    "cluster_id": "07438861-a868-47ed-8a1a-288138dc65c0",
    "title": "Crimean Tatars Seek Turkish Recognition"
  },
  {
    "cluster_id": "0368ead8-8d25-41a1-9249-88baff9335b0",
    "title": "Delta reduces Pfizer infection protection"
  },
  {
    "cluster_id": "23f623bb-83de-47ba-a19b-9df053aaf2d2",
    "title": "NATO Reaffirms Ukraine Support"
  },
  {
    "cluster_id": "acf3ef41-5374-4f21-834c-c4a11d955ee1",
    "title": "Operation Warp Speed to Accelerate Vaccines"
  },
  {
    "cluster_id": "fd231a27-03e0-4839-bed2-513e10b79733",
    "title": "U.S. Sends Military Aid to Ukraine"
  },
  {
    "cluster_id": "efd04eb7-8311-4730-bee6-1df74b27a996",
    "title": "Chechen Fighters in Donbas with Separatists"
  },
  {
    "cluster_id": "4ac1da2e-cd03-4a11-b440-f62dc8f73aad",
    "title": "Tatars Demand Renaming of Crimea"
  },
  {
    "cluster_id": "8d628785-9843-475a-bf8c-f7eff1bc8e38",
    "title": "Extra-legal Self-defence and Arms Proliferation"
  },
  {
    "cluster_id": "93f03d20-e5b7-41c5-976e-5122f884847a",
    "title": "U.S. Strikes Syrian Airbase"
  },
  {
    "cluster_id": "1e061f92-2688-4d15-8cdc-93767b97df6b",
    "title": "Waning Vaccine Effectiveness and Vaccinated Cases"
  },
  {
    "cluster_id": "7a87a2e6-b475-458d-ad14-3c21326625db",
    "title": "Torchlit Rallies Honoring Bandera"
  },
  {
    "cluster_id": "63114462-4942-4f84-9437-7c2bd611b2f3",
    "title": "Poroshenko's Approval Decline Signals Vulnerability"
  },
  {
    "cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc",
    "title": "Japan Moderna Vaccine Contamination Triggers Recalls"
  },
  {
    "cluster_id": "596b866e-0c38-462e-b0b0-eee502c092aa",
    "title": "Vaccine Hesitancy and Misinformation Threats"
  },
  {
    "cluster_id": "d7524d60-e45b-419a-8a13-87cf67bfd8e5",
    "title": "Villagers Attack Vaccine Crew"
  },
  {
    "cluster_id": "063191cf-9936-4d33-8783-201496475d0e",
    "title": "FDA Warns Statins: Memory Loss, Diabetes Risk"
  },
  {
    "cluster_id": "0867ca4e-1775-4423-92bf-6fc8d1d9c0e3",
    "title": "Hryvnia Plunges After Policy Change"
  },
  {
    "cluster_id": "cf6c1c0d-fc13-4eb6-a686-91e7d8509399",
    "title": "EU Grants Georgia 90-Day Visa-Free Travel"
  },
  {
    "cluster_id": "8ef3f5ab-a5d7-4598-bbc0-95b969a66cac",
    "title": "Russian Crackdown on Crimean Tatars"
  },
  {
    "cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
    "title": "COVID Vaccines Linked to Heart Damage"
  },
  {
    "cluster_id": "b7bef44a-7480-409a-8790-0a70b42045ee",
    "title": "Alleged Ukrainian Nuclear Provocation and Attacks"
  },
  {
    "cluster_id": "2f6021e2-bde5-4c10-ae2b-194bf6a93505",
    "title": "Ukraine to Lift Sanctions on Russia"
  },
  {
    "cluster_id": "41895296-6f09-4b44-a2d4-3d90f2e03b81",
    "title": "Crackdown on Crimean Tatars"
  },
  {
    "cluster_id": "6289781a-230a-4b8d-94dc-f3adadc4495d",
    "title": "Regulatory Pauses on AstraZeneca TTS"
  },
  {
    "cluster_id": "81174c72-fc84-4203-8dcb-b1068c7bd254",
    "title": "Poroshenko Allows Civilian Gun Ownership"
  },
  {
    "cluster_id": "237a5318-2edd-4ffc-869f-c0fed9502097",
    "title": "Hryvnia Collapse Looms for Ukraine"
  },
  {
    "cluster_id": "0587530d-6a6d-4aa0-9e34-087698c923aa",
    "title": "Ukraine distributes WWII commemorative medals"
  },
  {
    "cluster_id": "f6ad38c8-1553-418f-93f5-4a6bb4909e2b",
    "title": "OSCE notes unmarked graves near Komunar"
  },
  {
    "cluster_id": "82ba7adb-7963-4264-baad-21315bacde1d",
    "title": "Volnovakha Bus Attack Near Checkpoint"
  },
  {
    "cluster_id": "40265b93-5ea0-4bd6-8b7d-972baab54b70",
    "title": "Majorities Back Negotiations and Preconditions"
  },
  {
    "cluster_id": "c3f83d4c-9f83-4fe3-befa-1e9b93dee510",
    "title": "Ukraine's Organ Trafficking Scandal"
  },
  {
    "cluster_id": "d6e4581d-8b56-4f44-aadb-7c57a4d3eb29",
    "title": "McCain Visits Maidan, Backs Protesters"
  },
  {
    "cluster_id": "d211ea4f-25c6-49b0-b039-be55cbe6e301",
    "title": "Ilovaisk 2014: Evidence of Russian Armor"
  },
  {
    "cluster_id": "2d39c2e2-591e-4b57-a739-0d6203a1a49f",
    "title": "Israel Launches Booster for Seniors"
  },
  {
    "cluster_id": "fd5ddb7c-f743-498e-b007-014e9c97bbc8",
    "title": "Mixed Vaccination Effects on Long COVID"
  },
  {
    "cluster_id": "467eec25-d0de-412a-9f09-8a0db03d60ae",
    "title": "Donbas Reintegration Law Labels Russia Aggressor"
  },
  {
    "cluster_id": "33fe2055-c6c1-46ed-8871-fc741999d32b",
    "title": "Government Claims Vaccines Superior, Masks Effective"
  },
  {
    "cluster_id": "400218af-6cc1-4f06-8e3d-7804bde6ad17",
    "title": "Vaccine-Linked Cancer Rise Lowers Life"
  },
  {
    "cluster_id": "f9e1ae92-90cd-4553-9870-a06691bcf1d5",
    "title": "Russia expands maritime claims after annexation"
  },
  {
    "cluster_id": "0fa8aef0-deff-4ac5-a935-94011ed8be80",
    "title": "Pro-Russian Seizure of Crimea"
  },
  {
    "cluster_id": "00e4e855-edbf-4846-a824-47a6b221930a",
    "title": "United States Recognizes Donetsk People's Republic"
  },
  {
    "cluster_id": "0a78e568-4aaf-4a3c-a4c0-d484ec60f776",
    "title": "SBU arrests four for uranium smuggling"
  },
  {
    "cluster_id": "8a1337a6-24c6-4382-8169-4bec0e1a4fab",
    "title": "Media attention to vaccine-associated myocarditis"
  },
  {
    "cluster_id": "0ea60366-ef97-44ac-91be-b38d55efb0c3",
    "title": "Crimean Tatars Support Putin in March"
  },
  {
    "cluster_id": "9d8e9597-3167-4e1c-94bb-e686324d37e0",
    "title": "OPEC Holds Output, Oil Falls"
  },
  {
    "cluster_id": "a2925234-109d-4c57-aac5-814b5a99a831",
    "title": "Rapid Marginal Zone Lymphoma Progression Post-Vaccine"
  },
  {
    "cluster_id": "4d35ec7a-3721-4f70-b323-8070302a4c95",
    "title": "Ukraine\u2019s 2014\u201315 Economic Contraction"
  },
  {
    "cluster_id": "5d65069d-5cc8-4da8-8b8d-bbd1528688e7",
    "title": "COVID-19 Less Deadly Than Seasonal Flu"
  },
  {
    "cluster_id": "367c1ab5-4267-4b68-a2ed-2893d2797c11",
    "title": "COVID-19 Death Certification and Coding"
  },
  {
    "cluster_id": "dffdac1b-ba6f-48b2-97f4-02cb8656a37e",
    "title": "Ukraine Rate Hike, IMF Delay Risk"
  },
  {
    "cluster_id": "8bd4a872-0209-415e-a7b8-b4acaf26a95b",
    "title": "Autopsy study: possible vaccine-induced myocarditis"
  },
  {
    "cluster_id": "fedc3a0d-9f9d-4e04-81a3-669b447f0bcb",
    "title": "Staged Crimean Tatar Congress Propaganda"
  },
  {
    "cluster_id": "67cff5df-1bcb-4edc-af42-99ff9df792c5",
    "title": "Controversy Over Early Corman\u2013Drosten PCR"
  },
  {
    "cluster_id": "9d6f335e-c5fe-40ff-9edc-7ee5892fafaf",
    "title": "Unverified pediatric vaccine-death claim"
  },
  {
    "cluster_id": "734aba7a-e1ac-4a78-a926-3957017f7843",
    "title": "EU Ends Ukrainian Visa-Free Travel"
  },
  {
    "cluster_id": "04b0fab9-75f9-45a3-8f7f-91f5ed199dc0",
    "title": "Moderna CEO's Pre-Planned Insider Sales"
  },
  {
    "cluster_id": "f4253f2e-cf0c-4fcc-9979-cb25e723158b",
    "title": "Debate Over Natural Immunity Durability"
  },
  {
    "cluster_id": "5b6da2ab-36ee-4cfe-968a-ce42565405bc",
    "title": "Ukraine GDP halved by sanctions"
  },
  {
    "cluster_id": "db101c75-2320-4597-b222-b7197dc49dc4",
    "title": "Ukraine Blacklists Russian Artists Over Crimea"
  },
  {
    "cluster_id": "a5706e56-c643-44be-8e44-3c19fd9dcc29",
    "title": "Contested vaccine risk-benefit claim"
  },
  {
    "cluster_id": "1e2e215d-02f8-41f2-bb72-8bb5cf8991d4",
    "title": "Public Pfizer Documents via FOIA 2022"
  },
  {
    "cluster_id": "976266ce-5c9b-4a82-9062-52ac4f4dcbd6",
    "title": "Ukrainian Strikes in Crimea 2023"
  },
  {
    "cluster_id": "dd4670c3-7e44-4c76-a7d9-373ad6cb6c50",
    "title": "Zelensky's 2019 Steinmeier Formula Stance"
  },
  {
    "cluster_id": "728de5c6-3345-44e8-91f4-5ab1fb0c6670",
    "title": "Lund Study: mRNA Reverse Transcription"
  },
  {
    "cluster_id": "600431fd-692e-4209-97b9-71af21abedf4",
    "title": "Investigation and Recall After Japan Findings"
  },
  {
    "cluster_id": "abea76a9-3994-48b0-b3bb-df2d7f55ad12",
    "title": "Updated Vaccination Guidance After Infection"
  },
  {
    "cluster_id": "e3df2907-4da7-4352-a8ae-dd0543915bd1",
    "title": "EU Establishes East StratCom Task Force"
  },
  {
    "cluster_id": "921fce8d-f4e2-4dbe-b940-66b148c09f17",
    "title": "Zelensky sanctions, blocks pro-Russian channels"
  },
  {
    "cluster_id": "f3cb984c-8736-4ad2-8cd8-5ca9f90033d5",
    "title": "Media Hype, Ignores Vaccine Injuries"
  },
  {
    "cluster_id": "825bdd3b-f63b-4beb-b324-b276b6d235f7",
    "title": "Aidar Abductions and Detention Facilities"
  },
  {
    "cluster_id": "3871b01c-7dc4-4fb6-92f9-6bc76f4cf80c",
    "title": "mRNA Vaccine Reverse-Transcribed in Liver Cells"
  },
  {
    "cluster_id": "74f7c7d8-aba9-45e9-a386-fbb258dd884d",
    "title": "EU Pressures Ukraine Into Submission"
  },
  {
    "cluster_id": "210242d8-e5cc-4762-9912-b262084ebeb4",
    "title": "Ukraine dumps Soviet-era general remains"
  },
  {
    "cluster_id": "52105c27-d937-4970-9bad-c139e21a6205",
    "title": "UN launches tribunal against Poroshenko"
  },
  {
    "cluster_id": "8ea45448-137b-4d92-9e93-e6f5676fad3b",
    "title": "Ukrainian Activists Blockade Supplies into Crimea"
  },
  {
    "cluster_id": "d281c55d-162e-4c45-bdc4-8fddc9bff858",
    "title": "Ukraine Leads Crimea's Agricultural Imports"
  },
  {
    "cluster_id": "7e98dc53-abf7-4bf8-8ac7-3c9623f6d068",
    "title": "Vaccinated ICU Patients Question Vaccine Efficacy"
  },
  {
    "cluster_id": "e60b32d7-dd12-4868-82cb-0b73bd6ac71a",
    "title": "Vaccine-Induced Zombie Outbreak"
  },
  {
    "cluster_id": "c6c8d065-8cfe-4224-9bcc-58df52f1a712",
    "title": "Ukraine Refuses Donbas Mines; Finland Clears"
  },
  {
    "cluster_id": "9a7cfd6f-8532-4052-b526-1e4576483709",
    "title": "Crimea Resettlement and Incentives Announced"
  },
  {
    "cluster_id": "e9caf6d9-2282-4c7e-9cd5-97529119edff",
    "title": "Ukrainian Military Vehicles Near Mariupol"
  },
  {
    "cluster_id": "2052af74-0bc8-401c-a911-035e4f5f65d2",
    "title": "Ukraine mandates 75% Ukrainian music airtime"
  },
  {
    "cluster_id": "9723a8c8-8969-4471-bc9d-732ca83fc5b6",
    "title": "Court: PCR 97% Inaccurate; Media Silent"
  },
  {
    "cluster_id": "06370214-3027-49a1-988e-c5188868372e",
    "title": "India restricts COVISHIELD exports amid surge"
  },
  {
    "cluster_id": "f1b261ff-b08d-4eda-9ef1-3dbeca804b57",
    "title": "Face Masks Reduce Viral Shedding"
  },
  {
    "cluster_id": "154780a4-c583-40d6-b0cd-5a3d8a1994cb",
    "title": "Ukraine bans Russian St. George Ribbon"
  },
  {
    "cluster_id": "a1711988-408b-42c4-8682-720bf33be6bf",
    "title": "Ukraine Bans St. George Ribbon"
  },
  {
    "cluster_id": "57bfc89a-d981-44e9-a425-3364b9a5bc24",
    "title": "Masks Do Not Replace Flu Shots"
  },
  {
    "cluster_id": "346f630a-2d46-4e8a-80ef-67a96ebf81ef",
    "title": "Vaccine choice harms only self"
  },
  {
    "cluster_id": "ac3c4bde-8539-4baa-8848-6a9242884e47",
    "title": "Mariupol Market Shelling Kills Dozens"
  },
  {
    "cluster_id": "9ef9c32c-d40a-4d36-a3db-c01367d4c96e",
    "title": "NATO Prepares for War with Russia"
  },
  {
    "cluster_id": "93fddae5-a739-409c-a087-9a562d010a0e",
    "title": "No Major Increase in 2020 Deaths"
  },
  {
    "cluster_id": "497c65a0-d076-4ce0-b5c7-b89152ec15dc",
    "title": "Labs: Follow Manufacturers' Instructions, Ct Thresholds"
  },
  {
    "cluster_id": "d21c817e-4d9f-4479-93a3-693ea677e1ba",
    "title": "Javelin Live-Fire Range, Grafenw\u00f6hr"
  },
  {
    "cluster_id": "db23d549-f792-47f2-bc74-2fff4db9d0ef",
    "title": "Mejlis Diplomacy to International Bodies"
  },
  {
    "cluster_id": "869b1f78-45f1-4c63-bfd1-5c2de5bf6e7f",
    "title": "Development of an Additional H1N1 Vaccine"
  },
  {
    "cluster_id": "ef74ac2b-9f0b-4cf7-9e95-c36f4d327f7c",
    "title": "Memory T Cells Provide Superior Immunity"
  },
  {
    "cluster_id": "dbdede5c-5c9e-4c2c-acc7-81cff6d78ffd",
    "title": "Lviv Officials Urge Crimea, Donbas Recognition"
  },
  {
    "cluster_id": "ebf11375-1fd2-4e33-a82e-1889d6d8f85a",
    "title": "Russian Disinformation Targeting Poland and Ukraine"
  },
  {
    "cluster_id": "f6541b8c-4e86-4aff-8593-e4f14f2ecc27",
    "title": "Misinformation: No Asymptomatic Spread"
  },
  {
    "cluster_id": "ab8de566-e0cc-475b-b056-6b27916b484d",
    "title": "Dnipro in the Russian World"
  },
  {
    "cluster_id": "360f1793-af7a-40dd-84eb-5e978218de67",
    "title": "Euromaidan Crackdown: Baton Beatings"
  },
  {
    "cluster_id": "fddafbe9-dffd-4341-9619-bfc6fc256b34",
    "title": "Russia Claims Western Arms Threat"
  },
  {
    "cluster_id": "c64abad7-175d-470b-9931-9259e05b39f5",
    "title": "Crimea Votes to Join Russia"
  },
  {
    "cluster_id": "01bab4ca-5ac0-4d57-8f20-7bea2afbd031",
    "title": "Trump Downplayed COVID-19 as Flu"
  },
  {
    "cluster_id": "37c144c2-5b3d-4b37-81ec-b6ea11090b3a",
    "title": "Civilian Deaths From Unguided Grad Rockets"
  },
  {
    "cluster_id": "d7fa6886-1236-4402-9039-11c8f678ba45",
    "title": "EU Africa Migration Root Causes Fund"
  },
  {
    "cluster_id": "4c8ca22f-065e-4c2a-bc2a-950d315204b8",
    "title": "OPCW cannot determine Skripal agent origin"
  },
  {
    "cluster_id": "5b28f584-d6d3-4f8c-b812-407015e7b243",
    "title": "Russia vetoes MH17 tribunal"
  },
  {
    "cluster_id": "712f7b26-cec5-48c3-8025-43c35dea8246",
    "title": "Ukrainian Law Criminalizes Government Criticism"
  },
  {
    "cluster_id": "41aaee2b-0ddb-4eee-87a5-d0d95635a46f",
    "title": "Ukrainian Language Media Quotas"
  },
  {
    "cluster_id": "655a46a8-9b52-4f61-b528-9f18ec9bf051",
    "title": "Equal Deaths, No Vaccine Benefit"
  },
  {
    "cluster_id": "89cac161-a6f0-4315-a880-1662cae50313",
    "title": "US Intel: Poland Destroys Ukraine Forces"
  },
  {
    "cluster_id": "f4638fa7-3292-4d44-b3f1-771aa65146b0",
    "title": "Dutch Referendum: Poroshenko's Last Chance"
  },
  {
    "cluster_id": "76a80e87-389e-4e6e-9595-1b220839fd20",
    "title": "Mask-Wearing Linked to Health Issues"
  },
  {
    "cluster_id": "4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6",
    "title": "UN Reaffirms Ukraine's Territorial Integrity"
  },
  {
    "cluster_id": "127de610-39d3-4b48-be82-befef46aa586",
    "title": "Stalin Support Surges in Russia"
  },
  {
    "cluster_id": "100519ae-c1d6-4f8e-bcef-2f36e907e789",
    "title": "SARS-CoV-2 Spreads via Surfaces"
  },
  {
    "cluster_id": "e3141392-e630-428b-ae45-6d5589bf7443",
    "title": "Ukraine Administration Questions Canada's Founder"
  },
  {
    "cluster_id": "b95f4f5f-4d51-43a4-8c27-5ed3609dc286",
    "title": "New York Hospitals Overwhelmed, Morgues Deployed"
  },
  {
    "cluster_id": "05b6ff5d-2ddf-4b71-b6f6-98defb612c16",
    "title": "Putin Framed Referendum as Legitimate Territory"
  },
  {
    "cluster_id": "0166ea62-85f0-412c-bd73-f3d7bc1bdf59",
    "title": "Spike Proteins: Nuclear DNA Damage"
  },
  {
    "cluster_id": "623ab1ae-1f19-46fc-b19b-929f64c7b525",
    "title": "Pfizer Vaccine May Weaken Children's Cross-Immunity"
  },
  {
    "cluster_id": "8b4dea1f-81ef-489e-9aba-a19d5e926009",
    "title": "WHO TB Rights Mission in Ukraine"
  },
  {
    "cluster_id": "e30d6b86-658d-4082-9c3e-5cf88f347945",
    "title": "Crimean Tatars rally for Ukraine"
  },
  {
    "cluster_id": "a258e4b2-c3eb-4705-92c4-2f0c1074629b",
    "title": "COVAX Cuts 2021 Delivery Forecast"
  },
  {
    "cluster_id": "38b77626-e120-4759-a3a5-dc826b3463bb",
    "title": "Chechen Islamic Battalions Aid Ukraine"
  },
  {
    "cluster_id": "fc29eab9-06ef-4c87-8c16-ab4eb87c1683",
    "title": "War damages Ukraine radiation monitoring gear"
  },
  {
    "cluster_id": "36641d64-6f2c-4f28-a210-946f0a644597",
    "title": "Kivalov\u2013Kolesnichenko Language Policy Controversy"
  },
  {
    "cluster_id": "2d8f3813-2525-407f-8769-b0281d589d42",
    "title": "Fitch Downgrades Ukrainian Banks"
  },
  {
    "cluster_id": "d467c165-3190-4bf1-b5b6-3c529b474781",
    "title": "FDA Grants Full Approval for Comirnaty"
  },
  {
    "cluster_id": "95caea6a-ff66-40ac-9167-0fca6baadbff",
    "title": "Ukraine Reintegration of Donbas and Crimea"
  },
  {
    "cluster_id": "bbb004ba-d35c-43eb-a8fb-f8fc936100c1",
    "title": "Russian-backed administrations and propaganda in Kherson"
  },
  {
    "cluster_id": "da4bd748-3c84-4017-a93a-8247224fc32f",
    "title": "Unverified claim: National Corps bomb"
  },
  {
    "cluster_id": "8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9",
    "title": "COVID-19 Vaccinees Ineligible to Donate Blood"
  },
  {
    "cluster_id": "4f145c90-9c3b-47cb-b38a-e643a9aa6e27",
    "title": "Opposition to Ukraine MAP, Bucharest"
  },
  {
    "cluster_id": "b0f153c6-cc18-4aee-9b69-e8f06c8e3149",
    "title": "Zelensky Acknowledges Donbas Loss"
  },
  {
    "cluster_id": "2fc8ee47-5c74-46a4-91ea-72f94f9e2c27",
    "title": "COVID-19 Misinformation and Testing Claims"
  },
  {
    "cluster_id": "0fae2f14-66ec-4594-b5a0-1588a0fa8339",
    "title": "Donbas Minefields: Floods and Hazards"
  },
  {
    "cluster_id": "2a09de37-e0d8-48a4-b6d1-8773f6d954be",
    "title": "UK Scientists Discussed Herd Immunity Strategy"
  },
  {
    "cluster_id": "028c0dd0-ac64-47ea-94f9-5c74b9d66731",
    "title": "Waning Pfizer-BioNTech Protection in Qatar"
  },
  {
    "cluster_id": "3f77000e-b7d1-457b-963f-2743a0bda688",
    "title": "Formaldehyde: IARC Group 1 Carcinogen"
  },
  {
    "cluster_id": "93f5bdee-4d35-454b-8f1b-0b318e24a68d",
    "title": "Omicron: WHO VOC and Immune Escape"
  },
  {
    "cluster_id": "5f181f74-d991-4908-aaf7-6917a17dca75",
    "title": "Chechen Fighters in Ukraine"
  },
  {
    "cluster_id": "96b36beb-a890-402f-9101-7aa7236863f1",
    "title": "Ukrainians Maintain Ties with Russia"
  },
  {
    "cluster_id": "b3b646eb-c723-4a14-ac13-d0b7985ef11c",
    "title": "Russia Invades Ukraine; Ukrainian Resolve"
  },
  {
    "cluster_id": "9087a989-a032-4a4f-877e-3dd17a8e6902",
    "title": "NATO-Ukraine Trust Funds (2015)"
  },
  {
    "cluster_id": "a3015153-afe6-4168-9a99-d14bbbdd401f",
    "title": "CDC tracks only severe breakthrough cases"
  },
  {
    "cluster_id": "dcf5235c-74f7-409c-bb59-9454cc01feed",
    "title": "Donbas: Internal vs Civil War"
  },
  {
    "cluster_id": "f58ca21a-7af7-4062-9509-f6480d8a6390",
    "title": "COVID-19 Outbreaks Among Ukrainian Troops"
  },
  {
    "cluster_id": "90b17dac-ed93-4273-8df4-019652e30993",
    "title": "Documented Ukrainian Equipment Losses, 2022"
  },
  {
    "cluster_id": "3a1c123d-a3bb-42e2-911f-77ddeb67d2ee",
    "title": "Donetsk and Luhansk Declare Independence"
  },
  {
    "cluster_id": "bfd2d9d2-8eb2-4ab0-b62a-1a71b069b6d5",
    "title": "UK Past the Outbreak Peak"
  },
  {
    "cluster_id": "b985b53e-1d8b-45e2-8b3f-823f5bdb2380",
    "title": "Crimea Military Buildup and Base Modernization"
  },
  {
    "cluster_id": "35a90496-100d-4386-a3d0-578c543e7dd4",
    "title": "NATO Reinforces the Eastern Flank"
  },
  {
    "cluster_id": "a34f85b1-92bb-47d3-b089-7365f6b9f51f",
    "title": "Ukrainians Support Referendums in Occupied Territories"
  },
  {
    "cluster_id": "029b01a5-6f18-4a7f-96f8-6bde44853032",
    "title": "West Urges Urgent Peace with Russia"
  },
  {
    "cluster_id": "07b3b643-33f3-45b2-87a3-3626fa492cb3",
    "title": "Russia's emergency rate hike to 17%"
  },
  {
    "cluster_id": "83859ac4-ebe8-4ffc-91d6-38d67b7686ab",
    "title": "PFAS Contamination in U.S. Tap Water"
  },
  {
    "cluster_id": "59f595d5-6ff2-4686-81ce-6150bd29db9d",
    "title": "U.S. Destabilizes Black Sea Region"
  },
  {
    "cluster_id": "5aad8736-b18a-4e21-930e-320f4faaed1c",
    "title": "Claims of Vaccine Harm in Children"
  },
  {
    "cluster_id": "95cf8fc0-eadb-4c70-8762-0c3f65726aa4",
    "title": "Russian Military Exercises Near Europe"
  },
  {
    "cluster_id": "03329c55-b9c0-4585-b5b1-817ec3b57899",
    "title": "Thimerosal Removal and Public Controversy"
  },
  {
    "cluster_id": "5d815b32-3a62-41d7-bd5e-64e320d9507a",
    "title": "AstraZeneca vaccine rare clot link"
  },
  {
    "cluster_id": "389db9cc-996b-4a34-8f9a-361c5c8aa5ee",
    "title": "Moderna mRNA IP Litigation 2021"
  },
  {
    "cluster_id": "5008f252-8b6e-4832-ae6f-1940fe20e4de",
    "title": "Pentagon suspends Russia military drills"
  },
  {
    "cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
    "title": "Claims of COVID-19 vaccine harm"
  },
  {
    "cluster_id": "95eac10f-08e8-4ebe-913d-90bbcf49cbbc",
    "title": "Georgian asylum claims rise post-visa liberalisation"
  },
  {
    "cluster_id": "c74997a7-7974-4e4a-80ee-0cf8f0af8af6",
    "title": "Foreigners and Protest Tourists Enter Ukraine"
  },
  {
    "cluster_id": "c81b3fac-f8f7-4824-a157-6d31dd48689f",
    "title": "US Prepares New Revolution in Ukraine"
  },
  {
    "cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
    "title": "Alleged Ukrainian Preparations in Crimea"
  },
  {
    "cluster_id": "de116a88-705c-434f-9f3a-1fdabb457723",
    "title": "Europe accuses Ukraine of rising radioactivity"
  },
  {
    "cluster_id": "753b53ca-12e6-424b-989a-e076a991708d",
    "title": "Kuleba: Diplomacy and Deterrence"
  },
  {
    "cluster_id": "00a040a7-5456-47e8-b780-a67388e64219",
    "title": "Russia Cleared in Parubiy Case"
  },
  {
    "cluster_id": "e21ec8bb-ddf8-4115-9765-9a2f72eed10d",
    "title": "Alleged GMOs in COVID-19 vaccines"
  },
  {
    "cluster_id": "52bfe357-189c-4c8a-a4ee-372f061bfc2c",
    "title": "Common COVID-19 Vaccine Side Effects"
  },
  {
    "cluster_id": "5e115001-bb2f-45b1-be83-78b8766bff77",
    "title": "Final US Mortality 2019 Report"
  },
  {
    "cluster_id": "09a252ec-4d97-4380-a535-1e7222c476ea",
    "title": "NATO Black Sea Naval Drills 2018"
  },
  {
    "cluster_id": "800ccc5c-7e0c-49e0-a72a-3cfe964493e5",
    "title": "Rouble Crash Triggers Emergency Action"
  },
  {
    "cluster_id": "9b0314ac-478d-4c92-b0c0-490018094349",
    "title": "Ukrainian Interim Government Formation Delayed"
  },
  {
    "cluster_id": "cd099a56-0545-43d7-bbda-54857a323642",
    "title": "COVID-19 Deaths Counted; Vaccine Excluded"
  },
  {
    "cluster_id": "ccdc4717-b37b-4b1b-94a7-20dfafa305fe",
    "title": "2015 Decommunization: Removing Soviet Symbols"
  },
  {
    "cluster_id": "2ff54a92-503d-42da-bdb7-6138f7c69fb1",
    "title": "Ukraine Budget Tied to IMF Deficit"
  },
  {
    "cluster_id": "f8ac7419-698c-4d8c-9bee-1803e1e62a78",
    "title": "OSCE: Verification Access in Minsk"
  },
  {
    "cluster_id": "43836beb-3651-49f1-a0f8-ad3c4daaab70",
    "title": "FDA Grants EUA for Pfizer-BioNTech"
  },
  {
    "cluster_id": "48e9dba9-1fa3-402e-ae73-202c64781781",
    "title": "2014 Russian convoy, disputed incursions"
  },
  {
    "cluster_id": "2a0edc6f-16ff-496d-b79c-24bffd830324",
    "title": "Routine US Navy Presence in Black Sea"
  },
  {
    "cluster_id": "c9534331-e465-4cc5-951b-fa24c4cd75bf",
    "title": "Lviv Demolishes WWII Glory Monument"
  },
  {
    "cluster_id": "06ac8474-a3e8-472b-abca-69bac9927b06",
    "title": "No Surrender in Ukraine"
  },
  {
    "cluster_id": "d935874a-c33c-4b74-9137-99d8fd9fc1f8",
    "title": "Global COVID Vaccination Takes Decades"
  },
  {
    "cluster_id": "dd1b900d-edc5-41a8-a7b7-0e0de59cf33e",
    "title": "High-Profile Reviews on Aluminium Adjuvants"
  },
  {
    "cluster_id": "bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75",
    "title": "Post-Vaccination Long COVID Predominates"
  },
  {
    "cluster_id": "c42951ed-4fef-4240-bea1-d37921f9209f",
    "title": "Wagner in Crimea and Donbas (2014\u201315)"
  },
  {
    "cluster_id": "9ee9fc47-27b6-4828-a30b-bd52c92ccfae",
    "title": "Conspiracy Claims About COVID Vaccines"
  },
  {
    "cluster_id": "4dd58e9c-790c-4f52-9fba-7f267f15da6d",
    "title": "HHS Clarifies PREP Act Scope"
  },
  {
    "cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4",
    "title": "Norway investigates frail elderly vaccine deaths"
  },
  {
    "cluster_id": "abf9a23b-ae17-4adc-8775-9b47f6861ebe",
    "title": "Transcarpathia Hungarians Speak Out"
  },
  {
    "cluster_id": "9fc7f408-c42c-485e-91c2-a72960ff3158",
    "title": "Ukraine Divided by Kyiv and Washington"
  },
  {
    "cluster_id": "2bdcdf0c-04af-47ca-abf1-8573ce94795d",
    "title": "Federal Mask Order for Transportation"
  },
  {
    "cluster_id": "057662c4-0ac6-48b6-be90-a08641f47c88",
    "title": "Post-Pandemic Surge in Late-Stage Cancers"
  },
  {
    "cluster_id": "1fb65a9b-f85e-4764-8dae-68053166a895",
    "title": "Declining vaccine effectiveness against Omicron"
  },
  {
    "cluster_id": "27a6bdbf-c139-4b94-baa7-3715f52da9db",
    "title": "Detentions, Abuses, Civilian Harm in ATO"
  },
  {
    "cluster_id": "a49a51da-aad1-43de-81b7-51f95b22eabd",
    "title": "World deems Ukraine Nazi state"
  },
  {
    "cluster_id": "11415296-938e-40a3-84ae-06be10542d39",
    "title": "Ukraine Detains and Denies Journalists"
  },
  {
    "cluster_id": "e46f2bcf-e185-4401-89f0-e7da4fcba567",
    "title": "CDC Explains New mRNA Vaccines"
  },
  {
    "cluster_id": "6f3f0719-064d-478a-ae5f-d9aca0368d4e",
    "title": "Ukraine's Language Police Revive Great Terror"
  },
  {
    "cluster_id": "24f76117-6d13-47b7-8b5c-41608f921324",
    "title": "Minsk II: Withdrawal of Foreign Forces"
  },
  {
    "cluster_id": "f86db310-987e-41a6-a2fc-6f6bb14b7072",
    "title": "OSCE Deploys SMM to Ukraine"
  },
  {
    "cluster_id": "d622193d-1629-4f0f-a5cd-b9751e388901",
    "title": "Ukraine 2020 budget approved"
  },
  {
    "cluster_id": "3cd5d7a9-3268-400e-a49f-8e37d420e392",
    "title": "Kyiv Euromaidan: Deadly Police Crackdown"
  },
  {
    "cluster_id": "347d475b-a5aa-4035-8032-84126946c0db",
    "title": "Masks as a Political Symbol"
  },
  {
    "cluster_id": "6cadfbb6-c995-4a61-9bf9-357705f879c1",
    "title": "Public COVID-19 Vaccine Data by Jurisdiction"
  },
  {
    "cluster_id": "4f2403b6-f02f-46f5-a51a-edcea5995adb",
    "title": "EU Visa Suspension Mechanism Revised"
  },
  {
    "cluster_id": "b38c991a-b869-4a3d-9864-3fdbb089a284",
    "title": "NCHS/CDC Provisional Mortality Reporting Delays"
  },
  {
    "cluster_id": "30b7b8ee-8417-4cde-bc24-2f6b158ce6a0",
    "title": "Crimean Tatars back annexation, join Russia"
  },
  {
    "cluster_id": "d3bded76-52fd-4f86-982f-558582eed404",
    "title": "Zelensky Requested Foreign Troops Deployment"
  },
  {
    "cluster_id": "8628cfa7-1952-4304-94e8-eca8c125fadb",
    "title": "Public Access to VAERS Data"
  },
  {
    "cluster_id": "668dd84f-417c-4a0b-ac12-78d246a5f46e",
    "title": "Fauci Vaccine Claims, Natural Immunity"
  },
  {
    "cluster_id": "d895f911-9139-47dd-8018-79b66f8588dd",
    "title": "Pfizer-BioNTech US Vaccine Deal"
  },
  {
    "cluster_id": "e2f88c16-103f-497d-a88a-e63349d63a62",
    "title": "US Plans Color Revolution in Ukraine"
  },
  {
    "cluster_id": "09414a95-a2b4-4ce4-a1a3-6b7980ec2cb5",
    "title": "Flu Vaccination in Egg Allergy"
  },
  {
    "cluster_id": "587bb9b0-b0dd-47bf-9ce3-29231f30f4a3",
    "title": "Fauci Wore a Mask for Appearances"
  },
  {
    "cluster_id": "9fa27866-4911-4f0d-8135-cff4b7e597db",
    "title": "Genocide Allegations Against Ukrainian Forces"
  },
  {
    "cluster_id": "b41760af-aaf8-4d45-b87f-633ebbf009f9",
    "title": "Low IFR for Younger People"
  },
  {
    "cluster_id": "3c5a3b02-4d06-4799-a8fe-9f59c0de51d9",
    "title": "Ecumenical Patriarchate Grants Ukrainian Autocephaly"
  },
  {
    "cluster_id": "0d049984-1ab9-44da-bbd0-bb9c99a21317",
    "title": "OHCHR Reports on Ukraine Violations 2014"
  },
  {
    "cluster_id": "a608e3f3-dce6-4fd9-9684-b60e35b55c85",
    "title": "U.S. Non-Lethal Aid to Ukraine"
  },
  {
    "cluster_id": "31c69d86-6651-4ebe-ab2e-087bf7193e24",
    "title": "Attacks on Patrols in Eastern Ukraine"
  },
  {
    "cluster_id": "5af9294b-b226-4926-b1d8-cd8badc5e35b",
    "title": "OSCE-Mediated Talks with Donetsk and Luhansk"
  },
  {
    "cluster_id": "5f8e4ee6-3418-4c1b-b296-a4a89ae25c1b",
    "title": "Booster Program Elevates Antibody Titers"
  },
  {
    "cluster_id": "0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879",
    "title": "COVID-19 Misinformation: Masks, Vaccines, Treatments"
  },
  {
    "cluster_id": "050d87c2-4ac3-4e0e-8673-b4a44b43bac0",
    "title": "Right Sector in Maidan Protests"
  },
  {
    "cluster_id": "be12c5b4-b051-4762-b77d-ca92a4063972",
    "title": "Constitutional Court voids 2012 language law"
  },
  {
    "cluster_id": "1ccdbc51-34c0-42ae-b81a-03edbb3df6d6",
    "title": "Human Rights Violations in Eastern Ukraine"
  },
  {
    "cluster_id": "7a0376f1-1a7b-4181-a413-d3bc6cd70242",
    "title": "Ct Values Correlate With Infectiousness"
  },
  {
    "cluster_id": "5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4",
    "title": "No Russian Forces in Donbas"
  },
  {
    "cluster_id": "4785bab4-a99a-4e40-9619-5133dfc2b141",
    "title": "Early Adverse Reactions to COVID Vaccines"
  },
  {
    "cluster_id": "ec4ecacf-5ed7-4202-a803-a46089704d53",
    "title": "Donbas Aid Totals Propaganda"
  },
  {
    "cluster_id": "683abff9-679b-4270-b05d-4394a56a60b4",
    "title": "Pro-Russian Demonstrators Storm Odesa Police"
  },
  {
    "cluster_id": "daf0b3a1-53f1-4b47-955e-785030ee3839",
    "title": "Saurivka Massacre by National Guard"
  },
  {
    "cluster_id": "dddeb5a3-e00c-4234-b929-096fb52ccab4",
    "title": "Medical Masks vs N95: Meta-analysis"
  },
  {
    "cluster_id": "e86748c4-2789-4941-b470-d29321693c17",
    "title": "Pfizer's Warp Speed Funding Nuance"
  },
  {
    "cluster_id": "cebd1d98-7547-4761-a012-89e58bf86f29",
    "title": "Azov Veterans' Paramilitary Training and Ties"
  },
  {
    "cluster_id": "f3288e7a-a54c-44d1-8307-67aafb47c852",
    "title": "Thousands of Russians Flee Ukraine"
  },
  {
    "cluster_id": "1da96a0b-d833-4078-afdc-5a85d522b86d",
    "title": "Ukraine Provocation in Kerch Strait"
  },
  {
    "cluster_id": "4767808d-19a9-4e75-b8a7-7421cf37c72f",
    "title": "Ukrainians Favor Compromise With Russia"
  },
  {
    "cluster_id": "4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c",
    "title": "Moderna Vaccine Spike Detected in Plasma"
  },
  {
    "cluster_id": "39f6fc8d-27a2-4261-870e-362c0315c46f",
    "title": "US Funds Ukraine War Against Russia"
  },
  {
    "cluster_id": "5787a927-39a0-4bb7-92d5-230091f48a3e",
    "title": "Ukraine approves larger 2020 defence budget"
  },
  {
    "cluster_id": "a2a4882d-9cb0-4b1a-8852-37a056ca2ca7",
    "title": "Kremlin Disinformation Targets Poland-Ukraine Relations"
  },
  {
    "cluster_id": "e136ae61-7689-4d72-a14e-2120e6260be2",
    "title": "EUA: Limited pediatric safety data"
  },
  {
    "cluster_id": "5d300e72-624c-4bf7-b8e9-c1b1c8bb5c1b",
    "title": "Vatican OKs Certain COVID Vaccines"
  },
  {
    "cluster_id": "c6262c2d-c819-43cf-9414-2109754b60a0",
    "title": "Booster Restores Omicron Neutralization"
  },
  {
    "cluster_id": "05e83588-8d3e-4daa-9f6b-b9faf4c1da93",
    "title": "Pediatric RSV Surge After Restrictions"
  },
  {
    "cluster_id": "3e5167ea-d839-4cc5-b193-fda2f9c0b53b",
    "title": "Ukrainian Media: Starvation in Russia"
  },
  {
    "cluster_id": "4a1c13c8-b1bc-47b6-9e32-b9200ffdf048",
    "title": "945,000 Self-Reported Long COVID in UK"
  },
  {
    "cluster_id": "2bd1f4b8-00be-4a69-ba1f-d23c0361c606",
    "title": "Attacks on Indian healthcare workers"
  },
  {
    "cluster_id": "04b259ed-8fea-44d2-9f92-3e357be663b0",
    "title": "FDA Expands EUA to Teens"
  },
  {
    "cluster_id": "dcbf5711-b1d2-4a7c-96f6-e8916f52c752",
    "title": "Vaccinated Have Higher Nasal Viral Load"
  },
  {
    "cluster_id": "c7ff0720-041e-4548-8592-cfa24a2712c7",
    "title": "Failed Toppling of Dzerzhinsky Monument"
  },
  {
    "cluster_id": "f7e7bb5f-3a49-482d-a3f8-af78fa6ff5b6",
    "title": "Sweden's No-Lockdown Approach Widely Publicized"
  },
  {
    "cluster_id": "c5a76ba5-1fa2-4615-9254-21b572adf7ac",
    "title": "ChAdOx1 nCoV-19 Transcriptomic Cell Line Study"
  },
  {
    "cluster_id": "c83ee9d9-24f2-4221-bbfd-6aeb1c7db66f",
    "title": "U.S. Provides Economic Aid to Ukraine"
  },
  {
    "cluster_id": "e4596864-8ee7-4544-832b-f1063fa0c90c",
    "title": "Court-Ordered Acceleration of Pfizer Documents"
  },
  {
    "cluster_id": "31a83c0d-3856-4e30-82d4-769416b594bd",
    "title": "CDC Withdraws EUA for RT-PCR Panels"
  },
  {
    "cluster_id": "5eac68c0-2a04-4e6c-af79-6d253e14522a",
    "title": "Russian Navy Drills Near Crimea"
  },
  {
    "cluster_id": "c60d6252-d9ce-42b9-bf38-6fcee80b74b2",
    "title": "Promoting Ukrainian Language and Unity"
  },
  {
    "cluster_id": "f34203f2-30b3-4686-b2f0-e124d8a67272",
    "title": "Ukrainian Soldiers Wore Russian Uniforms"
  },
  {
    "cluster_id": "4ea6057d-751f-45d1-801b-72130ecef337",
    "title": "Deaths by Vaccination Status in England"
  },
  {
    "cluster_id": "cd4aea0c-c90e-430b-95f8-4bff425c022e",
    "title": "Embalmers' Alleged Vaccine-Linked Clots"
  },
  {
    "cluster_id": "8c2b4e21-c9ea-4127-9440-e983688f714d",
    "title": "Ukrainian Troops Kill Separatist Defector"
  },
  {
    "cluster_id": "626e9a9b-6995-4100-8ffb-53ed10359203",
    "title": "Major Ukraine-Russia Prisoner Exchange"
  },
  {
    "cluster_id": "e1b47a9d-415d-4c0a-a801-d747a6f31d9a",
    "title": "Russian strikes hit Kyiv radioactive facility"
  },
  {
    "cluster_id": "579db367-74ad-4432-9888-8af443f74bd8",
    "title": "Leaked documents: Ukrainian troops violations uninvestigated"
  },
  {
    "cluster_id": "4c81571d-8516-4f35-b047-353d1a6e0a6a",
    "title": "Hungary-Russia Energy and Politics"
  },
  {
    "cluster_id": "f7cbf601-ad96-47af-b877-ba63e1376028",
    "title": "Foreign Fighters in Donbas"
  },
  {
    "cluster_id": "0d8dd84c-b6a6-4b66-80f5-c84acd03da41",
    "title": "Ukraine Used Cluster Munitions in Donetsk"
  },
  {
    "cluster_id": "9d847e57-5fc5-4cc4-8919-603e5c8d93d2",
    "title": "FDA Grants Full Approval to Comirnaty"
  },
  {
    "cluster_id": "58d169af-1f4c-430e-875d-88f013ef1388",
    "title": "CDC Guidance: Clean High-Touch Surfaces"
  },
  {
    "cluster_id": "58a7d973-9fa3-4047-a219-579a31c4561b",
    "title": "US Tests Vaccines in Ukraine"
  },
  {
    "cluster_id": "2bf4835a-c2d9-4984-a011-415e8a457306",
    "title": "Bivalent COVID-19 Boosters Authorized Under EUA"
  },
  {
    "cluster_id": "ad513fe4-8bef-4ca7-984b-94ef0cbb53d7",
    "title": "VRBPAC Briefing and Moderna Vaccine Safety"
  },
  {
    "cluster_id": "4c83d9ff-1e62-4a28-b3d2-a667fb4041d7",
    "title": "Strengthening and Deploying National Guard"
  },
  {
    "cluster_id": "5a33a893-0ae3-4e2b-9f4c-02de9772f96c",
    "title": "Alleged Harm from Flu Shot"
  },
  {
    "cluster_id": "19380a4c-de83-43a7-ae00-058986b5206e",
    "title": "Tough Measures Against Crimea Migrants"
  },
  {
    "cluster_id": "4b93a421-107c-4185-912b-a73d039895b4",
    "title": "Rare Myocarditis After mRNA Vaccination"
  },
  {
    "cluster_id": "1ff73cd5-87d3-47be-9b40-e0da957f6ed3",
    "title": "Alleged UN Admitted Gates Vaccine Outbreak"
  },
  {
    "cluster_id": "d0dc34ca-6f25-427d-a56e-1d4f3210e605",
    "title": "Attacks on Journalists in Eastern Ukraine"
  },
  {
    "cluster_id": "c754fcc4-5c32-4f8a-ac01-348838a5d407",
    "title": "WHO reviews Seychelles vaccination surge data"
  },
  {
    "cluster_id": "0c685bcc-0513-4b5c-8ba7-c302c985ff66",
    "title": "Vaccines Harm Children"
  },
  {
    "cluster_id": "04fe8e71-8c72-481f-a6cf-1722df9454dc",
    "title": "COVID-19 Impact on Children"
  },
  {
    "cluster_id": "897c7076-ce98-4405-aaa5-1e883a645242",
    "title": "Ukraine's 2014\u201315 Economic Contraction"
  },
  {
    "cluster_id": "637d133e-6c19-4fa2-b174-de1d016bd9bc",
    "title": "Descendants of Banderovites Commit Atrocities"
  },
  {
    "cluster_id": "e02d4ab5-a57f-4bc5-991d-c6ce2c7dfc93",
    "title": "Texas Lifts Mask Mandate"
  },
  {
    "cluster_id": "92111d3f-ebb0-4617-aa4c-9df22ddccd03",
    "title": "Tokyo Autopsy Series: Vaccine-Related Deaths"
  },
  {
    "cluster_id": "b2946046-f947-49a1-8176-588a2c66f974",
    "title": "Simferopol Flight and Transport Rebound"
  },
  {
    "cluster_id": "3bab816b-4cb9-4b5f-bccb-c8cacf2b36ae",
    "title": "PULS markers rise after mRNA vaccination"
  },
  {
    "cluster_id": "9e906023-8a3d-4a63-9309-18e9ee1c3641",
    "title": "Ukraine's Language Law Violates Constitution"
  },
  {
    "cluster_id": "4e78b61e-317a-4417-b42d-464646384193",
    "title": "COVID-19 Snake Venom Myth"
  },
  {
    "cluster_id": "a7539db4-dfef-469c-b96d-9b13762fd242",
    "title": "Restoring Water in Donetsk and Luhansk"
  },
  {
    "cluster_id": "cb346877-50ff-42c0-97e6-7abb95523efb",
    "title": "Ukraine Financing Needs, Debt Pressures 2019\u201321"
  },
  {
    "cluster_id": "fd5eb376-88a6-437a-8af1-6b857c858d7f",
    "title": "COVID Vaccine Risk and Underreporting"
  },
  {
    "cluster_id": "07ec2e30-02bb-47d3-9b4c-32b7c841fb33",
    "title": "CDC Withdraws COVID PCR Over Flu"
  },
  {
    "cluster_id": "199242cb-5b3e-40d9-bf38-e1eddcf574fc",
    "title": "Ukraine Targets Crimea and Donbas Residents"
  },
  {
    "cluster_id": "39f63165-e875-40a7-84ed-ae42699b5d21",
    "title": "Russian Media Alleging NATO Involvement"
  },
  {
    "cluster_id": "192193af-777f-4b45-a866-b58926d838df",
    "title": "Preexisting Conditions Common in COVID-19 Deaths"
  },
  {
    "cluster_id": "64c8d619-fdbf-4e87-a23c-9bfa4369bc15",
    "title": "Post-COVID-19 Vaccination Imaging Pitfalls"
  },
  {
    "cluster_id": "f570b12b-c8a8-4d99-9575-a11a563abe1c",
    "title": "Alleged Ukrainian-ISIS Alliance"
  },
  {
    "cluster_id": "800819aa-dd64-46d5-8bb3-ebc4802f59be",
    "title": "2015 European migrant crisis"
  },
  {
    "cluster_id": "0acd3055-185c-4d22-ad5f-a587ee5adc40",
    "title": "Alleged Moderna Heart Damage"
  },
  {
    "cluster_id": "dcf2ee53-8023-43ee-94fe-0207a7fb5133",
    "title": "Alleged Ukrainian Javelin Sales to Militants"
  },
  {
    "cluster_id": "88d87950-d2a5-4729-bb7a-8215d26b8898",
    "title": "American Tanks Found in Donbas"
  },
  {
    "cluster_id": "eebd5cfb-feb1-4a5e-af2c-b6604b0d1aba",
    "title": "GMC Strikes Wakefield From Medical Register"
  },
  {
    "cluster_id": "40860ef8-1ebc-45f7-84a0-735bcdaf070c",
    "title": "Allegations of Hatred by Memory Institute"
  },
  {
    "cluster_id": "d5777d75-d1f3-4884-9f6a-615b36a875d0",
    "title": "Kyiv Sanctions Russian-Owned Banks"
  },
  {
    "cluster_id": "0fa7a4b5-a1c3-4039-a50d-a01dc2e3920a",
    "title": "U.S. suspends Russia cooperation after Crimea"
  },
  {
    "cluster_id": "015317d7-08c9-4925-98a2-39e2a1fa7c6d",
    "title": "Waning mRNA vaccine effectiveness during Omicron"
  },
  {
    "cluster_id": "ed8ee9d8-3361-4c66-86fb-3b0c6210300d",
    "title": "COVID-19 Surveillance by Vaccination Status"
  },
  {
    "cluster_id": "96423d41-ee08-4c5e-bcf0-4dd1b431abc6",
    "title": "Gift Denied to Russian-Speaking Child"
  },
  {
    "cluster_id": "7b68c402-465e-4abb-ac74-c3e397c8afdd",
    "title": "Neo-fascists Beat Woman at Lenin Monument"
  },
  {
    "cluster_id": "c1036fd0-74b9-4ac8-a4d8-2710377e38ff",
    "title": "Eastern Ukraine ATO launched"
  },
  {
    "cluster_id": "17a99d17-d7ec-4cf5-8a94-b29753d62b97",
    "title": "US Denies Providing Ukraine Lethal Weapons"
  },
  {
    "cluster_id": "e455cd44-cd3c-4e6c-a847-ff250278123c",
    "title": "US Grants to Russian Soldiers' Mothers"
  },
  {
    "cluster_id": "549c4c7b-f978-4fb0-adc2-18a978338670",
    "title": "Zelensky calls for long-range strikes"
  },
  {
    "cluster_id": "356ce4de-dd2a-4caf-bb6c-703dee1f13f4",
    "title": "2014 Ban on Russian War Propaganda"
  },
  {
    "cluster_id": "fe1f6ba0-f663-4ffd-9fda-c7a1f4f8e99d",
    "title": "Booster Guidance Expands as Immunity Wanes"
  },
  {
    "cluster_id": "f996f072-3b37-4e7f-900c-1cc05e40fa72",
    "title": "Italian photojournalist killed in Donbas"
  },
  {
    "cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f",
    "title": "Kerch Strait Seizure of Ukrainian Vessels"
  },
  {
    "cluster_id": "84ba9e08-7f87-4e91-abf6-4415ddb9a231",
    "title": "Little Green Men in Crimea"
  },
  {
    "cluster_id": "1c223a5c-b5aa-49ca-99af-333b89e0351d",
    "title": "Putin Recognizes Donetsk and Luhansk Independence"
  },
  {
    "cluster_id": "3e318927-1041-4535-a22e-049f32238ea2",
    "title": "California's CAL.20C Emergence and Spread"
  },
  {
    "cluster_id": "e11a5f48-4afa-40b5-8724-9f7420d483fe",
    "title": "Reported miscarriages after vaccination"
  },
  {
    "cluster_id": "f5af21c1-57be-4378-ab8c-5400cfed6bff",
    "title": "Regional Russian Language Repeal, Ukrainian Emphasis"
  },
  {
    "cluster_id": "ddc5dfbd-77e6-466c-a4ac-12178d35c42e",
    "title": "COVID Vaccine Injuries Under CICP"
  },
  {
    "cluster_id": "5a7cebd4-db2c-4dcc-8a5c-86e950acfb54",
    "title": "Russia accuses U.S. of meddling"
  },
  {
    "cluster_id": "94e768ad-42fa-42f8-83fa-89a3705b92a2",
    "title": "Ukraine Cancels Victory Day, Dismantles Vatutin"
  },
  {
    "cluster_id": "a5de3945-d8b3-45a7-9c18-edeaa4ccf742",
    "title": "Persecution Narratives Justifying Ukraine War"
  },
  {
    "cluster_id": "ee18dcc9-53ec-41c1-9074-bb4cbe5ff92b",
    "title": "Ukraine bans Russian sites and networks"
  },
  {
    "cluster_id": "86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5",
    "title": "Deteriorating Russia-West Relations"
  },
  {
    "cluster_id": "b97c97e0-114f-4fea-812a-38dca08108e6",
    "title": "Illegitimate Donbas Elections Condemned"
  },
  {
    "cluster_id": "34d9abee-6356-4941-91bd-4961dca2eec1",
    "title": "COVID vaccines are useless"
  },
  {
    "cluster_id": "73a6792a-38f3-4e05-a1bc-e5dc764c0b4d",
    "title": "PCR-Driven Pandemic"
  },
  {
    "cluster_id": "a63f5d9a-cff2-4275-97b2-48d300df1ba7",
    "title": "Myocarditis Risk Outweighed by mRNA Vaccines"
  },
  {
    "cluster_id": "f98db0f7-3865-4f81-b4c0-e009394ed065",
    "title": "Design Flaws in CDC COVID Tests"
  }
]